export const LEVELB_PART1 = {
	"label": "part 1",
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-1-LEVEL-B.mp4",
	"index": 0,
	"description": "Questions and answers about work or other familiar activities: " +
		"1. You answer brief questions about your work or other familiar activities (e.g., studies or volunteer activities, if you are not currently employed) for which short, factual responses are expected. " +
		"2. Duration: 2 to 6 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"index": 0,
					"label": "Question 1",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a3.mp3",
							"audioLabel": "q1-a",
							"script": "Où travaillez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b1.mp3",
							"audioLabel": "q1-b",
							"script": "Dans quel ministère travaillez-vous ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q1-c1.mp3",
							"audioLabel": "q1-c",
							"script": "A quel endroit travaillez-vous ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q1-d1.mp3",
							"audioLabel": "q1-d",
							"script": "Pour quel ministère travaillez-vous ? "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-a2.mp3",
							"audioLabel": "p1-a",
							"script": "Je travaille pour l’Agence de la santé publique, dans le portefeuille de Santé Canada."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-b1.mp3",
							"audioLabel": "p1-b",
							"script": "Je travaille à Environnement Canada."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-c1.mp3",
							"audioLabel": "p1-c",
							"script": "Je travaille à Travaux publics et Services gouvernementaux Canada."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-d1.mp3",
							"audioLabel": "p1-d",
							"script": "Je travaille à Citoyenneté et Immigration Canada. "
						}
					],
					"problematicAnswers": []
				},
				{
					"index": 1,
					"label": "Question 2",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a2.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est votre poste ? "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b.mp3",
							"audioLabel": "q2-b",
							"script": "Quelle est votre profession ? "
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c.mp3",
							"audioLabel": "q2-c",
							"script": "Quel est le titre de votre poste ? "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-e4.mp3",
							"audioLabel": "p1-e",
							"script": "Je suis infirmière et aussi épidémiologiste, donc je travaille pour la division de la préparation pandémique et j’ai utilisé mes compétences pour développer les recommandations pour le vaccin contre la grippe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-f3.mp3",
							"audioLabel": "p1-f",
							"script": "Je suis analyste principale."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-g2.mp3",
							"audioLabel": "p1-g",
							"script": "Je suis agente principale de l’industrie"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-h2.mp3",
							"audioLabel": "p1-h",
							"script": "Je suis gestionnaire des portefeuilles clients."
						}
					],
					"problematicAnswers": []
				},
				{
					"index": 2,
					"label": "Question 3",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a1.mp3",
							"audioLabel": "q3-a",
							"script": "Quelles sont vos tâches principales?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b1.mp3",
							"audioLabel": "q3-b",
							"script": "En quoi consiste votre travail ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c1.mp3",
							"audioLabel": "q3-c",
							"script": "Décrivez-moi brièvement vos tâches principales ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q3-d1.mp3",
							"audioLabel": "q3-d",
							"script": "Quelles sont les tâches principales rattachées à votre poste ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-i2.mp3",
							"audioLabel": "p1-i",
							"script": "En tant qu’analyste principale, je suis responsable de la préparation des notes de breffage, des notes de service et des mémoires de cabinet concernant les changements climatiques.  Je suis responsable de fournir des recommandations et des conseils aux hauts-gestionnaires et au ministre et enfin il faut que je sois bien organisée pour respecter les dates d’échéances."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-j2.mp3",
							"audioLabel": "p1-j",
							"script": "Je rédige les notes de breffage et je donne aussi des conseils à mon directeur général.  De plus, je gère une équipe de trois personnes."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-k3.mp3",
							"audioLabel": "p1-k",
							"script": "Je suis responsable de gérer des projets spéciaux afin de promouvoir les programmes d’efficacité dans le secteur de l’industrie. J’accomplis cette tâche en communiquant avec les intervenants qui sont responsables ou impliqués dans le même projet comme les personnes dans les directions de la communication, de l’informatique et des consultants.  En plus, je gère mon équipe."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-l3.mp3",
							"audioLabel": "p1-l",
							"script": "Mes tâches principales sont la rédaction des protocoles d’entente ainsi que des avis ou des notes de services. De plus, mon travail est de fournir un soutien aux employés du ministère et d’autres ministères"
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-a4.mp3",
								"audioLabel": "wp1-apart 1 e a",
								"script": "Je rédige les notes de breffage"
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-a.mp3",
								"audioLabel": "wp1-apart 1 e a",
								"script": "The plural form is used in the question; you should, therefore, name at least two of your duties"
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-b2.mp3",
								"audioLabel": "wp1-bpart 1 e b",
								"script": "Mon tâche principale sont pour les relations avec les clients qui est les autres directions générales dans mon ministère."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-b.mp3",
								"audioLabel": "wp1-bpart 1 e b",
								"script": "Try to avoid basic mistakes, such as subject-verb agreement and noun-adjective agreement."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-c1.mp3",
								"audioLabel": "wp1-cpart 1 e c",
								"script": "Je gérer mon équipe, je maintenir les serveurs et j’assiste à les réunions."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-c.mp3",
								"audioLabel": "wp1-cpart 1 e c",
								"script": "Verbs should always be conjugated when using a personal pronoun!"
							}
						}
					]
				},
				{
					"index": 3,
					"label": "Question 4",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a1.mp3",
							"audioLabel": "q4-a",
							"script": "Présentez-moi brièvement votre équipe ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b1.mp3",
							"audioLabel": "q4-b",
							"script": "Que font les différents membres de votre équipe ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q4-c1.mp3",
							"audioLabel": "q4-c",
							"script": "Qui sont les personnes qui composent votre équipe ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q4-d.mp3",
							"audioLabel": "q4-d",
							"script": "Combien de personnes travaillent dans votre équipe et à quel poste ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-m1.mp3",
							"audioLabel": "p1-m",
							"script": "J’adore mon équipe!  On est tous jeunes, il y a des gens qui ont leur expérience dans le domaine de l’environnement mais d’autres ont leur expérience dans le domaine des sciences politiques alors on a des points de vue divers, mais tout le monde aime leur travail et travaille très fort et on s’entend bien.  On est seulement cinq personnes alors c’est une petite équipe et on est tout responsable d’élaborer les politiques concernant les changements climatiques."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-n1.mp3",
							"audioLabel": "p1-n",
							"script": "Mon équipe est composée de deux analystes subalternes, de deux chercheurs, d’une gestionnaire et d’une consultante en communication.  Nous sommes très efficaces."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-o1.mp3",
							"audioLabel": "p1-o",
							"script": "Premièrement mon équipe n’est ni trop grande ni trop petite. Il y a environ 30 personnes. Les responsabilités de chaque membre de l’équipe dans la division sont très différentes. Normalement, nous travaillons seuls sur notre projet et nous avons une clientèle unique, nous ne partageons pas les mêmes clients. Par exemple, je suis responsable de région de l’Ontario et mon collègue est responsable de la région du Québec."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-p1.mp3",
							"audioLabel": "p1-p",
							"script": "Il y a trois personnes dans mon équipe.  Il y a deux infirmières et une analyste de politiques.  Les infirmières font des recherches avec les données et les informations sur les vaccins contre la grippe et Il y a trois personnes dans mon équipe.  Il y a deux infirmières et une analyste de politiques.  Les infirmières font des recherches avec les données et les informations sur les vaccins contre la grippe et les analystes de politiques rédigent les notes de breffage et aussi travaillent avec les autres personnes dans la division de pandémie à la préparation contre les pandémies."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-d2.mp3",
								"audioLabel": "wp1-dpart 1 e d",
								"script": "À Parcs Canada, il y a trois sections principales et mon équipe s’occupe de la section des lieux historiques nationaux.  Plus précisément, nous faisons partie de la direction des services historiques et on s’occupe des désignations de la Commission."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-d.mp3",
								"audioLabel": "wp1-dpart 1 e d",
								"script": "The candidate has clearly described the place that his team occupies within the organizational chart; however, he has not answered the question. If you are not sure to have understood the question, please ask the examiner to repeat it."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-e1.mp3",
								"audioLabel": "wp1-epart 1 e e",
								"script": "Il y a trois personnes et directeurs. Il y a trois gestionnaires comme moi et directeurs et chaque gestionnaire a client comme moi mais c’est l’autre direction générale de mon ministère."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-e.mp3",
								"audioLabel": "wp1-epart 1 e e",
								"script": "The answer is not clear. Use connectives and prepositions to ensure your descriptions are as clear as possible."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-f1.mp3",
								"audioLabel": "wp1-fpart 1 e f",
								"script": "Dans mon équipe, ils sont deux analystes subalternes, deux chercheurs, une gestionnaire et une consultante en communication."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-f.mp3",
								"audioLabel": "wp1-fpart 1 e f",
								"script": "Be careful when using certain structures. ”Ils sont” is the wrong construction in this case (candidate is using verb ”to be”:”there are two analysts”). Correct construction is ”il y a”."
							}
						}
					]
				},
				{
					"index": 4,
					"label": "Question 5",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a.mp3",
							"audioLabel": "q5-a",
							"script": "Comment vous rendez-vous au travail le matin?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b1.mp3",
							"audioLabel": "q5-b",
							"script": "Quel trajet empruntez-vous pour aller au travail ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q5-c.mp3",
							"audioLabel": "q5-c",
							"script": "Quel chemin suivez-vous pour vous rendre au travail ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q5-d.mp3",
							"audioLabel": "q5-d",
							"script": "Par où passez-vous pour aller au travail ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-q1.mp3",
							"audioLabel": "p1-q",
							"script": "Pour me rendre au travail je vais à pied jusqu’à la rue Rideau, jusqu’à l’arrêt de l’autobus et je prends la 33 vers Gatineau en traversant le pont Portage.  Et je suis chanceuse parce que l’arrêt de l’autobus est juste devant mon édifice.  Alors ça prend presque 30 minutes je pense."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-r1.mp3",
							"audioLabel": "p1-r",
							"script": "Chaque matin, pour me rendre au travail, je prends l’autobus."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-s1.mp3",
							"audioLabel": "p1-s",
							"script": "D’habitude je prends ma voiture pour aller au travail. Je prends la rue Woodroff, ensuite je tourne à droite et je vais sur l’autoroute 416 et puis je sors à la sortie Rochester, après je tourne à droite sur la rue Preston pour le stationnement."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-t1.mp3",
							"audioLabel": "p1-t",
							"script": "Je vais à pied sur le rue Smythe jusqu’à le arrêt d’OC transpo et je prends l’autobus qui prend le Transitway jusqu’à la rue Colonel By."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-g1.mp3",
								"audioLabel": "wp1-gpart 1 e g",
								"script": "D’habitude, je prends mon voiture pour aller au travail.  Je prends rue Woodroff long, ensuite je tourne droit et aller sur autoroute 416 et puis je sors sortie Rochester, après je tourne droit sur rue Preston pour stationnement."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-g.mp3",
								"audioLabel": "wp1-gpart 1 e g",
								"script": "Describing the route you follow to go somewhere will test your mastery of prepositions, so use every opportunity to practise this in class. Once again, don’t forget to conjugate your verbs. Rule number one!"
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-h1.mp3",
								"audioLabel": "wp1-hpart 1 e h",
								"script": "Je prendre mon auto et je prendre le rue Meadowlands jusqu’à Fisher, je tourne gauche sur Fisher jusqu’à Carling. Quand j’arrive au Carling je tourne droit sur Booth et je tourne gauche sur Booth jusqu’à Gatineau. Et mon édifice est à la droit sur Gatineau, sur rue Laurier et mon édifice est à la droit."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-h.mp3",
								"audioLabel": "wp1-hpart 1 e h",
								"script": "Verbs belonging to the third group are a little more difficult to conjugate, so practise them as much as you can. Also, pay special attention to prepositions. They are used incorrectly by the candidate, which makes the answer confusing."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-i1.mp3",
								"audioLabel": "wp1-ipart 1 e i",
								"script": "J’ai marché dans le rue Smythe et à le qu’est-ce que c’est? à le arrêt pour le OC Transpo et aussi j’ai prends le autobus dans le Transit Way et aussi dans le rue Baseline et puis le autobus tourne au gauche dans le rue Prince of Whales et enfin le autobus tourne à la droite dans le rue Colonel."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-1-e-i.mp3",
								"audioLabel": "wp1-ipart 1 e i",
								"script": "Since this question gets asked fairly often in the Test and can be a little tricky, you should practise it in class until it becomes natural. The candidate’s answer is comprehensible, but it is full of basic mistakes; these should be eliminated."
							}
						}
					]
				}
			],
			"followUpQAs": [],
			"index": 0
		}
	]
};


export const LEVELB_PART2 = {
	"label": "part 2",
	"index": 1,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-2-LEVEL-B.mp4",
	"description": "Listening and speaking in response to short audio recordings: " +
		"1. You listen to two short voice-mail messages (10 to 15 seconds each) and two short work-related conversations (30 to 35 seconds each) twice. " +
		"2. Afterwards, you are asked to identify the reason for the call, what needs to be done or what help is being offered. " +
		"3. Duration: Approximately 7 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a5.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b3.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un court résumé de l’enregistrement?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-a.mp3",
							"audioLabel": "P2-a",
							"script": "Ce message laissé par Marie est à propos de l’absence de M. Lapierre. Il faut informer le reste d’équipe que M. Lapierre sera absent donc elle annule la réunion."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-b.mp3",
							"audioLabel": "P2-b",
							"script": "C’est un message qui dit que la personne qui est le président de la réunion est absent. Donc, la réunion est annulée."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p2-c.mp3",
							"audioLabel": "P2-c",
							"script": "C’est une message de Marie à Thomas, pour l’informer que la réunion est annulée et Marie lui dit d’informer l’équipe."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p2-d.mp3",
							"audioLabel": "P2-d",
							"script": "Marie a appelé pour informer que le réunion pour l’après midi était annulée parce que M. Lapierre était absent. Et elle a demandé que la personne informe le reste de l’équipe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-a.mp3",
								"audioLabel": "wp2-awp2-a",
								"script": "C’est Marie qui appelle l’équipe et informe la réunion après-midi est qu’est-ce que c’est? est hum! est re…j’ai oublié le mot maintenant, la réunion d’après-midi est reportée dans un autre temps, dans un autre moment et le président est absent et l’équipe réussit le autre information. J’ai oublié le sens, le reste j’ai oublié."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-a2.mp3",
								"audioLabel": "wp2-awp2-a",
								"script": "If you can’t remember a word, avoid telling the examiner. It is usually preferable to get around it by using a synonym or by omitting certain details. If the examiner feels is missing, he will ask further questions to find out."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a7.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est le but du message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b1.mp3",
							"audioLabel": "q2-b",
							"script": "Quel est l’objet de l’annonce?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c1.mp3",
							"audioLabel": "q2-c",
							"script": "Quel est la raison du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-b2.mp3",
							"audioLabel": "p2-b",
							"script": "C’est un message qui dit que la personne qui est le président de la réunion est absent. Donc, la réunion est annulée."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-c1.mp3",
							"audioLabel": "p2-c",
							"script": "C’est une message de Marie à Thomas, pour l’informer que la réunion est annulée et Marie lui dit d’informer l’équipe."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p2-d1.mp3",
							"audioLabel": "p2-d",
							"script": "Marie a appelé pour informer que le réunion pour l’après midi était annulée parce que M. Lapierre était absent. Et elle a demandé que la personne informe le reste de l’équipe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-b.mp3",
								"audioLabel": "wp2-bpart 2 e b",
								"script": "Marie appelé son équipe d’informer que le réunion pour l’après midi être annulée parce que M. Lapierre était absent. Et elle demandé pour le personne qui appelé d’informer le reste de l’équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-b.mp3",
								"audioLabel": "wp2-bpart 2 e b",
								"script": "Remember to conjugate your verbs, especially when you use the past tense (“passé compose”). It is sometimes necessary to emphasize the auxiliary verb so that the examiner will know you are using the past tense of the verb and not the infinitive (since they sound alike in some cases)."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a2.mp3",
							"audioLabel": "q3-a",
							"script": "Qu’est-ce qui doit être fait?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b2.mp3",
							"audioLabel": "q3-b",
							"script": "Quelle est la conclusion du message?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c2.mp3",
							"audioLabel": "q3-c",
							"script": "Quelle est la solution du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-a3.mp3",
							"audioLabel": "p2-a",
							"script": "Ce message laissé par Marie est à propos de l’absence de M. Lapierre. Il faut informer le reste d’équipe que M. Lapierre sera absent donc elle annule la réunion."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-c.mp3",
								"audioLabel": "wp2-cpart 2 e c",
								"script": "C’est une message qui dit que le person qui est le president de la réunion est pas present. Donc, le réunion …la réunion est cancellée."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-c.mp3",
								"audioLabel": "wp2-cpart 2 e c",
								"script": "As much as possible, try to pronounce the word the way it is pronounced in French, even if French words are sometimes similar to their English equivalent. Avoid anglicisms such as ”canceller” (correct term is ”annuler”)."
							}
						}
					]
				}
			],
			"followUpQAs": [],
			"index": 0,
			"label": "Message",
			"content": {
				"audio": "/wp-content/uploads/2013/12/message-11.mp3",
				"audioLabel": "Message1",
				"script": "Bonjour Thomas, Marie à l’appareil. Je t’appelle pour t’informer que la réunion hebdomadaire prévue en fin de journée a été annulée car M. Lapierre, qui devait la présider, est absent. Pourrais-tu stp informer le reste de l’équipe afin d’éviter des déplacements inutiles. Merci et à bientôt!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a7.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce message ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b5.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un court résumé de l’enregistrement?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-e.mp3",
							"audioLabel": "p2-e",
							"script": "La raison de ce message est d’informer l’homme qu’il a réussi le première étape du concours pour le poste de directeur général pour la division des communications. Puis la personne veut confirmer sa présence à l’entrevu le 3 mars à 15 h."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-f.mp3",
							"audioLabel": "p2-f",
							"script": "Le but du message est de communiquer que une personne a réussi la première étape d’un concours de dotation et que la personne est qualifiée pour un entrevue."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p2-g.mp3",
							"audioLabel": "p2-g",
							"script": "Une femme a téléphoné M. Dupont pour l’informer que il avait réussi le premier étape d’un concours pour le poste de directeur général et qu’il était invité à une entrevue le 3 mars à 15 h et qu’il devait confirmer sa présence."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p2-h.mp3",
							"audioLabel": "p2-h",
							"script": "Dans ce message, il y a un homme qui a réussi la première étape d’un concours pour le poste de directeur général dans la division des communications et la personne veut une entrevue le 3 mars à 15 h et c’est nécessaire pour l’homme de confirmer sa présence."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-e.mp3",
								"audioLabel": "wp2-epart 2 e e",
								"script": "Une femme a téléphone M. Dupont de lui informer que il est réussir le premier étape dans un concours pour le poste de directeur général et il a invité d’une entrevue le 3 mars à 15 heures et il doit confirmer son présence."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-e.mp3",
								"audioLabel": "wp2-epart 2 e e",
								"script": "You don’t have to use indirect discourse (using the past tense) in the second part of the TOP. You can if you are very comfortable with this form of speech. Otherwise, avoid doing so to ensure you don’t use it incorrectly."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a5.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est le but du message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b3.mp3",
							"audioLabel": "q2-b",
							"script": "Quel est l’objet de l’annonce?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c3.mp3",
							"audioLabel": "q2-c",
							"script": "Quel est la raison du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-e1.mp3",
							"audioLabel": "p2-e",
							"script": "La raison de ce message est d’informer l’homme qu’il a réussi le première étape du concours pour le poste de directeur général pour la division des communications. Puis la personne veut confirmer sa présence à l’entrevu le 3 mars à 15 h."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-f1.mp3",
							"audioLabel": "p2-f",
							"script": "Le but du message est de communiquer que une personne a réussi la première étape d’un concours de dotation et que la personne est qualifiée pour un entrevue."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p2-h1.mp3",
							"audioLabel": "p2-h",
							"script": "Dans ce message, il y a un homme qui a réussi la première étape d’un concours pour le poste de directeur général dans la division des communications et la personne veut une entrevue le 3 mars à 15 h et c’est nécessaire pour l’homme de confirmer sa présence"
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-d.mp3",
								"audioLabel": "wp2-dpart 2 e d",
								"script": "La raison pour ce message est d’informer l’homme qu’il a réussi le première étape du concours pour le position de directeur général pour la division des communications. Puis elle voulait confirmer son présence dans son entrevue le 3 mai à 2 heures."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-d.mp3",
								"audioLabel": "wp2-dpart 2 e d",
								"script": "It is not necessary to make a note of every detail, such as the date, time and phone number that are mentioned in the recordings, since they are generally not important. If you still choose to mention them, make sure they are accurate to avoid making mistakes."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-f1.mp3",
								"audioLabel": "wp2-fpart 2 e f",
								"script": "Le but de le message est communiquer une personne est réussie dans un concours euh… dotation et le personne a euh… qualifiée pour un entrevue, un certaine place euh… pour une certaine date."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-f.mp3",
								"audioLabel": "wp2-fpart 2 e f",
								"script": "Pay particular attention to prepositions and relative pronouns. Without them, the sentence becomes much less clear and it is almost impossible to follow the conversation."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a5.mp3",
							"audioLabel": "q3-a",
							"script": "Qu’est-ce qui doit être fait?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b4.mp3",
							"audioLabel": "q3-b",
							"script": "Quelle est la conclusion du message?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c3.mp3",
							"audioLabel": "q3-c",
							"script": "Quelle est la solution du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-g1.mp3",
							"audioLabel": "p2-g",
							"script": "Une femme a téléphoné M. Dupont pour l’informer que il avait réussi le premier étape d’un concours pour le poste de directeur général et qu’il était invité à une entrevue le 3 mars à 15 h et qu’il devait confirmer sa présence."
						}
					],
					"problematicAnswers": []
				}
			],
			"followUpQAs": [],
			"index": 1,
			"label": "Message 2",
			"content": {
				"audio": "/wp-content/uploads/2013/12/message-2.mp3",
				"audioLabel": "message 2",
				"script": "Bonjour M. Dupont, j’ai le plaisir de vous annoncer que vous avez réussi avec succès la première étape de notre concours pour le poste de directeur-adjoint à la division des communications. Par conséquent, vous êtes convoqué à une entrevue qui aura lieu dans nos locaux le jeudi 3 mars à 15 heures. Pourriez-vous m’appeler au 613-444-1919 pour confirmer votre présence. Merci et à bientôt!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a3.mp3",
							"audioLabel": "q4-a",
							"script": "Pourriez-vous résumer ce dialogue?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b3.mp3",
							"audioLabel": "q4-b",
							"script": "Faites un court résumé de l’enregistrement?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-1-a1.mp3",
							"audioLabel": "m d 1 a",
							"script": "C’est une conversation entre M. Martin et Rose. Il veut connaître la raison de ses retards le matin. Elle lui explique donc qu’elle a des problèmes personnels. M. Martin suggère à Rose terminer plus tard le soir."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-1-b1.mp3",
							"audioLabel": "m d 1 b",
							"script": "M. Martin rencontre Rose pour savoir pourquoi elle est en retard le matin. Rose explique que sa mère est hospitalisée et qu’elle doit s’occuper de son père. Il lui propose une solution."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-c.mp3",
								"audioLabel": "m d 1 cpart 2 e g",
								"script": "Premièrement, M. Martin a eu des problèmes avec Rose parce qu’elle arrivait plus tard chaque matin. Rose a explique qu’elle s’a occupé sa mère qui était dans l’hôpital. Après d’avoir écouter l’explication il a suggéré qu’elle resté chez elle pour s’occuper sa mère."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-g.mp3",
								"audioLabel": "m d 1 cpart 2 e g",
								"script": "You don’t have to use indirect discourse (using the past tense) in the second part of the TOP. You can if you are very comfortable with this form of speech. Otherwise, avoid doing so to ensure you don’t use it incorrectly."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-d.mp3",
								"audioLabel": "m d 1 dpart 2 e h",
								"script": "M. Martin a une problème avec Rose parce que elle est arrivée tard la semaine suivant et elle a dit oui j’ai un problème avec son mari parce que elle s’occupe son mari et M. Martin a dit désolé et dit Rose de travaille 37,5 heures pour le semaine."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-h.mp3",
								"audioLabel": "m d 1 dpart 2 e h",
								"script": "If you have not understood all the details of a recording, it would be better to stick to what you have written down rather than resort to guessing. The examiner will ask you a specific question should he wish to further test your comprehension. Furthermore, the faulty structures in the answer make the message less clear."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a2.mp3",
							"audioLabel": "q5-a",
							"script": "Quelle est le but de la rencontre?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b4.mp3",
							"audioLabel": "q5-b",
							"script": "Quel est l’objet de la conversation?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q5-c2.mp3",
							"audioLabel": "q5-c",
							"script": "Quelle est la raison de l’entretien?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-1-e.mp3",
							"audioLabel": "m d 1 e",
							"script": "M. Martin veut discuter avec Rose de ses retards le matin pour trouver une solution à ce problème."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-1-f.mp3",
							"audioLabel": "m d 1 f ",
							"script": "La raison pour laquelle M. Martin veut rencontrer Rose est qu’il souhaite parler avec elle d’un problème avec son horaire."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-g.mp3",
								"audioLabel": "m d 1 gpart 2 e m",
								"script": "M. Martin veut parler avec Rose de ses problèmes avec sa famille."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-m.mp3",
								"audioLabel": "m d 1 gpart 2 e m",
								"script": "It is important to make a distinction between the aim of this meeting and the underlying reasons causing the problem."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-h.mp3",
								"audioLabel": "m d 1 hpart 2 e n",
								"script": "L’horaire de Rose doit être modifié."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-n.mp3",
								"audioLabel": "m d 1 hpart 2 e n",
								"script": "This affirmation does not correctly respond to the question.The meeting’s aim does not imply the changes that need to be brought, nor the solutions that need to be established."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q6-a1.mp3",
							"audioLabel": "q6-a",
							"script": "Quelle est la conclusion de la discussion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q6-b1.mp3",
							"audioLabel": "q6-b",
							"script": "Quelle est la solution du dialogue?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-1-i1.mp3",
							"audioLabel": "m d 1 i",
							"script": "M. Martin présente à Rose un arrangement. Elle peut commencer plus tard le matin et terminer son travail le soir."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-1-j2.mp3",
							"audioLabel": "m d 1 j",
							"script": "Le patron lui offre de modifier son horaire pour qu’elle commence à 10 heures et termine à 18 heures."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-k.mp3",
								"audioLabel": "m d 1 kpart 2 e o",
								"script": "M. Martin dit qu’il est désolé pour elle. C’est tout."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-o.mp3",
								"audioLabel": "m d 1 kpart 2 e o",
								"script": "Pay attention to the proposed solution.When a problem is generated, a solution always follows.The way to solve a problem is an important element of the oral test. Keep in mind, while taking notes, that the examiner is evaluating you based on your responses regarding the summary, the goal and the solution."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-1-l.mp3",
								"audioLabel": "m d 1 lpart 2 e p",
								"script": "M. Martin dit qu’il n’est pas nécessaire d’arriver dans le matin, mais c’est obligé de rester à le travail pour 8 heures. C’est possible de le travail de le soir et ça c’est une bonne idée que pour elle."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-p.mp3",
								"audioLabel": "m d 1 lpart 2 e p",
								"script": "Make sure you correctly structure your sentences so that they are both correct and comprehensible. Keep your answers simple so that they will be easier to master."
							}
						}
					]
				}
			],
			"followUpQAs": [],
			"index": 2,
			"label": "Conversation ",
			"content": {
				"audio": "/wp-content/uploads/2013/12/mini-dialogue-12.mp3",
				"audioLabel": "mini-dialogue1",
				"script": "-M. Martin : Bonjour Rose, entre! J’aimerais te parler d’un problème que j’ai remarqué concernant tes horaires.\n-Rose : Oui bonjour M. Martin, que se passe-t-il?M.\n-Martin : Eh bien voilà, je me suis rendu compte que depuis une semaine tu arrivais tous les matins à 10 heures au lieu de 9 heures. Aurais-tu un problème?\n-Rose : Eh bien oui, j’ai quelques problèmes personnels en ce moment. Ma mère est hospitalisée et je dois m’occuper de mon père le matin.\n-M. Martin : Ah, je suis désolé pour toi. Si tu veux rentrer plus tard le matin, je peux te proposer de rester jusqu’à 18 heures le soir pour que tu puisses terminer ton travail.\n-Rose : Oui, merci beaucoup! Cela m’arrange bien car ma sœur pourra prendre le relais le soir.\n-M. Martin : Très bien! Tout va bien alors! Bonne journée Rose!\n-Rose : Merci, à vous aussi!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a2.mp3",
							"audioLabel": "q4-a",
							"script": "Pourriez-vous résumer ce dialogue?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b2.mp3",
							"audioLabel": "q4-b",
							"script": "Faites un court résumé de l’enregistrement."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-2-a.mp3",
							"audioLabel": "m d 2 a",
							"script": "Arthur vient voir Mme Bertha pour dire que quelqu’un dans l’équipe est en retard dans son travail. Elle va lui dire de se dépêcher.."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-2-b.mp3",
							"audioLabel": "m d 2 b",
							"script": "C’est une rencontre entre un employé et sa patronne. Il dénonce un collègue qui ne respecte pas les échéances. Elle va lui parler."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-c.mp3",
								"audioLabel": "m d 2 cpart 2 e k",
								"script": "Arthur a parlé avec Mme Bertha parce qu’il voudrait, aurait voulu… attendez, je recommence. Arthur a parlé avec Mme Bertha parce qu’il demandé, parce qu’il a demandé… quoi? Je ne sais pas."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-k2.mp3",
								"audioLabel": "m d 2 cpart 2 e k",
								"script": "Indirect discourse using the past tense is a complex structure that you are not required to use in the second part of the TOP. In order to avoid the mental blocks that may be caused by use of complex structures, adopt the following strategy: initial situation, problem and solution. That way, the examiner will be able to see your actual level of comprehension."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-d.mp3",
								"audioLabel": "m d 2 dpart 2 e l",
								"script": "Il y a une réunion avec deux personnes et l’homme demandé une réunion et le femme écoute. Il y a un problème avec l’homme dit que quelqu’un a un problème de délais. L’homme dit que le problème est un autre homme qu’il travail pas bien et la femme comprend. Elle dit qu’elle va parler avec l’autre homme."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-l2.mp3",
								"audioLabel": "m d 2 dpart 2 e l",
								"script": "This response is very long and lacks structure. It becomes difficult for the examiner to grasp what the candidate is saying. It is always better to make a message clear and simple than complicated and hard to understand."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a4.mp3",
							"audioLabel": "q5-a",
							"script": "Quel est le but de la rencontre?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b5.mp3",
							"audioLabel": "q5-b",
							"script": "Quel est l’objet de la conversation?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q5-c4.mp3",
							"audioLabel": "q5-c",
							"script": "Quelle est la raison de l’entretien?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-2-e.mp3",
							"audioLabel": "m d 2 e",
							"script": "La raison pour laquelle Arthur veut voir Mme Bertha est parce qu’il a un problème avec un collègue et il veut qu’elle s’en occupe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-2-f.mp3",
							"audioLabel": "m d 2 f",
							"script": "Arthur rencontre sa patronne parce qu’il veut lui dire que quelqu’un prend du retard dans le travail de groupe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-g.mp3",
								"audioLabel": "m d 2 gpart 2 e j",
								"script": "Le, la euh… oui, la raison pour LA-quelle Arthur veut enh… voudrait, voulait voir Mme Bertha était parce que un collègue ne travaillons, non ne travaillait pas… Bien. La patroNE va parler… ehh… bientôt à ehh… Arthur."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-j4.mp3",
								"audioLabel": "m d 2 gpart 2 e j",
								"script": "Try to avoid hesitating as much as possible, particularly when it comes to looking for the correct grammar structures. It is better to simplify than to hesitate."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-h.mp3",
								"audioLabel": "m d 2 hmini2-a",
								"script": "Le but de la conversation est pour dire à Jean Lamoureux qu’il va être rencontré cette après-midi pour le remercier."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-a1.mp3",
								"audioLabel": "m d 2 hmini2-a",
								"script": "This statement is false. You must focus on the important information in the dialogue, even if this means leaving out details like numbers and names."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q6-a3.mp3",
							"audioLabel": "q6-a",
							"script": "Quelle est la conclusion de la discussion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q6-b3.mp3",
							"audioLabel": "q6-b",
							"script": "Quelle est la solution du dialogue?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/m-d-2-i.mp3",
							"audioLabel": "m d 2 i",
							"script": "Mme Bertha va avertir Jean Lamoureux cette après-midi qu’il est en retard dans son travail."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/m-d-2-j.mp3",
							"audioLabel": "m d 2 j",
							"script": "La patronne va parler au collègue en retard cette après-midi pour lui dire de se rattraper."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-k.mp3",
								"audioLabel": "m d 2 kpart 2 e k",
								"script": "Elle va lui dire de travailler parce qu’il lui a demandé"
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-2-e-k.mp3",
								"audioLabel": "m d 2 kpart 2 e k",
								"script": "Indirect discourse using the past tense is a complex structure that is not called for in the second part of the TOP. In order to avoid mental blocks that may occur when using complex structures, adopt the following strategy: mentioning initial situation, problem and solution. This way, the examiner will be able to gauge your actual level of comprehension."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/m-d-2-l.mp3",
								"audioLabel": "m d 2 lmini2-b",
								"script": "Arthur vient voir Mme Bertha pour dire que quelqu’un ne fait pas son travail à temps. Elle va lui dire de se dépêcher."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-b1.mp3",
								"audioLabel": "m d 2 lmini2-b",
								"script": "This is a good summary but it is not an accurate response to the question that was asked."
							}
						}
					]
				}
			],
			"followUpQAs": [],
			"index": 3,
			"label": "Conversation 2",
			"content": {
				"audio": "/wp-content/uploads/2013/12/mini-dialogue-2.mp3",
				"audioLabel": "mini-dialogue2",
				"script": "-Arthur: Bonjour Madame Bertha. Puis-je entrer ?\n-Mme Berta:Bien-sur, assied-toi. Qu’est-ce qu’il ya ?\n-Arthur: J’aimerais vous parler d’un sujet délicat.\n-Mme Bertha: D’accord, je t’écoute.\n-Arthur: Vous savez que nous travaillons en groupe sur le dossier Corneille. Nous avons remarqué qu’un de nos collègues, Jean Lamoureux, est très en retard sus sa partie du travail. Nous lui avons transmis nos inquiétudes face aux délais préétablis et lui avons demandé d’être plus coopératif mais il n’est pas très réceptif.\n-Mme Bertha: Oh, je vois, Eh bien, je te remercie d’être venu me voir. Je vais lui en parler cette après-midi pour qu’il rattrape son retard.\n-Arthur: Merci beaucoup et au revoir.Au revoir"
			}
		}
	]
};


export const LEVELB_PART3 = {
	"label": "part 3",
	"index": 2,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/01/B_Part3_real.mp4",
	"description": "Talk with follow-up questions: " +
		"1. The assessor proposes three topics for the talk. " +
		"2. You choose one topic and have a minute and a half to prepare for your talk. " +
		"3. Your talk should last approximately two to three minutes. " +
		"4. After your talk, you will be asked to answer follow-up questions. " +
		"5. Duration: 10 to 12 minutes.",
	"sections": [
		{
			"talkContent": {
				"index": 0,
				"label": "Topic 1 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q16-a.mp3",
						"audioLabel": "q16-a",
						"script": "Quel est pour vous le gestionnaire idéal?"
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q16-b.mp3",
						"audioLabel": "q16-b",
						"script": "Décrivez-moi ce qu’est pour vous un bon gestionnaire."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q16-c.mp3",
						"audioLabel": "q16-c",
						"script": "Selon vous, quelles sont les qualités d’un bon gestionnaire?"
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-a.mp3",
						"audioLabel": "p3-a",
						"script": "À la fonction publique, les gestionnaires ont des rôles très importants. Pour moi, un bon gestionnaire a les qualités suivantes.Premièrement, il doit avoir la capacité de travailler fort parce qu’il doit avoir beaucoup d’énergie pour travailler hors des heures normales.  Ensuite, il doit avoir toutes les compétences de ses fonctionnaires pour leur donner de l’aide, s’ils ont besoin de l’aide.Un bon gestionnaire doit avoir l’habilité de se concentrer pendant longtemps parce qu’il a beaucoup de dossiers à lire.La deuxième grande qualités est qu’il doit être dynamique et avoir un esprit fort pour pousser ses idées et ses dossiers dans le contexte de le gouvernement, dans le contexte des autres gestionnaires, des autres députés, il doit se battre contre les autres gestionnaires et les autres fonctionnaires et il doit pouvoir gagner.Troisièmement, il devrait bien écouter ses subalternes, ses fonctionnaires parce que le meilleur gestionnaire sait ce que se passe dans son équipe et il peut donner de l’aide à ses fonctionnaires, s’ils ont besoin de l’aide et aussi il doit connaître les problèmes et les défis avec leur dossier.\nEn conclusion, un gestionnaire doit avoir beaucoup de qualités très importantes, comme la capacité de travailler, le dynamisme et l’habilité de bien écouter les autres."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-b.mp3",
						"audioLabel": "p3-b",
						"script": "À mon avis, il y a deux types de qualités importantes pour un gestionnaire : les qualités humaines et les qualités professionnelles.  D’un côté, un bon gestionnaire doit avoir la patience et être aimable.  C’est une personne qui est souple, mais qui peut être ferme.  Comme ça, ses employés peuvent l’apprécier comme patron.De l’autre côté, un gestionnaire idéal doit avoir les connaissances, les vraies connaissances du gouvernement pour réussir les projets.  Il doit utiliser la bonne communication, en parlant avec clarté avec tous ses employés et aussi avoir une vision pour l’équipe ou la division.  C’est une personne qui comprend les enjeux du groupe.\nVoilà pour moi les qualités du gestionnaire idéal."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-c1.mp3",
						"audioLabel": "p3-c",
						"script": "Le gestionnaire idéal devrait écouter son personnel pour que ses employés soient heureux.  Il devrait pouvoir travailler en équipe.  Par exemple, il devrait présenter les enjeux qui sont difficiles à l’autre gestionnaire et l’autre division s’il avait besoin d’aide. Ensuite, c’est nécessaire pour un gestionnaire idéal de gérer une équipe avec efficacité, surtout quand l’équipe est très grande comme la mienne.  Pour un gestionnaire dans mon domaine, c’est nécessaire de bien rédiger aussi et de bien négocier avec les parties prenantes comme les compagnies pharmaceutiques, par exemple.\nFinalement, un gestionnaire idéal doit bien travailler avec son équipe et les autres gestionnaires et il doit être fort en gestion et en communication et je suis chanceuse parce que mon gestionnaire est comme ça."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-d1.mp3",
						"audioLabel": "p3-d",
						"script": "Dans mon opinion, un gestionnaire idéal est un gestionnaire qui travaille bien dans une équipe, c’est une personne qui est très positive avec ses collègues, qui communique le but dans sa division et c’est une personne qui est très sympathique pour les autres collègues. C’est nécessaire pour un gestionnaire d’avoir une mandat clair et le soutien de son patron pour travailler bien dans la fonction publique.  C’est nécessaire pour un bon gestionnaire de bien collaborer avec les autres ministères et les partenaires externes au gouvernement.  Par exemple, j’ai un collègue qui est un bon gestionnaire à Santé Canada.  Il est toujours de bonne humeur, il est toujours prêt à soutenir son équipe, il fait preuve de leadership et il apporte aussi une direction claire aux bureaux régionaux.\nC’est un bon exemple parce qu’il possède selon moi, toutes les qualités qui sont désirées chez un gestionnaire à la fonction publique.  Si j’avais toutes ces qualités, je serais un meilleur gestionnaire."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-a1.mp3",
							"audioLabel": "wp3-a",
							"script": "À la fonction publique, les gestionnaires a des rôles très importants. Pour moi, un bon gestionnaire a les qualités suivants.\nPremièrement, il devrait a la capacité de fort travaille, il doit a beaucoup des énergies pour travail dehors des heures de travail, il doit a tous les compétences de ses fonctionnaires pour les donner l’assistance, si il a besoin de l’assistance. Et, il doit a l’habilité de se concentre pour les longs temps parce qu’il aurait beaucoup beaucoup de dossiers de lire.La deuxième grande qualité est il devrait dynamique et avoir un esprit fort pour pousser sa idée et sa dossier dans le contexte de le gouvernement.  Il doit battre avec autres gestionnaires et autres fonctionnaires et il doit gagne.Troisièmement, il devrait bien écouter à ses sous-ordres, à ses fonctionnaires parce que le meilleur gestionnaire sait ce qu’il passe avec son équipe et il peut donner ses fonctionnaires de l’assistance, si ils ont besoin de l’assistance.\nEn conclue, un gestionnaire doit a beaucoup des très importants qualités, comme la capacité pour travail, le dynamisme et l’habilité d’écouter bien à les autres. "
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-a.mp3",
							"audioLabel": "part 3 e a",
							"script": "Occasional minor mistakes are acceptable. The examiner does not expect the candidate to be perfect; it is necessary, however, to avoid making mistakes systematically. Too many basic mistakes make the message harder to understand and demonstrate that basic grammar structures are still not mastered."
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-b1.mp3",
							"audioLabel": "wp3-b",
							"script": "Le gestionnaire idéal pour moi est un gestionnaire avec une attitude de laisser-faire, qui est amiable, mais qui est souple, mais qui peut être ferme. Une personne qui comprend les enjeux de le groupe."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-b.mp3",
							"audioLabel": "part 3 e b",
							"script": "The response does not lack substance, but it is much too short. The examiner expects the candidate to speak for three minutes in order to be able to adequately assess his level of proficiency. Use these three minutes wisely and demonstrate the full range of your skills and vocabulary."
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-c1.mp3",
							"audioLabel": "wp3-c",
							"script": "Je voudrais être un gestionnaire idéal et pour ça, je fais certaines choses.  Premièrement, je travaille bien avec mon équipe, je suis très positive avec mes collègues, je donne un but clair à ma division.  Par exemple, je fais des réunions régulières pour connaître le travail de mes employés et leurs défis. Deuxièmement, c’est nécessaire pour moi d’avoir un mandat clair et le soutien de mon patron pour bien travailler dans la fonction publique.  C’est nécessaire pour moi de bien collaborer avec les autres ministères et les partenaires externes au gouvernement si je veux être un bon gestionnaure.J’ai un collègue qui est un modèle pour moi.  Il est un bon gestionnaire à Santé Canada parce qu’il est toujours de bonne humeur, il soutient son équipe, il fait preuve de leadership pour son équipe et aussi pour les bureaux régionaux.  Il est un excellent exemple pour moi.\nJe pense que si j’étais comme lui, je serais un gestionnaire idéal à la fonction publique."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-c.mp3",
							"audioLabel": "part 3 e c",
							"script": "This answer is well structured and the grammar is sound. It does not, however, adequately address the question that was asked, which was of a more general nature. The examiner could draw the conclusion that the candidate may not have understood the question. Make sure you have understood the question before answering and stick to the topic."
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a11.mp3",
							"audioLabel": "q1-a",
							"script": "Quelle qualité de votre gestionnaire aimeriez-vous posséder?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b9.mp3",
							"audioLabel": "q1-b",
							"script": "Quel trait de votre gestionnaire voudriez-vous avoir?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q1-c3.mp3",
							"audioLabel": "q1-c",
							"script": "Quelle qualité enviez-vous à votre gestionnaire?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-e1.mp3",
							"audioLabel": "p3-e",
							"script": "J’aimerais posséder la capacité de bien négocier avec les parties prenantes.  Par exemple, à quelques occasions à Santé Canada, il y a eu beaucoup de problèmes parmi les compagnies pharmaceutiques, nous et aussi les autres divisions et il a été nécessaire pour le gestionnaire de bien pouvoir négocier avec tout le monde.  Aussi, j’aimerais posséder la capacité de gérer une grande équipe et de gérer le temps avec plus d’efficacité.."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-f1.mp3",
							"audioLabel": "p3-f",
							"script": "J’aimerais posséder plus de patience et j’aimerais être plus amical aussi, comme mon patron."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-g1.mp3",
							"audioLabel": "p3-g",
							"script": "Ça veut dire quelle qualité il a maintenant que j’apprécie?  Mon patron maintenant a une très forte connaissance des processus du gouvernement fédéral à cause de son expérience aux agences centrales, comme le Conseil privé et le département des finances. Aussi il est très sympathique envers ses employés, d’une manière plus sympathique que moi.  Ce sont les deux qualités que j’aimerais avoir."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-h1.mp3",
							"audioLabel": "p3-h",
							"script": "Ma gestionnaire, ma patronne est très gentille et aussi elle a un bon sens de l’humour et grâce à ça, toutes les personnes dans l’équipe ont une attitude très bonne.  Moi, j’ai un sens de l’humour, mais pas dans mon travail et je pense que ça c’est une qualité que j’aimerais."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-d1.mp3",
								"audioLabel": "wp3-d",
								"script": "J’aime de posséder les qualités de bonne humeur de ma collègue."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-d1.mp3",
								"audioLabel": "part 3 e d",
								"script": "Besides being a little too short, this response contains two grammar mistakes. Since the present conditional was used in the question, it should also be used in the answer. Furthermore, a semi-auxiliary verb such as the verb ”aimer” is not used with a preposition."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-e2.mp3",
								"audioLabel": "wp3-e",
								"script": "Je serais aimé de possécer plus leadership, de être plus patient avec HR et aussi plus efficient dans le faire non prendre de décisions."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-e1.mp3",
								"audioLabel": "part 3 e e",
								"script": "It is clear that his candidate has understood the question and his ideas are interesting. However, the influence of the mother tongue is noticeable in the choice of grammar structures: mistakes and anglicisms. These mistakes should be kept to a minimum."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-f1.mp3",
								"audioLabel": "wp3-f",
								"script": "J’aimerais posséder la qualité de pouvoir bien négocier avec les parties prenantes. Par exemple, il y avait quelques occasions dans Santé Canada, quand il y avait beaucoup de problèmes parmi les compagnies pharmaceutiques et nous et aussi les autres divisions et il était nécessaire pour le gestionnaire pouvait bien négocier avec les compagnies pharmaceutiques."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-f1.mp3",
								"audioLabel": "part 3 e f",
								"script": "Using an example to clearly explain an idea is indeed a good strategy. However, when you take an example from the past, you should pay particular attention to use of verb tenses, more specifically, the ”passé composé” and the ”imparfait”; it is fairly common to substitute one for the other."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a10.mp3",
							"audioLabel": "q2-a",
							"script": "Croyez-vous que le leadership soit une qualité essentielle à un bon gestionnaire?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b6.mp3",
							"audioLabel": "q2-b",
							"script": "Le leadership est-il indispensable pour être un bon gestionnaire?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c6.mp3",
							"audioLabel": "q2-c",
							"script": "Un gestionnaire doit-il nécessairement être un bon leader?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-i1.mp3",
							"audioLabel": "p3-i",
							"script": "Oui, la qualité de chef est très essentielle.  À mon avis c’est  important pour un gestionnaire d’avoir une vision et ça c’est une qualité d’une leader et aussi c’est important pour un gestionnaire de fournir les occasions pour avancer la carrière ou la formation des employés et aussi ça aussi c’est une qualité d’un leader.  Il faut motiver les employés.  Enfin, les qualités de leadership sont très importantes."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-j1.mp3",
							"audioLabel": "p3-j",
							"script": "Sans leadership, c’est difficile de gérer un équipe. C’est impossible de donner une direction à un groupe si il n’y a aucun respect pour le gestionnaire."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-k1.mp3",
							"audioLabel": "p3-k",
							"script": "Oui, mais à des niveaux différents qui dépendent du niveau du gestionnaire. Par exemple, pour les directeurs, le leadership n’est pas si important, mais pour les sous-ministres adjoints le leadership est essentiel."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-l1.mp3",
							"audioLabel": "p3-l",
							"script": "Oui, c’est une qualité qui est nécessaire pour un bon gestionnaire.  Quand un gestionnaire peut mener une grande équipe ou peut mener les enjeux qui sont difficiles, c’est important de prendre cette approche pour effectuer les objectifs des tâches, par exemple et c’est important pour un gestionnaire de mener son équipe pour compléter les documents ou les rapports à temps et pour faire ça, il faut être un bon leader."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-g1.mp3",
								"audioLabel": "wp3-g",
								"script": "Les qualités de leadership essentielles pour un bon gestionnaire sont les qualités d’acceptance pour inclure tous les collègues avec un sens de ouverture et d’acceptance de diversité dans le lieu de travail.  C’est essentiel pour les bons habiletés avec les gestions de finance aussi."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-g1.mp3",
								"audioLabel": "part 3 e g",
								"script": "Pay close attention to the formulation of follow-up questions. In this instance, we are dealing with an opinion question that requires a yes or no answer. The candidate must not describe the qualities attributed to leadership, as in this response."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-h1.mp3",
								"audioLabel": "wp3-h",
								"script": "Sans leadership, c’est difficult de gère un équipe. C’est impossible de donne les directions à un groupe si il est aucun respect pour le gestion."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-h1.mp3",
								"audioLabel": "part 3 e h",
								"script": "The candidate has understood the question and is producing a substantial response. However, the answer contains many anglicisms and basic mistakes which make it difficult to understand."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-i1.mp3",
								"audioLabel": "wp3-i",
								"script": "Ça oui, euh… mais euh… à des niveaux différents euh… qui dépend de la niveau de la gestionnaire. Euh… par exemple euh… pour les directeurs par exemple, le leadership n’est pas si important, mais euh… pour les sous-ministres adjoints par exemple, le leadership est plus important."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-i1.mp3",
								"audioLabel": "part 3 e i",
								"script": "Fluency is an important component of the TOP. Too much hesitancy can affect the clarity of the message and make it very hard for the examiner to understand. It is normal to hesitate at times when you are short of ideas, but you must avoid hesitating systematically; this interrupts the flow of words as well as the expression of ideas."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a9.mp3",
							"audioLabel": "q3-a",
							"script": "Selon vous, que doit faire un bon gestionnaire pour maintenir la motivation de ses employés?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b8.mp3",
							"audioLabel": "q3-b",
							"script": "D’après votre expérience, comment un bon gestionnaire fait-il conserver la motivation de son équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c5.mp3",
							"audioLabel": "q3-c",
							"script": "À votre avis, que fait un bon gestionnaire pour garder son équipe motivée?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-m1.mp3",
							"audioLabel": "p3-m",
							"script": "Ça, c’est une question très complexe.  Selon moi, ça dépend bien sûr du contexte mais en général, je pense que si le gestionnaire a une bonne connaissance des défis et des bénéfices des dossiers sur lesquels les fonctionnaires travaillent, il peut bien communiquer ça et motiver son équipe.  Aussi, il devrait connaître la source de motivation de chaque membre de son équipe pour avoir une approche plus efficace."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-n1.mp3",
							"audioLabel": "p3-n",
							"script": "C’est possible d’améliorer la motivation d’une équipe en organisant les réunions sociales, les événements pour construire un équipe plus forte. Personnellement, deux ou trois fois par année, j’organise un dîner pizza pour mon équipe et ça aide parce que l’équipe est plus contente."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-o1.mp3",
							"audioLabel": "p3-o",
							"script": "À mon avis, c’est très important pour un gestionnaire de motiver ses employés et pour faire ça, c’est important de communiquer la vision, le mandat et les objectifs de la division.  Il est aussi important d’encourager les employés.  Enfin, si les employés atteignent un objectif, c’est important de donner les félicitations pour motiver les employés."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-p1.mp3",
							"audioLabel": "p3-p",
							"script": "Pour la motivation de ses employés, selon moi un bon gestionnaire devrait introduire des projets différents au fil du temps.  Le bon gestionnaire devrait écouter son équipe aussi parce qu’il y a quelques employés qui aiment travailler sur des projets qui sont difficiles et d’autres employés aiment le contraire.  C’est une bonne stratégie d’écouter les employés parce que ça dépend des traits des employés, par exemple, un employé aime le changement de son travail constamment, mais un autre employé aime garder le même type de travail et c’est important pour le gestionnaire de gérer cette situation pour bien motiver ses employés."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-j1.mp3",
								"audioLabel": "wp3-j",
								"script": "De maintenir, encore la question.  (Pause) À mon avis, c’est très important pour un gestionnaire de motiver les employés parce que sans la motivation, les employés ne travaillent pas fort.  C’est la rôle du gestionnaire de motiver son équipe d’après moi."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-j1.mp3",
								"audioLabel": "part 3 e j",
								"script": "You must pay particular attention to the formulation of the question. This is an open-ended question which requires the candidate to explain what a manager must do to keep his employees motivated. It does not require the candidate to say whether he thinks it is up to the manager to motivate employees."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-k1.mp3",
								"audioLabel": "wp3-k",
								"script": "C’est possible de améliore la motivation de son équipe par organiser les réunions sociales, par construire un équipe plus fort.  Peut-être deux ou trois fois par année, j’organisais un dîner de pizza pour mon équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-k2.mp3",
								"audioLabel": "part 3 e k",
								"script": "It is clear that this candidate has understood the question, but his response contains too many mistakes. Constantly making basic mistakes will have a negative impact on the assessment."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-l1.mp3",
								"audioLabel": "wp3-l",
								"script": "Un gestionnaire doit posséder les qualités de stratégie d’avoir les buts de projets dans son division.  Il doit avoir la capabilité pour gérer un projet.  Il doit avoir le capabilité pour travailler avec les gens et pour communiquer bien.  Ensuite, il doit faire les rapports pour rapporter les progrès des projets."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-l1.mp3",
								"audioLabel": "part 3 e l",
								"script": "You must pay special attention to the formulation of the question. This candidate is not adequately addressing the question that has been asked, which indicates insufficient comprehension. Make sure you have understood the question, even if it means asking the examiner to repeat the question or reformulate it."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a7.mp3",
							"audioLabel": "q4-a",
							"script": "Si vous deveniez gestionnaire à la place de votre patron, que changeriez-vous à son style de gestion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b8.mp3",
							"audioLabel": "q4-b",
							"script": "Si vous deviez prendre la place de votre patron, comment géreriez-vous l’équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q4-c3.mp3",
							"audioLabel": "q4-c",
							"script": "Si vous deviez remplacer votre patron, quels changements apporteriez-vous à sa façon de gérer l’équipe?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-q1.mp3",
							"audioLabel": "p3-q",
							"script": "Mon patron est une personne très dynamique et qui travaille très fort et qui est très  amical, mais il y a certaines choses dans sa façon de gérer que je changerais si j’étais à sa place.Premièrement je pense que mon gestionnaire est trop mou vis-à-vis ses employés. Souvent ses employés prennent avantage de sa trop grande souplesse, je pense qu’il devrait être plus ferme.  Deuxièmement, je pense qu’il est souvent indécis. Il hésite à prendre les décisions et cela fait perdre du temps à l’équipe\nEn conclusion, je dirais que même est un bon gestionnaire, je changerais certaines lacunes dans sa gestion."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-r1.mp3",
							"audioLabel": "p3-r",
							"script": "Si j’étais à la place de mon patron, je prendrais plus de temps pour parler avec mes employés avant de prendre une décision.  C’est la première chose, j’ai une bonne patronne, mais elle prend les décisions trop vite et elle pose les autres questions après la décision.  À part ça, elle est une très très bonne personne."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-s1.mp3",
							"audioLabel": "p3-s",
							"script": "J’aime beaucoup ma patronne et à cause de ça, je ne changerais pas beaucoup de choses mais je pense que ce serait nécessaire de parler avec les employés plus fréquemment que maintenant.  Il faudrait aussi qu’elle fournisse les occasions pour la formation et aussi pour avancer la carrière.  Maintenant, ça ce n’est pas une priorité de ma patronne et selon moi, c’est une priorité, de parler avec les employés pour comprendre leurs objectifs de carrière et aussi de formation.  Je pense que ça serait une façon de motiver les employés et de stimuler un environnement d’innovation."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-t1.mp3",
							"audioLabel": "p3-t",
							"script": "Selon moi, je voudrais collaborer plus étroitement avec les autres agences de santé.  Maintenant, je collabore avec les autres agences, mais seulement sur les sujets qui sont très difficiles ou quand il y a beaucoup de défis avec un enjeu, mais je pense que ce serait nécessaire de consulter les autres agences de santé aux États-Unis et en Europe, en général, au sujet de leurs politiques.  Présentement, mon patron collabore parfois avec les autres agences, mais ça dépend de la situation.  Selon moi, cette collaboration devrait être inclue dans notre politique.  Par exemple, il devrait y avoir une réunion chaque mois pour discuter des enjeux en général avec les autres pays pour connaître leurs politiques."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-m1.mp3",
								"audioLabel": "wp3-m",
								"script": "C’est une autre bonne question.Si je devrais gestionnaire en place de mon gestionnaireSi je deviens, si je devenais gestionnaire… Je vais recommencer!\nSi je devenais gestion en place de mon gestionnaire, je changerais seulement une chose. Ça c’est la force avec laquelle il pousse les dossiers, il lutte contre les autres ministère pour obtenir son but politique. Selon moi, c’est la seule chose qui manque dans le style de leadership de mon gestionnaire."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-m1.mp3",
								"audioLabel": "part 3 e m",
								"script": "It is all right to occasionally reformulate a sentence, but you should avoid doing so systematically. The structure of the conditional sentence should be altogether mastered, so do not hesitate to practise it until it is used naturally."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-n1.mp3",
								"audioLabel": "wp3-n",
								"script": "J’aime ma patronne beaucoup et à cause de ça, je ne change pas beaucoup de choses mais je pense c’est nécessaire de parler avec les emplois plus fréquemment et aussi de fournir les occasions pour avancer les formations et aussi la carrière.  Je pense ça c’est une façon de motiver des emplois et aussi stimuler un environnement de d’innovation."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-n1.mp3",
								"audioLabel": "part 3 e n",
								"script": "Pay attention to the way the question is formulated. In this case, we are dealing with a hypothetical question using the present conditional and not with a condition with which the present tense is used. Therefore, the present conditional should be used in the response."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-o1.mp3",
								"audioLabel": "wp3-o",
								"script": "Si je suis en place de mon patron, je devrais prendre plus de temps pour parler avec mes employés avant de prendre les décisions.  C’est la première chose que je change.  J’ai une bon patron, mais elle prend les décisions trop vite et elle demande des autres questions après la décision.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-o1.mp3",
								"audioLabel": "part 3 e o",
								"script": "When it comes to hypothetical questions, you must pay particular attention to the tense and mood of the verbs that are used. This is the key to building a correct response, so practise this construction to your heart’s content with your instructors!"
							}
						}
					]
				}
			],
			"label": "Topic 1",
			"index": 0
		},
		{
			"talkContent": {
				"index": 1,
				"label": "Topic 2 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q17-a2.mp3",
						"audioLabel": "q17-a",
						"script": "Expliquez-moi comment vous restez motivé(e)?"
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q17-b2.mp3",
						"audioLabel": "q17-b",
						"script": "Comment faites-vous pour conserver votre motivation au travail?"
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q17-c3.mp3",
						"audioLabel": "q17-c",
						"script": "Expliquez-moi les moyens que vous utilisez pour garder votre motivation?"
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-u1.mp3",
						"audioLabel": "p3-u",
						"script": "De temps en temps, il devient très difficile de conserver ma motivation au sein de la fonction publique parce qu’il y a beaucoup de défis au travail, mais j’ai développé plusieurs stratégies ou techniques pour conserver ma motivation.\nPremièrement, quand je suis en face d’un problème ou un défi, je garde le perspective impersonnelle, jene me fâche pas contre un autre et j’essaie de régler le problème, au lieu  d’être fâché contre une personne.Deuxièmement, la plupart du temps, j’essaie d’adopter une vue à long terme parce que s’il y a un problème en ce moment, si mon travail est interrompu, je peux penser à l’avenir et les bénéfices à l’avenir à cause de mon travail.Troisièmement, j’essaie d’apprécier ma place dans la hiérarchie et j’imagine le lieu des autres gens dans les autres postes, et je pense que je suis à un bon endroit.\nEn conclusion, j’ai adopté plusieurs stratégies pour garder ma motivation au travail, elles incluent : garder mon équilibre émotionnel et apprécier le travail où je suis. "
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-v1.mp3",
						"audioLabel": "p3-v",
						"script": "Afin de rester motivée au bureau, il y a quelques choses que je fais.Premièrement, je suis les développements dans mon domaine de travail afin de garder ma connaissance et de maintenir mon intérêt dans le travail. Ensuite, je prends les formations professionnelles afin de apprendre de nouvelles choses dans mon domaine de travail, mais aussi afin d’apprendre de nouvelles connaissances en général. Enfin, je parle à mon patron et ma commissaire adjointe des occasions pour avoir des promotions et d’autres opportunités dans mon bureau, peut-être dans les autres directions ou dans ma propre direction aussi.\nEn résumé, voilà toutes les choses que je fais pour rester motivée au bureau."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-w1.mp3",
						"audioLabel": "p3-w",
						"script": "Pour rester motivée, je suis quelques règles.Premièrement, je mange santé et je me repose à une bonne heure.  C’est très important pour l’étude du français, parce que si je suis reposée, c’est possible pour moi de revoir mes notes chaque soirée et d’écouter la radio en français.  Et je parle avec ma belle-sœur francophone de temps en temps parce que je peux pratiquer et en plus, elle m’encourage. Ensuite, si je ne suis pas contente avec mes progrès, je parle avec d’autres personnes qui ont fini le cours et elles me donnent de bons conseils pour garder ma motivation.Et finalement, si il est nécessaire pour moi de choisir un autre moyen, je joue avec mes chats pour changer mes idées alors je peux me reposer.Pour rester motivée au travail, je lis les documents courants pour rester informée, je parle avec mon gestionnaire pour les occasions d’avancement ou les changements de responsabilité et j’assiste à beaucoup de réunions pour échanger avec mes collègues et trouver des solutions.\nC’est tout ce que je fais pour rester motivée au travail et à l’école."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-x.mp3",
						"audioLabel": "p3-x",
						"script": "Pour commencer, je vais expliquer comment je reste motivée au travail.  À mon expérience, il y a plusieurs facteurs qui peuvent contribuer à la motivation positive au travail. La première chose pour moi est de rester toujours intéressée dans mon domaine.  Par exemple, je pourrais réviser la littérature académique ou les nouvelles politiques dans le domaine de la santé publique et les maladies chroniques pour rester au courant des inovations. Deuxièmement, j’essaie de travailler avec des partenaires externes pour identifier les priorités nationales et finalement je peux trouver des solutions avec les collaborateurs dans notre agence pour intégrer des perspectives diverses.  Je trouve que c’est important qu’on crée des occasions pour trouver de nouvelles stratégies et pour développer les programmes novateurs.\nJe conclurais en disant que pour moi, rester motivée au  travail n’est pas un problème parce que je suis une passionnée de mon domaine."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-p.mp3",
							"audioLabel": "wp3-p",
							"script": "Si je veux rester motivée, premièrement, je mange santé, je me repose tôt et si je suis reposée, c’est possible pour moi de revoir mes notes chaque soirée.  J’écoute la radio en français et je parle avec ma belle-sœur francophone de temps en temps.  Si je ne suis pas contente avec mes progrès, je parle avec d’autres personnes qui ont fini le cours et ils me donnent des bons conseils.  Et finalement, si il est nécessaire pour moi de choisir un autre moyen, je joue avec mes chats."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-p.mp3",
							"audioLabel": "part 3 e p",
							"script": "The response does not lack substance, but it is much too short. The examiner gives you the opportunity to speak for three minutes so that you will be able to demonstrate your language skills. You should, therefore, use this time wisely and demonstrate the full range of your skills and vocabulary."
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-q.mp3",
							"audioLabel": "wp3-q",
							"script": "Pour commencer, je vais expliquer comment je rester motivée au travail.  À mon expérience, il y a plusieurs facteurs que pouve contribuer de la motivation positive au travail. La première chose pour moi est de rester toujours intéressée de la sujet dans mon domaine.  Par exemple, je pouve réviser la littérature académiqueou les nouvelles politiques dans le domaine de la santé publique et les maladies chroniques pour être au courant. Deuxièment, je essayer de travaille ensemble avec des partenaires externes pour identifier les priorités nationales et finalement je pouve trouver des solutions avec les collaborateurs dans notre agence pour intégrer des perspectives diverses.  Je trouve que c’est important qu’on fait des occasions pour trouver les nouvelles stratégies et développer les programmes novateurs. Je conlure en disant que pour moi, rester motivée au  travail n’était pas un problème parce que je suis passionnée de mon domaine. "
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-q.mp3",
							"audioLabel": "part 3 e q",
							"script": "Pay particular attention to how you use verbs. They form the basis of language and must be used correctly, i.e., conjugated. Listening to a presentation in which verbs are not conjugated can easily become a painful experience for the examiner."
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-r.mp3",
							"audioLabel": "wp3-r",
							"script": "C’est difficile conserver mon motivation temps en temps.  Le travail est beaucoup de défis, mais je garde une perspective impersonnelle.  Je essaie de me fâcher pas contre les autres et je essaye de régler les problèmes et me fâche pas.  J’utilise aussi le technique du longue terme.  Temps en temps, ils sont problèmes et c’est difficile donc si je penser longue terme, je peux voir les résultats et impacts et c’est bon.  Finalement, je essaye apprécier mon place dans le hiérarchie et je imagine le lieu des autres gens dans les autres travails et je pense je suis à une bonne lieu.  C’est ça."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-r.mp3",
							"audioLabel": "part 3 e r",
							"script": "Besides the way the verbs are used, this response has two flaws. It lacks structure, which makes it difficult to grasp the message. Furthermore, the presentation is a little short and would benefit from greater use of examples to clarify the candidate’s statements, which do not lack substance."
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q6-a5.mp3",
							"audioLabel": "q6-a",
							"script": "Est-ce qu’il y a une tâche pour laquelle il est plus dur de garder votre motivation?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q6-b5.mp3",
							"audioLabel": "q6-b",
							"script": "Quelle est la tâche la moins motivante?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q6-c.mp3",
							"audioLabel": "q6-c",
							"script": "Qu’est-ce que vous aimez le moins faire au travail?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-y.mp3",
							"audioLabel": "p3-y",
							"script": "Oui, si je choisis une tâche qui est un défi pour la motivation, c’est certainement une tâche administrative.  Selon moi, les tâches administratives sont très longues et avec plusieurs étapes dans la bureaucratie et en effet, la hiérarchie de la gouvernement fédéral cause des délais.  Pour cette raison, je trouve que c’est difficile d’avancer à cause de tâches administratives et c’est difficile de rester motivée pour terminer ce type de travail."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-z.mp3",
							"audioLabel": "p3-z",
							"script": "Pas vraiment, mais je trouve que en suivant les développements dans mon domaine de travail j’arrive à rester généralement motivée pour toutes les tâches."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-za.mp3",
							"audioLabel": "p3-za",
							"script": "Oui, quand il est nécessaire pour moi de travailler avec la direction principale de l’information sur une présentation, c’est très difficile pour moi de rester motivée parce que la direction principale d’information est très occupée et c’est difficile pour moi de prendre le temps de respecter les échéances et de finir le travail à temps."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zb.mp3",
							"audioLabel": "p3-zb",
							"script": "Oui, je n’aime pas planifier les réunions avec certaines personnes. Avant, j’avais beaucoup de problèmes avec l’équipe qui s’occupait des contrats dans mon ministère. Je trouvais que cette tâche était trop dure. Encore aujourd’hui, même si j’aime beaucoup participer aux grandes réunions, je n’aime pas faire la planification de ces événements."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-s.mp3",
								"audioLabel": "wp3-s",
								"script": "Pas vraiment, tout est bien."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-s.mp3",
								"audioLabel": "part 3 e s",
								"script": "Even if you do not have much to say on a given topic, try as much as possible to justify your point of view. An extra sentence would indicate active participation in the conversation and make a better impression on the examiner."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-t.mp3",
								"audioLabel": "wp3-t",
								"script": "Oui, quand il est nécessaire pour moi de travaille avec la direction principale de l’information sur une présentation peut-être, c’était très difficile pour moi de garder motivée parce que la direction principale d’information est très chargée et c’était difficile pour moi de prendre le temps de rencontre les dates et finisser le travail en bon temps."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-t.mp3",
								"audioLabel": "part 3 e t",
								"script": "Try to remain consistent in your  use of verb tenses. In this particular case, it is hard to determine whether the candidate is talking about a past situation or a situation that often occurs."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-u.mp3",
								"audioLabel": "wp3-u",
								"script": "Oui, je n’aime pas planifier les réunions parce que au passé j’avais beaucoup de problèmes avec l’équipe des contrats dans mon ministère et je trouvais que cette tâche a été trop dure. J’aimais beaucoup participer aux réunions grandes, mais je n’ai aimé pas planifier les réunions."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-u.mp3",
								"audioLabel": "part 3 e u",
								"script": "Whenever you use an example from the past, make sure that the past tenses, i.e., ”passé composé” and ”imparfait” are used correctly."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q7-a.mp3",
							"audioLabel": "q7-a",
							"script": "Pensez-vous qu’il y ait un lien entre la motivation et la productivité?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q7-b.mp3",
							"audioLabel": "q7-b",
							"script": "Croyez-vous que la motivation et la productivité soient liées?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q7-c.mp3",
							"audioLabel": "q7-c",
							"script": "D’après vous, la motivation induit-elle la productivité?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zc.mp3",
							"audioLabel": "p3-zc",
							"script": "Bien sûr, la littérature dans ce domaine et l’expérience de plusieurs secteurs ont prouvé que il y avait une relation entre la motivation et le rendement ou la productivité, mais peut-être la relation est différente dans le contexte de la fonction publique.  Par exemple, si une équipe n’a pas de bonnes relations sociales ou informelles ou si elle a des problèmes de motivation à cause des tâches réguliers c’est normal qu’il y ait un problème pour la productivité.  Mais d’un autre côté, la motivation n’est pas la seule facteur qui peut déterminer la productivité.  Il y a plusieurs facteurs comme la charge de travail, les horaires de travail et ainsi de suite."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zd.mp3",
							"audioLabel": "p3-zd",
							"script": "Oui, je pense que les deux sont très proches.  Si on n’a pas de motivation, c’est difficile de travailler plus fort au bureau ou d’essayer de faire du mieux qu’on peut."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-ze.mp3",
							"audioLabel": "p3-ze",
							"script": "Ah oui, je pense qu’il y a un lien entre motivation et la productivité.  Si on n’est pas motivé, c’est très difficile de finir quelque travail à temps et c’est comme une cercle et après le temps on peut devenir stressé."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zf.mp3",
							"audioLabel": "p3-zf",
							"script": "Oui, je pense qu’il y a un lien entre la motivation et la productivité.Par exemple, si il y a un projet qui est difficile, il y a beaucoup de défis à relever. Il faut donc se motiver pour arriver à un bon résultat. Souvent, les employés ont l’occasion de travailler avec d’autres partenaires qui travaillent dans les autres ministères. Le projet est plus compliqué parce qu’il faut faire beaucoup de réunions, mais ils sont très motivés par le travail en équipe. De l’autre côté, si on n’a pas la motivation, c’est difficile de finir le projet et c’est difficile d’être productif. Donc… si on est motivé, je pense que c’est plus facile de compléter les tâches dans le délai."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-v.mp3",
								"audioLabel": "wp3-v",
								"script": "À mon opinion, il faut qu’on motive les employés pour qu’ils soient plus productifs.  Et c’est ça je fais parce que je suis gestionnaire.  Je motive mes employés et je pense c’est important donc je passe beaucoup de temps sur ça.  C’est mon opinion."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-v.mp3",
								"audioLabel": "part 3 e v",
								"script": "Listen carefully to the questions that are being asked to fully understand the way they are formulated. This is a question that requires a yes or no answer, so the candidate should have started his response by using ”yes” or ”no”. Furthermore, he is not adequately addressing the matter, which could indicate insufficient comprehension."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-w.mp3",
								"audioLabel": "wp3-w",
								"script": "Oui, je pense les deux sont très proches.  Si on n’avait la motivation, c’est difficile de travailler plus fort au bureau ou d’essayer de faire le meilleure qu’on peut."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-w.mp3",
								"audioLabel": "part 3 e w",
								"script": "In this response, the candidate is resorting to a hypothesis in order to support his opinion, which is a wise strategy. However, the sentence is not correctly constructed; be sure that you master complex structures before using them in the Test."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-x1.mp3",
								"audioLabel": "wp3-x",
								"script": "À mon avis, je pense qu’il y a un lien entre la motivation et la productivité. Par exemple, si il y a un projet qui très difficile, il y a beaucoup de défis et aussi il y a beaucoup des occasions de travailler avec l’autre partenaire au Canada ou peut-être dans autres ministères et si tu as beaucoup de motivation avec ce projet, je pense que c’est plus facile de compléter le projet dans le temps nécessaire et aussi de produire le résultat, mais tu as le motivation pour le résultat. Donc, tu veux être productif avec un projet."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-x.mp3",
								"audioLabel": "part 3 e x",
								"script": "This response is poorly constructed, which makes it hard to understand.  To avoid this, try to stick to a main theme in your answer. You could write down the key words in the question and glance at the list while you are building your response. This approach would be more likely to produce a structured answer."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q8-a.mp3",
							"audioLabel": "q8-a",
							"script": "Que pensez-vous des activités sociales pour garder la motivation d’une équipe?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q8-b.mp3",
							"audioLabel": "q8-b",
							"script": "D’après vous, comment les activités sociales peuvent-elles contribuer à maintenir la motivation d’une équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q8-c.mp3",
							"audioLabel": "q8-c",
							"script": "Quelle est votre opinion sur la préservation de la motivation d’une équipe au moyen d’activités sociales?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zg.mp3",
							"audioLabel": "p3-zg",
							"script": "Tout d’abord, c’est important pour moi de garder ma vie privée. J’aime maintenir une division entre ma vie personnelle et ma vie de travail. Mais aussi, de temps en temps j’aime participer aux activités sociales avec mon équipe. C’est une bonne idée d’avoir des rencontres à l’extérieur du travail et c’est bien d’oublier le travail pour conserver une bonne esprit d’équipe. Parfois, je trouve que c’est utile de prendre une pause, de faire quelques activités, de prendre une bière… mais peut-être seulement deux ou trois fois par année. Je pense que nous sommes vraiment occupés au bureau et que le travail prend beaucoup de place dans notre vie. Alors, il faut éviter les activités sociales à chaque semaine ou à chaque mois pour conserver notre motivation."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zh.mp3",
							"audioLabel": "p3-zh",
							"script": "Personnellement, je n’aime pas les activités sociales au travail.  C’est un peu difficile de répondre oui ou non à cette question parce que je n’aime pas ces activités."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zi.mp3",
							"audioLabel": "p3-zi",
							"script": "À mon avis, les activités sociales sont un facteur qui contribue à la motivation au travail, mais c’est nécessaire qu’on trouve un équillibre entre les activités sociales et les tâches de travail.  Si quelques employés dépensaient beaucoup de temps sur les activités sociales, ça pourrait donner des problèmes pour respecter les échéances ou les exigences de leur rôle.  En somme, je pense que les activités sociales peuvent apporter une atmosphère positive dans le bureau, mais ce n’est pas critique pour le rendement."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zj.mp3",
							"audioLabel": "p3-zj",
							"script": "On peut participer à quelques activités sociales afin de garder la motivation au bureau.  Par exemple, une équipe peut prendre le dîner ensemble ou le déjeuner.  Des activités motivantes pendant la journée peuvent être avantageuses aussi ou quelque chose de plus simple comme prendre une café ou avoir une discussion sont une bonne idée aussi."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-y.mp3",
								"audioLabel": "wp3-y",
								"script": "Oui, j’aime bien les activités sociales.  Souvent, on apprend des nouvelles choses et on a une petit pause.  Notre division a un comité social qui organise quelques événements chaque année.  J’aime beaucoup ça, surtout le tournoi de golf parce que j’aime golf.  Donc les activités sociales sont une excellente idée."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-y.mp3",
								"audioLabel": "part 3 e y",
								"script": "Try as much as possible to stick to the topic. In this instance, the candidate is digressing (he obviously likes the topic, but he is not answering the question). Furthermore, since this is an open-ended question, the candidate should start by expressing an opinion rather than saying ”yes”."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-z.mp3",
								"audioLabel": "wp3-z",
								"script": "Personnellement, je n’aime pas les activités sociales au travail.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z.mp3",
								"audioLabel": "part 3 e z",
								"script": "This candidate is expressing a legitimate opinion, but he should support it. He should explain why he does not like social activities and why they do not contribute to motivating a team. It is always better to participate actively in the conversation by elaborating on what you have said."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-za1.mp3",
								"audioLabel": "wp3-za",
								"script": "Je pense ce serait une bonne idée d’avoir les expériences à l’extérieur du travail parce que nous travaillons très fort ensemble et je pense j’ai une bonne équipe et nous travaillons bien ensemble. Mais de temps en temps, ce serait utile de prendre une pause ensemble, de faire quelques activités, de prendre une bière… je ne suis pas sûre. Mais peut-être deux ou trois fois chaque année, je pense ce serait une bonne idée. Mais pas absolument chaque semaine ou chaque mois parce que nous sommes vraiment occupés et le travail occupe beaucoup de temps dans notre vie."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-a.mp3",
								"audioLabel": "part 3 e z a",
								"script": "Whenever you express your opinion using a verb such as ”penser”, do not forget to add ”que”. It is part and parcel of this construction. This mistake is fairly easy to avoid."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q9-a.mp3",
							"audioLabel": "q9-a",
							"script": "Si vous deviez donner un conseil à un employé démotivé, que lui diriez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q9-b.mp3",
							"audioLabel": "q9-b",
							"script": "Si vous rencontriez un collègue démotivé, quel conseil lui donneriez-vous?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q9-c.mp3",
							"audioLabel": "q9-c",
							"script": "Si un membre de votre équipe était démotivé, comment l’aideriez-vous à regagner sa motivation?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zk.mp3",
							"audioLabel": "p3-zk",
							"script": "Si je devais donner un conseil à un employé démotivé, je lui dirais de réfléchir à plusieurs choses. Premièrement, je lui poserais certaines questions en ce qui concerne ses objectifs de carrière, ses compétences et ses faiblesses au travail. Je lui parlerais aussi des formations disponibles et des possibilités pour son plan de carrière. Et enfin, pour lui donner une nouvelle source de motivation, je lui dirais de rencontrer son patron pour déterminer ses tâches préférées et préparer un plan pour l’avenir à la fonction publique."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zl.mp3",
							"audioLabel": "p3-zl",
							"script": "S’il y avait une personne qui était démotivée, je pourrais commencer avec une pause dans la cafétéria avec un café et utiliser le temps pour écouter la personne.  Si elle avait un problème personnel, je lui conseillerait de trouver l’assistance d’un centre de santé."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zm.mp3",
							"audioLabel": "p3-zm",
							"script": "Si j’avais l’occasion de donner des conseils à un employé pour garder la motivation, je dirais que c’est nécessaire qu’on trouve les points positifs des tâches et qu’on parle ou discute avec le gestionnaire au sujet des nouvelles dossiers ou des occasions de commencer un nouveau projet pour ajouter ou augmenter la diversité pendant les horaires de travail."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zn.mp3",
							"audioLabel": "p3-zn",
							"script": "Je lui dirais de participer aux activités professionnelles au bureau si possible, parce que c’est très importante de rencontrer nos collègues au bureau, d’apprendre le nature du travail des autres et de demander s’il y a des occasions d’avoir des promotions au travail aussi."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zb.mp3",
								"audioLabel": "wp3-zb",
								"script": "Je lui disais de participer dans les activités professionnelles au bureau si possible, parce que c’était très importante de rencontrer nos collègues au bureau, d’apprendre le nature du travail des autres au bureau et de trouver s’il y est des occasions pour faire des promotions au travail aussi."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-b.mp3",
								"audioLabel": "part 3 e z b",
								"script": "Whenever you deal with hypothetical questions, be sure to use the conditional in your response. That is where mistakes are more likely to occur."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zc.mp3",
								"audioLabel": "wp3-zc",
								"script": "Si il y a une personne qui est démotivée, je peux commencer avec une pause dans la cafétéria avec un café et utilise le temps de entendre la personne si la personne a un problème personnel, je le conseille de trouver l’assistance d’un centre de santé."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-c.mp3",
								"audioLabel": "part 3 e z c",
								"script": "Pay close attention to the formulation of the question. The conditional is used in the question, but the candidate responds with a sentence using the present tense. It is preferable to use the same structure that was used in the question in order to demonstrate to the examiner that you have fully grasped the specific structure and purpose of the question."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zd.mp3",
								"audioLabel": "wp3-zd",
								"script": "Si je devais donner un conseil à un employé démotivé, je dirais… je… je poserais certaines questions. Comme « qu’est-ce que tu voudrais avec votre carrière? » et aussi « qu’est-ce que c’est ton compétence? » et aussi « qu’est-ce que c’est vos faiblesses? » et « est-ce qu’il y a une possibilité de formation ou de trouver un autre chemin pour ton carrière? ». Et enfin, je dirais que si il y a des choses dans le travail qui tu aimes beaucoup et tu as beaucoup de motivation pour certaines choses, ça c’est une indication de vos aptitudes. Et peut-être c’est une occasion de discuter avec votre patron pour déterminer l’avenir de ton carrière."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-d.mp3",
								"audioLabel": "part 3 e z d",
								"script": "This candidate is simulating a conversation with a real employee to explain what he would do in this particular case. This is an interesting strategy, but there is a little trap here. The candidate can either use ”tu” or ”vous” in order to address the imaginary employee, but not both, especially within the same sentence."
							}
						}
					]
				}
			],
			"label": "Topic 2",
			"index": 1
		},
		{
			"talkContent": {
				"index": 2,
				"label": "Topic 3 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q18-a.mp3",
						"audioLabel": "q18-a",
						"script": "Racontez-moi un voyage d’affaire."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q18-b.mp3",
						"audioLabel": "q18-b",
						"script": "Parlez-moi d’un voyage que vous avez fait dans le cadre de votre travail."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q18-c.mp3",
						"audioLabel": "q18-c",
						"script": "Parlez-moi d’une fois où vous êtes parti en voyage pour votre travail"
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-zo.mp3",
						"audioLabel": "p3-zo",
						"script": "Il y a trois ans, j’ai fait un voyage d’affaires à Halifax pour un projet spécial.  C’était un projet concernant la qualité de l’eau avec le but de régler les données concernant la qualité de l’eau.  Le voyage d’affaires a duré pour cinq jours et j’ai visité le bureau régional qui était situé à Halifax et on a fait quelques réunions pour régler des problèmes concernant le projet. Alors ce que j’ai aimé de ce voyage c’était que je n’avais jamais eu l’occasion de rencontrer des gens qui travaillaient au bureau régional alors c’était une bonne expérience pour moi de les rencontrer et aussi on a fait de bon travail pour régler les problèmes du projet.  On a eu de bons résultats et le projet a été une réussite et effectivement, on a reçu un prix du greffier du Conseil privé pour ce projet.  Enfin, j’ai eu la chance de visiter la ville de Halifax.  On a soupé dans les restaurants à la ville et il y avait de la musique alors j’ai trouvé c’était une ville très intéressante.\nAlors en conclusion, si j’avais l’occasion de visiter Halifax encore une fois, je la saisirais."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-zp.mp3",
						"audioLabel": "p3-zp",
						"script": "Du 24 au 25 novembre dernier, je suis allée à Toronto pour une conférence au sujet de l’énergie. Notre division était responsable de l’organisation de cette conférence alors c’était très spécial pour nous. Le but de cette conférence était d’aider les personnes qui utilisent ou travaillent dans le secteur industriel. Il y a eu beaucoup d’ateliers et de séances sur l’efficacité de l’énergie et aussi beaucoup de présentateurs et d’experts de tous les domaines industriels.Malheureusement, je n’ai pas pu assister aux ateliers parce que je devais courir partout pour m’occuper ou résoudre les problèmes.  À la fin, la conférence a été un succès parce que la majorité des participants étaient très heureux et nous avons reçu beaucoup de rétroaction positive et j’ai moi-même reçu des félicitations et remerciements pour mes efforts sur la conférence.\nEn conclusion même si j’étais très fatiguée, je me sentais très heureuse et j’étais satisfaite de mes efforts."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-zq.mp3",
						"audioLabel": "p3-zq",
						"script": "En 2006, j’ai voyagé avec ma directrice partout au Canada afin de présenter un nouveau système de commande en ligne pour tous les ministères dans la fonction publique.La première ville où nous sommes allées était Vancouver et nous sommes restées là 4 jours. J’ai beaucoup aimé Vancouver parce que c’est une belle ville et il y a beaucoup de magasins.  De plus, les clients étaient heureux avec le système que nous avons présenté.Après Vancouver, nous sommes allées à Edmonton pendant un jour seulement, et nous avons encore présenté le système. Ma directrice a parlé aux gens qui assistaient à la présentation et j’ai répondu à toutes les questions que les gens nous ont posées.\nEn tout, nous avons voyagé pendant 10 jours et j’ai trouvé que c’était un peu difficile parce que je vis ici à Ottawa et je m’ennuyais de tout, mes amis, ma famille et les évènements sociaux. C’était difficile et ma directrice était très exigeante mais, j’ai aimé les gens que j’ai rencontrés et j’ai appris beaucoup durant le voyage."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-zr.mp3",
						"audioLabel": "p3-zr",
						"script": "J’aimerais vous parler d’un voyage d’affaires que j’ai fait quand j’étais analyste de politiques à Industrie Canada.  J’ai travaillé pour Industrie Canada pendant un an, dans la section qui s’appelle le commerce électronique et pour ce rôle, j’ai voyagé à Boston pour une grande conférence sur le commerce électronique. Ça a été une bonne expérience pour trois raisons.  J’ai eu la chance d’apprendre beaucoup de choses à propos du sujet en général.  Par exemple, j’ai reçu de la formation sur la situation avec la sécurité de l’Internet, aussi il y a eu beaucoup d’ateliers à propos des courriels.  Ces ateliers étaient très pertinents pour moi.  La deuxième raison pour laquelle le voyage était bon pour moi, est que j’ai rencontré beaucoup de personnes qui travaillent dans le domaine.  Par exemple, il y avait beaucoup d’experts connus et j’ai pu faire du réseautage.  Finalement, j’ai eu la chance de visiter Boston et Boston est une très belle ville et j’ai pu également rencontrer un ami qui habitait là-bas alors j’étais heureux de le voir.\nDonc en conclusion, ce voyage était très bien parce que j’ai appris beaucoup de choses et en plus, j’ai eu la chance de visiter Boston."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-ze.mp3",
							"audioLabel": "wp3-ze",
							"script": "J’aimerais vous décrire un voyage que j’ai fait en 2006.  J’ai voyagé avec ma directrice partout au Canada pour présenter un nouveau système de commande pour tous les ministères de la fonction publique.Le voyage a duré 14 jours.  Nous avons commencé dans l’Ouest, à Vancouver, puis nous sommes allées dans les prairies, en Ontario et finalement dans les maritimes.  Nous n’étions pas allées au Québec parce que je n’ai pas parlé français à ce moment-là.  J’ai aimé rencontrer les gens dans les différents parties du Canada et j’ai trouvé qu’il y a eu des différences entre les parties.\nJ’ai trouvé le voyage long parce que j’ai manqué ma famille et mes amis.  Mai j’ai aimé Vancouver parce qu’il y a beaucoup de magasins et de choses à visiter.  Ma directrice était un peu difficile alors ça aussi c’était difficle."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-z-e.mp3",
							"audioLabel": "part 3 e z e",
							"script": "The problem with this presentation is that it does not address the matter at hand. When you choose to give an account of some event, you must relate what actually happened. Of course, you will have to describe the situation in order to make the narrative clear; however, you must focus on how the action unfolded and not on describing the situation (mood, emotions). Furthermore, special attention must be paid to accurate use of the past tenses."
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-zf.mp3",
							"audioLabel": "wp3-zf",
							"script": "Du 24 au 25 novembre dernier, à Toronto, j’ai assisté à une conférence au sujet de l’énergie.  Notre division était responsable de organiser cette conférence.\nC’était ma première fois d’organiser une conférence aussi grande.  J’ai travaillé pendant un mois et demi pour organiser cet événement.  J’ai dû déterminer l’horaire de la conférence et les conférencières.  J’ai demandé aux personnes de ma division pour des suggestions de spécialistes.J’ai formé une comité pour m’aider avec l’organisation de la logistique.  Nous avons eu plusieurs de réunions et j’ai réglé quelques problèmes, mais nous avons réussi.À la fin, il y avait un succès parce que la majorité des participants étaient très heureuse, nous avons reçu beaucoup de remerciements et j’ai moi-même reçu des félicitations pour les efforts sur la conférence.\nEn conclusion même si j’étais très fatiguée, je me sentais très heureuse et j’étais satisfaite de mes efforts."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-z-f.mp3",
							"audioLabel": "part 3 e z f",
							"script": "The candidate has done a good job of structuring the narrative and he makes interesting observations. However, he is not answering the question with sufficient precision; the question has to do with a business trip and not how this trip was organized. It is necessary to stick to the topic so that the examiner does not draw the conclusion that there is a comprehension problem"
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-1.mp3",
							"audioLabel": "wp3-1",
							"script": "J’aimerais vous parler à propos un voyage d’affaires que je fais quand je suis analyste politique à Industrie Canada.  Je travaille pour Industrie Canada pendant un an dans la section s’appelle le commerce électronique et pour ce poste, je voyage à Boston pour la grande conférence sur le commerce électronique. Il y a une bonne expérience pour trois raisons.  J’ai la chance de apprendre beaucoup de choses à propos du sujet en général.  Par exemple, je suis informé à propos de le situation avec la sécurité de l’Internet, aussi il y a beaucoup d’ateliers à propos des courriels.  Cet atelier est très bon pour moi.  La deuxième raison c’est bon est que je rencontre beaucoup de personnes qui travaillent dans le domaine.  Par exemple, il y a beaucoup de personnes qui sont très connues.  Finalement, j’ai la chance de visiter Boston et Boston est très belle et également mon ami habite là-bas alors je rencontre mon ami.\nDonc en conclusion, c’est un voyage très bien parce que j’apprends beaucoup de choses aussi, j’ai la chance de visiter Boston."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/part-3-e-z-g.mp3",
							"audioLabel": "part 3 e z g",
							"script": "When it comes to narratives, the past tenses -”passé composé”, ”imparfait” and ”plus-que-parfait” – must be used most of the time. You have to master these three tenses in order to reach the B level."
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q11-a.mp3",
							"audioLabel": "q11-a",
							"script": "Aimez-vous les voyages d’affaire?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q11-b.mp3",
							"audioLabel": "q11-b",
							"script": "Est-ce que vous aimez partir en voyage pour votre travail?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q11-c.mp3",
							"audioLabel": "q11-c",
							"script": "Faire des voyages d’affaire vous plaît-il?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zs.mp3",
							"audioLabel": "p3-zs",
							"script": "Oui, pour moi ce n’est pas un problème.  Je sais que c’est un peu difficile pour les autres gens, surtout les gens avec les petites familles, mais pour moi je suis assez libre.  Dans mon cas, les voyages d’affaires sont un grand avantage de mon travail.  Je peux voir toutes les régions différentes du Canada et visiter les endroits qui sont spéciaux alors je trouve que c’est une bonne chose.  Alors oui, j’adore les voyages d’affaires."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zt.mp3",
							"audioLabel": "p3-zt",
							"script": "Ça dépend du voyage et ça dépend de la personne qui voyage avec moi. Mais en général oui, j’aime les voyages d’affaires."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zu.mp3",
							"audioLabel": "p3-zu",
							"script": "Oui et non. J’aime les occasions de parler avec les clients parce que c’est une bonne occasion d’échanger les informations et de voir beaucoup de personnes en même temps. Par contre, les voyages d’affaires sont vraiment très fatigants. Il y a beaucoup de travail avant, pendant et après le voyage, mais c’est quand même stimulant."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zv.mp3",
							"audioLabel": "p3-zv",
							"script": "Non, c’est très difficile pour moi d’aimer les voyages parce que je n’aime pas du tout dormir à l’hôtel et attendre à l’aéroport  parce que c’est très stressant.  Je préfère rester dans une place, mais pour un voyage court, ça va si le sujet est intéressant."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-2.mp3",
								"audioLabel": "wp3-2",
								"script": "Ça dépend à le voyage et ça dépend à le personne que voyage avec moi. En général oui, j’aime de faitre les voyages pour travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-h.mp3",
								"audioLabel": "part 3 e z h",
								"script": "Basic mistakes must be avoided. Of course, a few mistakes are not a problem: the examiner does not expect you to be perfect. You must, however, master basic grammar (prepositions, relative pronouns, articles, etc.)."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-3.mp3",
								"audioLabel": "wp3-3",
								"script": "Non, c’est très difficile pour moi à aimer de voyage parce que je n’aime de voyage dans l’hôtel, de être dans l’aéroport c’est très stressant et j’aime beaucoup de rester dans une place, mais pour un voyage court, c’est très ennuyant sauf le sujet c’est intéressant."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-i.mp3",
								"audioLabel": "part 3 e z i",
								"script": "Verbs that are preceded by a preposition require special attention: the infinitive is used. Also, semi-auxiliary verbs such as ”aimer” are not used with a preposition!  "
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-4.mp3",
								"audioLabel": "wp3-4",
								"script": "Oui, j’aime les voyages d’affaires parce que pour moi, ils est l’opportunité de voyager de nouveau pays.  Aussi, je pense c’est très important pour le gouvernement de rencontre l’autre gouvernement."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-j.mp3",
								"audioLabel": "part 3 e z j",
								"script": "Pay close attention to subject-verb agreement. Whenever the subject is plural, every verb  to which it is connected must also be plural. Moreover, an opinion verb such as ”penser” must be followed by ”que”."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q12-a.mp3",
							"audioLabel": "q12-a",
							"script": "Selon vous, les voyages d’affaire sont-ils toujours nécessaires?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q12-b.mp3",
							"audioLabel": "q12-b",
							"script": "D’après vous, est-il toujours obligatoire de voyager pour le travail?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q12-c.mp3",
							"audioLabel": "q12-c",
							"script": "Croyez-vous que les voyages d’affaire soient à chaque fois indispensables?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zw.mp3",
							"audioLabel": "p3-zw",
							"script": "Oui, à mon opinion maintenant, quand vous avez l’approbation pour faire un voyage d’affaires, c’est parce que c’est vraiment nécessaire.  Peut-être qu’auparavant, il y a eu des gens qui ont fait des voyages d’affaires qui n’étaient pas nécessaires, mais maintenant je pense qu’ils sont plus spécifiques.  Il y a beaucoup de règles pour éviter des choses arbitraires.  Parfois, c’est important de travailler directement avec des gens qui sont impliqués avec des problèmes et de travailler très étroitement avec ces gens alors c’est nécessaire de faire des voyages d’affaires."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zx.mp3",
							"audioLabel": "p3-zx",
							"script": "Selon moi, je crois que les voyages d’affaires ne sont pas nécessaires tout le temps parce qu’il y a beaucoup de technologies qui permettent les réunions à l’Internet, aux ordinateurs et d’autres choses comme ça. Et en plus, les voyages d’affaires sont très chers."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zy.mp3",
							"audioLabel": "p3-zy",
							"script": "Normalement, c’est nécessaire pour les réunions internationales. Quand on utilise la téléconférence pour les réunions, ce n’est pas comme une réunion face à face.  Alors, pour une réunion très importante, je pense que c’est nécessaire de partir pour les réunions face à face.  Et pour les questions de négociation, c’est particulièrement important de parler en face à face alors il faut voyager de temps en temps."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zz.mp3",
							"audioLabel": "p3-zz",
							"script": "Je pense que oui et non.  Oui parce que c’est très important de rencontrer les clients dans leur région au Canada ou dans un autre pays.  En même temps non parce que il y a des occasions quand le travail face à face n’est pas nécessaire.  Je pense que parfois, le travail pourrait être fait à l’Internet."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zg2.mp3",
								"audioLabel": "wp3-zg",
								"script": "À mon avis, les voyages d’affaires sont trop chers.  Il faut réduire les coûts parce qu’ils sont un gaspillage pour le gouvernement.  Mon directeur en prend beaucoup et je pense c’est vraiment cher."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-k.mp3",
								"audioLabel": "part 3 e z k",
								"script": "Try to produce a response that specifically addresses the issue at hand. This candidate is not answering the question accurately and this could indicate insufficient comprehension."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zh.mp3",
								"audioLabel": "wp3-zh",
								"script": "Normalement, les voyages d’affaires sont pas essentiels."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-l.mp3",
								"audioLabel": "part 3 e z l",
								"script": "This is a legitimate opinion and addresses the issue. However, in the context of the TOP, it is always preferable to expand on a response. This way, the examiner will be able to accurately assess your language skills based on a wider array of structures used."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zi.mp3",
								"audioLabel": "wp3-zi",
								"script": "D’après moi, je crois les voyages d’affaires est très importantes pour ma développement professionnel.  L’année passée, j’ai été en Vancouver pour quatre jours et je utilise tout quoi j’ai apprendre pendant mon voyage."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-m.mp3",
								"audioLabel": "part 3 e z m",
								"script": "This candidate is straying from the subject; he is not addressing it. Don’t stray from the topic and remember to respond using the same structures as in the question. You will then be in a better position to pass the Test. What’s more, the grammar used in this response is faulty."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q13-a.mp3",
							"audioLabel": "q13-a",
							"script": "D’après vous, comment pourrait-on rendre les voyages d’affaire plus profitables pour les contribuables?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q13-b.mp3",
							"audioLabel": "q13-b",
							"script": "Selon vous, quels moyens utiliseriez-vous pour minimiser les dépenses produites par les voyages d’affaire?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q13-c.mp3",
							"audioLabel": "q13-c",
							"script": "Comment rentabiliseriez-vous les coûts induits par les voyages d’affaire."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zza.mp3",
							"audioLabel": "p3-zza",
							"script": "Je pense qu’il y a deux choses que la fonction publique peut faire.  D’abord, il est très important d’organiser les réunions avant le voyage d’affaires et dans la fonction publique, à mon avis, il n’y a pas le temps nécessaire pour bien préparer les voyages d’affaires.  Donc, pour les réunions, les fonctionnaires ont besoin de temps pour bien se préparer, mais maintenant, je pense que le temps n’existe pas. De plus, je pense que malheureusement, les fonctionnaires dépensent beaucoup d’argent pour voyager.  Je pense aussi qu’il y a beaucoup de façons d’économiser pour le processus.  Par exemple, si on voyage durant certaines saisons ou la fin de semaine, c’est moins cher.  Donc, il existe plusieurs façons de rendre les voyages plus profitables."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zzb.mp3",
							"audioLabel": "p3-zzb",
							"script": "D’après moi les voyages d’affaires peuvent être plus profitables pour les contribuables si l’utilisation du temps est bien planifiée.  Par exemple, si je vais à Victoria pour une réunion, je veux avoir un agenda plein et utile.  Donc pour moi, c’est l’utilisation du temps pour moi et les autres participants qui rend le voyage profitable."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zzc.mp3",
							"audioLabel": "p3-zzc",
							"script": "Je pense qu’afin de rendre les voyages plus profitables, il faut d’abord empêcher le gaspillage d’argent quand on fait des voyages d’affaires.  Pour ça, il faut que le gouvernement ait de bonnes politiques sur le sujet.  Comme maintenant, il y a quelques règles qui établissent le coût de chaque repas quand un fonctionnaire est en voyage d’affaires et il y a une limite d’argent que on peut dépenser quand on est en voyage.  Donc, je pense que maintenant le gouvernement est en train d’empêcher le gaspillage et je n’ai pas d’amélioration à proposer."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zzd.mp3",
							"audioLabel": "p3-zzd",
							"script": "C’est vraiment difficile à dire parce que le Conseil du Trésor a des politiques pour les voyages d’affaires.  Peut-être c’est possible pour le Conseil du Trésor de changer les politiques pour avoir une meilleure justification pour les voyages d’affaires.  Souvent, les voyages ne sont pas nécessaires et ils sont mal planifiés alors on perd beaucoup de temps de travail.  Mais c’est vraiment une question de politique du Conseil du Trésor."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zj.mp3",
								"audioLabel": "wp3-zj",
								"script": "Je sais pas, c’est le responsabilité de l’adjoint-administratif de faire les réservations."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-n.mp3",
								"audioLabel": "part 3 e z n",
								"script": "If you are short of ideas, it is better to say so and request another question rather than not respond. You cannot, however, systematically resort to this strategy."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zk.mp3",
								"audioLabel": "wp3-zk",
								"script": "Oui, je pense que les voyages sont trop chers et qu’il faut qu’on change les règles.  Surtout avec la crise économique, les fonctionnaires voyages trop et ça prend besucoup de budget."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-o.mp3",
								"audioLabel": "part 3 e z o",
								"script": "When we pay close attention to the formulation of the question, we realize that it is an open-ended question. In the response, it would have been necessary to explain how the situation could be improved rather than confirm that a problem existed at the time."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zl.mp3",
								"audioLabel": "wp3-zl",
								"script": "Dans ma division, il y a plusieurs de personnes qui voyagent beaucoup à cause de leur travail et c’est une problème.  Notre budget est utilisé trop avec les voyages alors c’est un problème.  Donc, je pense il faut faire moins voyages pour aider le budget."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-p.mp3",
								"audioLabel": "part 3 e z p",
								"script": "This candidate is basing his response on his own experience to answer the question, which is usually a good idea. Nevertheless, he is not answering the question which requires that he describe solutions rather than explain the problem."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q14-a.mp3",
							"audioLabel": "q14-a",
							"script": "Si vous pouviez choisir votre destination de voyage d’affaire, où iriez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q14-b.mp3",
							"audioLabel": "q14-b",
							"script": "Si vous aviez la possibilité de décider du lieu de votre prochain voyage d’affaire, que choisiriez-vous?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q14-c.mp3",
							"audioLabel": "q14-c",
							"script": "Si on vous donnait l’occasion de sélectionner la destination de votre voyage d’affaire, où préféreriez-vous partir?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zze.mp3",
							"audioLabel": "p3-zze",
							"script": "Si je pouvais choisir un autre voyage d’affaires, je voudrais aller à la ville de Québec.  Je n’ai jamais visité Québec et mes parents l’ont visitée l’année passée.  Ils ont eu une expérience très très bonne et j’ai entendu dire que c’était une très belle ville et je n’ai jamais eu l’occasion de la visiter alors si j’avais le choix, je voudrais aller à Québec."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zzf.mp3",
							"audioLabel": "p3-zzf",
							"script": "Pour les questions de ressources naturelles, je pense que ce serait important pour le Canada de travailler avec la Chine et l’Inde alors je pourrais faire un voyage d’affaires là-bas.  Mais personnellement, je pense j’aimerais faire un voyage d’affaires au Brésil ou en Argentine.  L’économie du Brésil est différente de l’économie de l’Inde et de la Chine et elle est similaire à l’économie du Canada, donc j’aimerais faire un voyage d’affaires dans un de ses pays."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zzg.mp3",
							"audioLabel": "p3-zzg",
							"script": "Si je pouvais choisir la destination pour un voyage d’affaires, j’irais à Vienne en Autriche.  Je choisirais Vienne parce que tout d’abord, Vienne est très très belle et il y a beaucoup de monuments et beaucoup de magasins pour les touristes.  C’est incroyable, puis j’aime la nourriture à Vienne.  Finalement, je pense que Vienne est peut-être la meilleure ville cosmopolite d’Europe et j’aime les villes cosmopolites."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zzh.mp3",
							"audioLabel": "p3-zzh",
							"script": "Si on pouvait choisir le destination de voyage d’affaires, je pense que ces occasions seraient des gaspillages d’argent, mais je choisirais une destination dans les Caraïbes si possible, parce que j’aime les pays qui sont toujours chauds, pas comme le Canada, et aussi, je choisirais un pays qui a une association ou un organisme qui travaille sur le droit à la vie privée bien sûr parce que c’est mon domaine."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zm1.mp3",
								"audioLabel": "wp3-zm",
								"script": "Pour les questions de ressources naturelles, je pense que c’est important pour le Canada de travailler avec la Chine et l’Inde alors je peux faire un voyage d’affaires là-bas.  Mais personnellement, je pense j’aime faire un voyage d’affaires au Brésil ou en Argentine.  L’économie du Brésil est différente de l’économie de l’Inde et de la Chine et elle est similaire à l’économie du Canada, donc j’aime faire un voyage d’affaires dans un de ses pays."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-q.mp3",
								"audioLabel": "part 3 e z q",
								"script": "When it comes to hypothetical questions, it is essential to use the appropriate tenses and moods in the response. It would have been necessary to respond using the conditional and not the present tense in order to adequately address the question."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zn.mp3",
								"audioLabel": "wp3-zn",
								"script": "Si on peut choisir le destination de voyage d’affaires, je pense des occasions comme ça sont des gaspillages d’argent, mais si je peux choisir, je choisis une destination dans les Caraïbes si possible, parce que j’aime les pays qui sont chauds, et aussi, je choiss une pays qui a une association ou un organisme qui travaille sur le droit à la vie privée bien sûr parce que c’est mon domaine."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-r.mp3",
								"audioLabel": "part 3 e z r",
								"script": "This was a hypothetical question using the present conditional; therefore, the same construction must be used in the response. Otherwise, the meaning will be different."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zo.mp3",
								"audioLabel": "wp3-zo",
								"script": "Ça dépend, si il serait l’hiver, une destination avec beaucoup de soleil, mais j’aimerais Toronto, il y aurait beaucoup de choses à Toronto beaucoup de cours qui seraient disponibles dans les universités, oui Toronto."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/part-3-e-z-s.mp3",
								"audioLabel": "part 3 e z s",
								"script": "Whenever you formulate a hypothesis using the present conditional, you must know how to use this grammar structure correctly. All the verbs used will not be in the present conditional. To remember this, tell yourself : ”si” and ”-rais” don’t get along! They can’t be used together."
							}
						}
					]
				}
			],
			"label": "Topic 3",
			"index": 2
		}
	]
};


export const LEVELB_PART4 = {
	"label": "part 4",
	"index": 3,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-4-LEVEL-B.mp4",
	"description": "Listening and speaking in response to a longer audio recording: " +
		"1. You listen to a two-minute recording of a work-related conversation between two people at a meeting twice. " +
		"2. Afterwards, you are asked to provide a brief summary of its content and answer related questions. " +
		"3. Duration: 11 to 13 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"index": 0,
					"label": "Q&A #1",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a13.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b10.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un résumé de l’enregistrement."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/good1-a.mp3",
							"audioLabel": "good1-a",
							"script": "Il s’agit d’une conversation entre deux collègues à propos d’un projet. Puisque Samantha était absente durant un certain temps, elle a demandé à son collègue Bertrand s’il y a eu des nouvelles concernant le projet. Il lui a donc expliqué que le directeur général a accepté de donner un budget pour le projet, mais que maintenant, la maintenance des ordinateurs devient une responsabilité de leur direction. Samantha n’est pas satisfaite de ce changement, car ce n’est pas le mandat de sa direction. Aussi, la femme doit donc réévaluer l’échéance du projet. À la fin, Bertrand a proposé de demander l’aide d’une autre personne même si celle-ci est très occupée. Pour terminer, Samantha a dit qu’elle prendra la responsabilité de contacter le client et que Bertrand discutera des échéances lors d’une réunion  avec le directeur général."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/good1-b.mp3",
							"audioLabel": "good1-b",
							"script": "Il s’agit d’une discussion entre deux employés. Tout d’abord, ils ont discuté sur les vacances de la femme. L’homme a ensuite expliqué sa collègue qu’il y avait des changements pour un projet pendant son absence. Au début, la femme ne semble pas heureuse d’apprendre cette nouvelle, mais elle a par la suite réalisé le point de vue de son collègue. Elle a dit qu’il est nécessaire de modifier les échéances du projet. Et, les deux collègues développent un plan d’action. Ils ont décidé d’ajouter un nouveau membre dans leur équipe, de contacter le client, et de renégocier les échéances auprès du directeur général."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/good1-c.mp3",
							"audioLabel": "good1-c",
							"script": "C’est une réunion entre Bertand et Samantha sur un projet. Bertrand a expliqué qu’il  reçoit un budget supplémentaire mais qu’une nouvelle tâche sur la maintenance des ordinateurs doit être ajoutée à sa charge de travail. Samantha n’est pas très contente de cette décision. Bertrand donc suggère de demander l’aide d’un nouveau coéquipier pour aider eux dans son travail. Après, Bertrand a réussi de convaincre Samantha et ils décident tous les deux de revoir les échéances du projet. Aussi, Samantha a promis de contacter le client pour informer lui de la situation et Bertrand a mentionné qu’il allait parler des échéances au directeur général le prochain mercredi."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/good1-d.mp3",
							"audioLabel": "good1-d",
							"script": "Il s’agit d’une conversation entre deux fonctionnaires. L’homme veut savoir si sa collègue est prête à travailler sur un nouveau projet. Il lui a donné un petit résumé des changements qui ont lieu durant l’absence de l’employée. Parce qu’il y a de nouvelles responsabilités à accomplir, l’employée semble un peu découragée au commencement. Mais, elle a dit qu’elle veut négocier les échéances pour pouvoir faire le travail. Le collègue suggère d’intégrer un autre employé dans l’équipe. Ils terminent la conversation par un accord. L’employée a expliqué qu’elle contacte le client pour parler des changements et l’autre dit qu’il discute avec le directeur général pour fixer les derniers détails."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong1-a.mp3",
								"audioLabel": "wrong1-ap4-d",
								"script": "Il s’agit d’une discussion entre deux employés concernant les vacances de la femme. L’homme demande où elle veut aller pour ses vacances… heum… Le sujet change. L’homme explique pour sa collègue qu’il ont quelques changements du travail, c’est-à-dire un nouveau projet qui la femme doit travailler avec un client. Les deux ont un conflit et la femme dit qu’elle parlait avec le directeur. Aussi elle consulte Fred pour sa approbation."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-d3.mp3",
								"audioLabel": "wrong1-ap4-d",
								"script": "The candidate seems confused and the answer provided is wrong. It’s important to identify what the subject of the conversation is. If you only understand a short part of the dialog, it is better not to expand on those details as though they are the main subject of the discussion. In this example, Samantha is not talking about the destination of her next trip, but rather about the vacation she took last week."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong1-b.mp3",
								"audioLabel": "wrong1-bp4-e",
								"script": "C’est un conflit entre un monsieur et une dame sur qui travaille sur le projet. La femme dit qu’elle devoir passer des vacances pour la forme. Après de ça, Bertrand veut le budget pour acheter des ordinateurs pour le directeur. En conclusion, la femme être d’accord pour l’achat."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-e3.mp3",
								"audioLabel": "wrong1-bp4-e",
								"script": "In this case, we can see that the candidate doesn’t understand the discussion between the two colleagues, who are talking about computer maintenance, not about purchasing new computers. Listening comprehension is an essential skill in passing the Test of Oral Proficiency – lots of practice is needed to avoid incorrect answers like this one."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong1-c.mp3",
								"audioLabel": "wrong1-cp4-c",
								"script": "L’homme voulait partir sur ses vacances avec la femme. Mais, Fred, le directeur général, demander pour lui fini le projet. Aussi, le client demander pour lui de changement l’échéance du projet. En conclusion, il est d’accord."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-c3.mp3",
								"audioLabel": "wrong1-cp4-c",
								"script": "There are two main problems with this response. First, the information is incorrect, showing that the candidate didn’t understand the conversation. Second, the learner’s response shows that she needs to review her grammar, verb tenses in particular, in order to express her ideas more clearly and accurately."
							}
						}
					]
				},
				{
					"index": 1,
					"label": "Q&A #2",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a12.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est le but du message"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b8.mp3",
							"audioLabel": "q2-b",
							"script": "Quel est l’objet de l’annonce?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/good2-a.mp3",
							"audioLabel": "good2-a",
							"script": "Selon moi, une personne que veut faire une carrière à la fonction publique doit accepter les nouvelles responsabilités et les nouvelles tâches du travail. Quand je suis motivée par des promotions, je dois préparer moi à travailler plus, car je sais que les responsabilités sont toujours plus complexes et plus exigeants. Je crois que c’est normal dans le monde du travail."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/good2-b.mp3",
							"audioLabel": "good2-b",
							"script": "Plusieurs fois dans ma carrière, j’ai accepté les nouvelles tâches et les nouvelles responsabilités au travail. Selon moi, ce n’est pas parce que je suis ambiteux, mais parce que j’avais l’occasion d’apprendre de nouvelles choses et de vivre des nouvelles expériences. Donc normalement, les surcharges de travail ne me fait pas peur. Mais, c’est plus difficile maintenant puisque j’ai deux petits enfants. Donc, j’ai aussi beaucoup de tâches à faire à la maison."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/good2-c.mp3",
							"audioLabel": "good2-c",
							"script": "À mon avis, l’ambition me motive à prendre de nouvelles tâches au travail. J’aime les défis, car je suis une personne fonceux. Je suis fière de que j’accomplis au travail. Mais, il est vrai que parfois je suis très occupée avec mes projets. Je dois rester au travail plus longtemps pour terminer tout et mon mari n’aime pas beaucoup cela. Mais je crois que l’ambition est bénéfique dans un milieu de travail."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/good2-d.mp3",
							"audioLabel": "good2-d",
							"script": "Pour moi, l’ambition est très importante, car je n’ai pas peur des surcharges de travail. Je connais des personnes que préfèrent avoir une charge de travail normale, mais je crois qu’il faut avoir de l’ambition dans la vie. De plus, c’est impossible de faire progresser sa carrière si on veut pas faire des tâches supplémentaires parce que aujourd’hui, il y a beaucoup de problèmes qui survient au travail. Les problèmes arrêtent souvent les personnes, mais grâce à l’ambition, ils peuvent travailler efficacement dans des situations plus difficiles."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong2-a.mp3",
								"audioLabel": "wrong2-ap4-d",
								"script": "D’après moi, c’est très important d’accepter de nouvelles responsabilités au travail. Je pense que c’est normal d’avoir parfois une surcharge de travail. Quand nous sont fonctionnaires, il faut être prêt accepter des nouveaux projets, il faut aussi être prêt pour une charge supplémentaire de travail. À mon avis, c’est une bonne façon de garder une bonne réputation avec nos gestionnaires. Il faut donc toujours accepter les nouvelles tâches sans hésitation."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-d4.mp3",
								"audioLabel": "wrong2-ap4-d",
								"script": "The candidate seems to have forgotten that the topic is ambition, as there is no mention of it in the response. When there is a discussion weighing the pros and cons of possible actions, be sure you understand and note the arguments being made by each speaker. You’ll then be able to discuss which point of view you agree with and explain why you do."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong2-b.mp3",
								"audioLabel": "wrong2-bp4-e",
								"script": "Récemment, le budget décidé par le gouvernement a des conséquences sur notre environnement de travail. Il y a beaucoup de personnes qui partent à la retraite et aussi beaucoup de programmes qui ont coupés. Les gestionnaires n’engagent pas de nouveaux fonctionnaires, car ils doivent  diminue leur personnel. Les fonctionnaires qui travaillent ont une surcharge de travail. Tout le monde doit travailler plus longtemps et accepter de nouvelles responsabilités."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-e4.mp3",
								"audioLabel": "wrong2-bp4-e",
								"script": "In this case, the candidate doesn’t answer the question correctly- the main topic, ambition, isn’t a part of her response. In the Part 4 of the exam, it must be clear to the examiner that you have understood both the subject being discussed and the follow-up questions asked. You are being evaluated on whether you can express an opinion about a topic, so it is extremely important to use opinion expressions such as “d’après moi,” “à mon avis,” “selon moi,” etc., and the pronoun “je” because a point of view is subjective."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong2-c.mp3",
								"audioLabel": "wrong2-cp4-f",
								"script": "Selon moi, l’ambition est très importante dans le monde du travail. Si l’on décide de pas prendre de risques, on va toujours rester dans le même ministère à faire la même chose avec les mêmes personnes. C’est pas intéressant. L’ambition permet aussi d’élever moi. On peut devenir gestionnaire ou directeur général si on veut. Je ne veux pas être comme les personnes qui ne fait rien pour changer."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-f4.mp3",
								"audioLabel": "wrong2-cp4-f",
								"script": "This isn’t a successful response because the question that was asked is not answered. “Ambition” is the main topic, but the context is not taken into account by the learner. It’s essential to understand the entire question because if something important is missed, even a well structured answer won’t have a strong impact."
							}
						}
					]
				},
				{
					"index": 2,
					"label": "Q&A #3",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a11.mp3",
							"audioLabel": "q3-a",
							"script": "Jusqu’à quel point les changements de dernière minute vous dérangent-ils?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b10.mp3",
							"audioLabel": "q3-b",
							"script": "Dans quelle mesure une modification de dernière minute vous oblige-t-elle à changer votre manière de travailler?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/good3-a.mp3",
							"audioLabel": "good3-a",
							"script": "Depuis les dernières années, je vois que les changements de dernière minute font partie du travail au sein de la fonction publique. Je ne suis pas habitué à cela parce que je suis une personne très organisée. Mais, quand il y a des changements de dernière minute, j’essaie de trouver du temps dans mon horaire pour leur faire. Mais c’est difficile pour moi parce que j’ai l’habitude de tout planifier. Enfin, les changements de dernière minute me dérangent parfois parce qu’ils arrivent souvent le vendredi après-midi et à cause de cela, je deviens frustré."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/good3-b.mp3",
							"audioLabel": "good3-b",
							"script": "Pour moi, les changements de dernière minute me dérangent jusqu’à un point. Je n’aime pas ça quand je dois arrêter mon travail pour les faire. Par exemple, si j’ai un projet important à donner aujourd’hui, j’aimerais ne pas avoir les autres tâches pour terminer mon projet du début. Finalement, avant d’accepter de nouvelles responsabilités, je préfère terminer mes tâches normales."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/good3-c.mp3",
							"audioLabel": "good3-c",
							"script": "Personnellement, les changements me dérangent plus ou moins, car j’ai une pensée positive. Je crois que les actions sont plus importantes que les résultats. Donc, quand un changement arrive, je souviens de cette idée et je reste calme. Enfin, grâce à cela, je peux travailler sur les problèmes et ne pas être fâchée par la situation."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/good3-d.mp3",
							"audioLabel": "good3-d",
							"script": "Il est vrai que les changements de dernière minute me dérangent un peu. Mais normalement, si je suis bien organisée, je peux finir tous mes tâches. Je peux aussi ajoute de nouvelles responsabilités sur ma liste des priorités. Mais quand c’est impossible de gérer la situation, je discute habituellement avec mon patron pour identifier le travail plus important."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong3-a.mp3",
								"audioLabel": "wrong3-ap4-g",
								"script": "Dans mon cas, je termine souvent mon travail à la dernière minute, car je suis pas une personne bien organisée. J’ai du retard dans mes projets normalement. Mon patron n’aime pas beaucoup cela, mais mon travail est toujours bien fait. Je dois améliore mon sens de l’organisation, car plus tard je veux devenir gestionnaire. Enfin, je comprends les personnes qui ont de la difficulté à planifier son horaire, car je suis comme ils."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-g3.mp3",
								"audioLabel": "wrong3-ap4-g",
								"script": "In this case, this answer shows a lack of comprehension, although the vocabulary and grammar are fine. It’s important to listen carefully to the question asked, and answer accordingly."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong3-b1.mp3",
								"audioLabel": "wrong3-bp4-h",
								"script": "Les changements à la dernière minute me dérangent lorsqu’ils arrêter le travail que je dois faire. Avant d’accepter de nouvelles responsabilités, je préfère terminer mes tâches habituelles."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-h2.mp3",
								"audioLabel": "wrong3-bp4-h",
								"script": "This response is a little too brief. Don’t be afraid to expand on what you’ve said in order to demonstrate your skills!"
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wrong3-c.mp3",
								"audioLabel": "wrong3-cp4-i",
								"script": "J’ai un bon exemple d’un changement de dernière minute : Je devais aller à une réunion à Toronto. Je prends l’avion le soir d’avant, car la réunion est à 8 heures le matin. Je dors dans un hôtel la nuit. Le lendemain matin, à 7 heures, mon patron appelle pour dire que la réunion est annulée."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-i2.mp3",
								"audioLabel": "wrong3-cp4-i",
								"script": "When the examiner asks you an opinion question, he or she wants to evaluate your ability to offer an opinion and then support that opinion. First, express your opinion, then make a few points to justify your perspective and give examples to support your argument. Finally, try to leave time to conclude by summarizing your opinion. These steps can help you succeed in this part of the test."
							}
						}
					]
				}
			],
			"followUpQAs": [],
			"index": 0,
			"label": "Conversation",
			"content": {
				"audio": "/wp-content/uploads/2013/12/long-dialogue1.mp3",
				"audioLabel": "long-dialogu",
				"script": "-Benoît : Salut Samantha!  Tu es finalement de retour?-Samantha : Salut Benoît!  Oui je suis revenue hier.-Benoît : Comment étaient tes vacances?-Samantha : C’était vraiment bien. Je suis allée passer une semaine dans le sud.-Benoît : Alors tu dois être en forme pour attaquer le projet dont nous avions parlé avant ton départ?-Samantha : En pleine forme!  Il y a eu du nouveau depuis?-Benoît : Oui, mais l’essentiel reste à faire.  Le directeur général a accepté de nous allouer un budget supplémentaire, mais nous devons inclure les maintenances des ordinateurs. -Samantha : La maintenance!  Mais, ce n’était pas ce qui était prévu au départ!  De plus, ce n’est pas le mandat de notre direction.-Benoît : Je le sais.  Mais vu les récentes coupures à la direction de la maintenance, il a dit que nous devions commencer à nous préparer à prendre en charge une partie de leur travail habituel. -Samantha : Dans ce cas, il faut refaire l’analyse et surtout renégocier les échéances. Il va aussi falloir prévenir le client.-Benoît : Oui. Il faut qu’on demande à Fred s’il veut faire partie du comité de préparation du projet. Ces connaissances et son expertise pourraient s’avérer très bénéfiques pour nous.-Samantha : Oui, mais penses-tu qu’il acceptera, surtout avec la surcharge de travail que connaît son équipe actuellement ?  Selon moi, il déclinera l’offre.-Benoît : Je pense qu’au contraire il sera tenté d’accepter surtout si on réussit à le convaincre de l’intérêt que pourrait avoir sa participation dans l’évolution de sa carrière.  Il ne sera pas insensible à ce genre d’argument.-Samantha : Vu comme ça, on a peut-être une chance.  Alors je me propose de contacter le client pour lui faire part du changement et de ton côté pourrais-tu en parler à Fred ?-Benoît : Oui, c’est ce que je vais faire.  Je me chargerai aussi de revoir les échéances avec le directeur général lors de notre réunion mensuelle, mercredi prochain."
			}
		}
	]
};


export const LEVELB = {
	label: "Level B",
	parts: [LEVELB_PART1, LEVELB_PART2, LEVELB_PART3, LEVELB_PART4]
};


export const LEVELC_PART1 = {
	"label": "part 1",
	"index": 0,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-1-LEVEL-C.mp4",
	"description": "Questions and answers about work or other familiar activities: " +
		"1. You answer brief questions about your work or other familiar activities (e.g., studies or volunteer activities, if you are not currently employed) for which short, factual responses are expected. " +
		"2. Duration: 2 to 6 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"index": 0,
					"label": "Question 1",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a3.mp3",
							"audioLabel": "q1-a",
							"script": "Où travaillez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b1.mp3",
							"audioLabel": "q1-b",
							"script": "Dans quel ministère travaillez-vous ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q1-c1.mp3",
							"audioLabel": "q1-c",
							"script": "A quel endroit travaillez-vous ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q1-d1.mp3",
							"audioLabel": "q1-d",
							"script": "Pour quel ministère travaillez-vous ? "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-a2.mp3",
							"audioLabel": "p1-a",
							"script": "Je travaille au ministère des Travaux publics et services gouvernementaux dans le domaine de l’approvisionnement. Ce n’est pas très loin d’ici, au centre-ville."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-b1.mp3",
							"audioLabel": "p1-b",
							"script": "Je travaille à Santé Canada."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-c1.mp3",
							"audioLabel": "p1-c",
							"script": "Je travaille à Santé Canada dans la division de la loi canadienne sur la santé."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-d1.mp3",
							"audioLabel": "p1-d",
							"script": "Je travaille aux Affaires indiennes et du Nord Canada dans la division des communications."
						}
					],
					"problematicAnswers": []
				},
				{
					"index": 1,
					"label": "Question 2",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a2.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est votre poste ? "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b.mp3",
							"audioLabel": "q2-b",
							"script": "Quelle est votre profession ? "
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c.mp3",
							"audioLabel": "q2-c",
							"script": "Quel est le titre de votre poste ? "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-e.mp3",
							"audioLabel": "p1-e",
							"script": "Je suis fonctionnaire et gestionnaire. Le titre de mon poste présentement est directeur général de soutien aux opérations et à la planification, avec le secteur des opérations régionales."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-f.mp3",
							"audioLabel": "p1-f",
							"script": "Je suis gestionnaire."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-g.mp3",
							"audioLabel": "p1-g",
							"script": "J’occupe un poste de gestionnaire pour une petite équipe de six analystes."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-h.mp3",
							"audioLabel": "p1-h",
							"script": "Je suis avocat, mais je travaille comme gestionnaire."
						}
					],
					"problematicAnswers": []
				},
				{
					"index": 2,
					"label": "Question 3",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a1.mp3",
							"audioLabel": "q3-a",
							"script": "Quelles sont vos tâches principales?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b1.mp3",
							"audioLabel": "q3-b",
							"script": "En quoi consiste votre travail ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c1.mp3",
							"audioLabel": "q3-c",
							"script": "Décrivez-moi brièvement vos tâches principales ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q3-d1.mp3",
							"audioLabel": "q3-d",
							"script": "Quelles sont les tâches principales rattachées à votre poste ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-i.mp3",
							"audioLabel": "p1-i",
							"script": "Tout d’abord, je dirige une petite équipe de six analystes qui travaillent dans le domaine de l’élaboration des politiques. Ensuite, j’organise plusieurs activités liées à la haute-gestion en ce qui concerne le système de santé. À titre d’exemple, il y a bien sûr le grand débat entre le système privé et le système public. Finalement, quotidiennement, il est très important que j’établisse une liste de priorités tout en réglant les problèmes qui surgissent au sein de mon équipe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-j.mp3",
							"audioLabel": "p1-j",
							"script": "Je suis le gestionnaire de la division… alors je dirige le programme d’évaluation environnementale et également je gère les ressources humaines et financières. De plus, je donne des conseils à mon équipe sur les politiques et les questions scientifiques."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-k.mp3",
							"audioLabel": "p1-k",
							"script": "Mes responsabilités comprennent l’approbation des produits de communications de mes employés, aussi la planification et la coordination concernant les évènements avec le ministre et les autres personnes de mon ministère. De plus, je dois gérer le travail de mon équipe et aussi les préoccupations  des ressources humaines concernant les membres de ma division."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-l.mp3",
							"audioLabel": "p1-l",
							"script": "Je dois gérer les activités de mon équipe et faire preuve de leadership auprès de mes employés. Il y a environ cinquante employés sous ma direction, alors je dois m’assurer qu’ils respectent tous le mandat de notre division. Je m’occupe aussi de l’organisation des réunions du comité d’opération pour le ministère. Je suis très occupé, mais j’aime mon travail."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-a1.mp3",
								"audioLabel": "wp1-ap1-a",
								"script": "Comme gestionnaire, j’ai plusieurs tâches, mais ma tâche principale est de gérer une petite équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-a3.mp3",
								"audioLabel": "wp1-ap1-a",
								"script": "If you are a manager, of course, you are in charge of a team! Furthermore, the plural form is used in the question, so it would be advisable to add at least one other duty to your description."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-b.mp3",
								"audioLabel": "p1-bp1-b",
								"script": "Comme tous les gestionnaires, j`ai des tâches assez importantes, des tâches plus que d’assister aux réunions et rédiger des rapports, mais en tant que gestionnaire, j’ai trois tâches qui me tiennent à cœur.  D’abord, je suis responsable de gérer une équipe donc, il faut que je planifie, j’organise le travail.  Ma deuxième tâche, je suis responsable de la dotation dans la direction.  C’est une processus assez compliqué que je vais tenter de vous décrire.  Nous organisons d’abord un concours.  On publie un avis de concours avant de passer à l’examen écrit.  Nous convoquons ensuite le candidat retenu à une entrevue en terminant avec la vérification des références données.  Ma troisième responsabilité, je analyse avec mon équipe chaque demande de logiciel du client afin de vérifier si les critères sont bien formulés.  Il est important que le critère respecte la loi et règlement du gouvernement du Canada et j’analyse avec mon équipe cette demande en lisant tous les critères et en soulignant toutes les modifications nécessaires.  Après ça, on discute avec le client pour qu’il le fasse et il est primordial qu’on comprenne la demande parce qu’on doit répondre beaucoup de questions.  Si on ne comprend pas la demande, il serait difficile d’y répondre.  Voilà encore mes trois responsabilités sur lesquelles il faut que je porte mon attention en tant que gestionnaire d’approvisionnement à Travaux publics."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-b2.mp3",
								"audioLabel": "p1-bp1-b",
								"script": "This response is too long. The first part of the TOP is designed to assess your knowledge of simple."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-c.mp3",
								"audioLabel": "p1-cp1-c",
								"script": "Mes ta, mon tâche principale est de supervise, fournir de leadership mes employés. En réalité, il y a environ cinquante employés sous ma direction. C’est la raison pour laquelle que j’ai besoin de s’assure le mandat de parce que respecté. Et aussi, je charge avec la responsabilité pour le réunion de la comité d’opération pour le ministère et j’ai besoin de s’être sur le réunion chaque deux semaines. On a dit c’était une poste très chargé, très occupé mais j’aime mon travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-c2.mp3",
								"audioLabel": "p1-cp1-c",
								"script": "The first part of the TOP is made up of simple questions in order to allow the candidate to start the Test without undue stress. It is normal to be nervous, but the candidate must manage to control his stress to pass this part of the Test, which should be simple."
							}
						}
					]
				},
				{
					"index": 3,
					"label": "Question 4",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a1.mp3",
							"audioLabel": "q4-a",
							"script": "Présentez-moi brièvement votre équipe ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b1.mp3",
							"audioLabel": "q4-b",
							"script": "Que font les différents membres de votre équipe ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q4-c1.mp3",
							"audioLabel": "q4-c",
							"script": "Qui sont les personnes qui composent votre équipe ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q4-d.mp3",
							"audioLabel": "q4-d",
							"script": "Combien de personnes travaillent dans votre équipe et à quel poste ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-m.mp3",
							"audioLabel": "p1-m",
							"script": "Je gère une équipe de dix personnes. C’est une équipe très diverse parce que j’ai trois employés qui travaillent aux bureaux régionaux. Le reste de mon équipe travaille au bureau central. C’est très intéressant parce qu’il y a une grande différence d’âge entre les jeunes et les plus âgés : une employée a juste 23 ans et un autre a 60. C’est une situation intéressante pour un gestionnaire d’avoir une équipe avec beaucoup d’expériences différentes et des niveaux de compétences différents aussi. Et aussi, c’est rare d’avoir une équipe de dix personnes. C’est une grande équipe dans ma division, mais en général les membres de mon équipe sont très professionnels et très exigeants et ils sont capables de collaborer beaucoup et c’est mon objectif d’avoir une équipe professionnelle, qui travaille ensemble avec des collègues."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-n.mp3",
							"audioLabel": "p1-n",
							"script": "J’ai une petite équipe de une personne donc c’est seulement moi et l’autre personne. J’ai l’exigeance d’avoir plus d’employés, mais j’en ai une maintenant. Avoir une équipe très petite comme ça me permet de répartir le travail entre les deux et c’est plus facile pour moi."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-o.mp3",
							"audioLabel": "p1-o",
							"script": "Il y a six analystes qui travaillent dans mon équipe : trois analystes expérimentés et trois débutants. Les trois expérimentés travaillent dans cette équipe depuis longtemps, surtout dans le domaine d’élaboration des politiques. Par contre, les débutants sont arrivés l’année passée et ils commencent à appuyer le processus gouvernemental pour préparer les objectifs, par exemple."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-p.mp3",
							"audioLabel": "p1-p",
							"script": "J’ai une équipe de 18 employés il y a 3 chefs d’équipes et je pense 3 stagiaires c’est-à-dire des étudiants. L’équipe est très dynamique, très compétente à mon avis. La seule faiblesse avec mon équipe c’est sa jeunesse donc de temps en temps, l’équipe manque l’expérience nécessaire de faire le budget."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-d.mp3",
								"audioLabel": "p1-dp1-d",
								"script": "Dans mon équipe, il y a des avocats, comme moi, et aussi des analystes qui sont des experts dans …. J’ai une grande équipe mais elle est divisée dans des petites équipes qui a des dossiers spécial. Donc j’ai deux-trois petits équipes, mais enfin nous sommes une grand équipe. Il y a trois autres avocats, le même de analystes et aussi de temps en temps il y a des membres de la GRC."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-d2.mp3",
								"audioLabel": "p1-dp1-d",
								"script": "This response is a little unclear. It is comprehensible, but it should be better organized. Furthermore, close attention must be paid to the rules for agreement of the various parts of speech, in this case, agreement of the adjective with the noun."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-e.mp3",
								"audioLabel": "p1-ep1-e",
								"script": "C’est un peu complexe mais je travaille dans une programme nationale, alors il y a sept personnes à Ottawa mais également il y a neuf personnes dans les régions qui ne relèvent pas à moi. Alors c’est un peu complexe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-e2.mp3",
								"audioLabel": "p1-ep1-e",
								"script": "This candidate started off his description well, but it could have been a little more elaborate. He could have specified the titles of the team members’ positions and also provided a general impression of the strengths and weaknesses of his team."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-f.mp3",
								"audioLabel": "p1-fp1-f",
								"script": "Oui, j’ai quatre gestionnaires qui travaillent directement sur ma direction et aussi trois autres membres de mon équipe : mon adjoint administratif, une analyste de politique et ensemble nous avons le responsabilité pour le direction.  Et il y a l’autre employé est partagé entre les quatre directeurs, les quatre gestionnaires.  Il y a une section pour l’administration, une section pour l’infrastructure, une autre section pour les urgences et les crises et une section qui a le responsabilité pour la planification et le budget."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-f2.mp3",
								"audioLabel": "p1-fp1-f",
								"script": "This response is not well articulated, which makes it hard to follow. Practise this type of question so that the response will be clearer. In this case, it would have been better to start by naming the different sections and then specifying what the members of the team do."
							}
						}
					]
				},
				{
					"index": 4,
					"label": "Question 5",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a.mp3",
							"audioLabel": "q5-a",
							"script": "Comment vous rendez-vous au travail le matin?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b1.mp3",
							"audioLabel": "q5-b",
							"script": "Quel trajet empruntez-vous pour aller au travail ?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q5-c.mp3",
							"audioLabel": "q5-c",
							"script": "Quel chemin suivez-vous pour vous rendre au travail ?"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/q5-d.mp3",
							"audioLabel": "q5-d",
							"script": "Par où passez-vous pour aller au travail ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p1-q.mp3",
							"audioLabel": "p1-q",
							"script": "Normalement je vais au bureau en voiture. J’habite un quartier juste au sud du Glebe à Ottawa. Je suis la rue Sunnyside jusqu’au rue Bronson et je prends à droite. Je continue sur la rue Bronson jusqu’à la rue Albert où je tourne à gauche et je continue jusqu’au feu de circulation au coin d’Albert et de  Booth. Je tourne à droite et je traverse le pont des Chaudières et mon édifice est juste au coin des rues Eddy et Wellington. Mon stationnement est juste en face de mon bureau. Voilà mon trajet jusqu’au bureau."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p1-r.mp3",
							"audioLabel": "p1-r",
							"script": "D’habitude je prends l’autobus entre ma maison et mon lieu de travail. Je demeure à Stittsville où il y a quelques autobus express et chaque matin je prends l’autobus."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p1-s.mp3",
							"audioLabel": "p1-s",
							"script": "Le matin, je prends l’autobus près de chez-nous jusqu’au centre-ville.  Malheureusement, OC-Transpo a supprimé l’autobus express dans mon quartier donc il faut que je change d’autobus à la station Hurdman."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p1-t.mp3",
							"audioLabel": "p1-t",
							"script": "En général, je prends ma voiture et je me dirige vers le parc-o-bus, où je prends le O-Train pour aller au travail.  Il y a quatre arrêts pour le train et après mon arrêt, je me rends à pieds pendant trois coins de rue."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-g.mp3",
								"audioLabel": "p1-gp1-g",
								"script": "En quittant ma maison, je marche juste au coin, à l’arrêt d’autobus numéro six.  Cet autobus traver le quartier Glebe et puis suit la rue Carling juste à la coin de Carling et Parkdale.  Ensuite l’autobus suit Parkdale jusqu’à la rentrée de pré Tunney où il tourne à gauche et arrête juste devant l’édifice Jeanne-Mance."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-g3.mp3",
								"audioLabel": "p1-gp1-g",
								"script": "It is not necessary to use complex structures, such as the gerund, in this part of the TOP. However, it is absolutely necessary to master prepositions which are the main difficulty with this question."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-h.mp3",
								"audioLabel": "p1-hp1-h",
								"script": "Normalement je vais au bureau en voiture. J’habite au quartier juste sud du Glebe à Ottawa. Je suis la rue Sunnyside jusqu’au rue Bronson et je prenne à droite rue Bronson. Je continue rue Bronson jusque au rue Albert ou je tourne à gauche et je continue jusqu’au feu de circulation au coin d’Albert et Booth.  Je tourne à droite et je traverse le pont des Chaudières et mon édifice est juste au coin de rue Eddy et rue Wellington. Et mon stationnement est juste en face de mon bureau. Et ça c’est mon trajet jusqu’au bureau."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-h3.mp3",
								"audioLabel": "p1-hp1-h",
								"script": "It is not necessary to provide such an elaborate response. If, however, you choose to include so many details, make sure prepositions are used accurately and verbs are correctly conjugated."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp1-i.mp3",
								"audioLabel": "p1-ip1-i",
								"script": "En général, je prends ma voiture, où je me dirige vers le parc-o-bus, où je prends le O-Train pour aller au travail.  Il y a quatre arrêts pour le train et après mon arrêt, je marche à pieds pour trois blocs."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p1-i3.mp3",
								"audioLabel": "p1-ip1-i",
								"script": "It is all right to use relative pronouns in your response, but they should not be used excessively. In this particular case, the first ”où” is not called for and makes the sentence cumbersome."
							}
						}
					]
				}
			],
			"index": 0
		}
	]
};


export const LEVELC_PART2 = {
	"label": "part 2",
	"index": 1,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-2-LEVEL-C.mp4",
	"description": "Listening and speaking in response to short audio recordings: " +
		"1. You listen to two short voice-mail messages (10 to 15 seconds each) and two short work-related conversations (30 to 35 seconds each) twice. " +
		"2. Afterwards, you are asked to identify the reason for the call, what needs to be done or what help is being offered. " +
		"3. Duration: Approximately 7 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a6.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce message ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b4.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un court résumé de l’enregistrement ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/mess-a.mp3",
							"audioLabel": "p1-a",
							"script": "Le message est de Marie pour Thomas. Elle l’informe que la réunion hebdomadaire devra être annulée pour cette semaine car M. Lapierre est absent et c’est lui qui devait présider la réunion. Elle charge Thomas de faire part de l’annulation aux autres membres de l’équipe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-a1.mp3",
							"audioLabel": "p1-b",
							"script": "Il s’agit d’un court message de la part de Marie à Thomas au sujet de la réunion hebdomadaire qui était planifiée pour cet après-midi-là.  La réunion a été annulée à cause de l’absence du président, M. Lapierre, et elle a demandé que Thomas informe le reste d’équipe afin d’éviter les déplacements inutiles."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-b.mp3",
								"audioLabel": "mess-bcom-a ",
								"script": "Marie laisse un message à Thomas pour lui dire que la réunion hebdomadaire de la fin de semaine est annulée, car le président n’est pas là. Elle lui demande aussi d’informer le reste de l’équipe, car elle ne veut pas payer les déplacements inutilement. C’est important pour elle. "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-a1.mp3",
								"audioLabel": "mess-bcom-a ",
								"script": "You must be careful not to add information that has not been clearly stated in the recording.The purpose of this exercise is not to demonstrate creativity or inventiveness.It is all about assessing your comprehension of the main elements of the message.It is essential not to go beyond the information contained in the recording by making suppositions about what was said in the message."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-c.mp3",
								"audioLabel": "mess-ccom-b",
								"script": "C’est un message de Marie pour Thomas. Elle lui dit qu’il n’y aura pas de réunion. Elle veut qu’il le dise aux autres."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-b.mp3",
								"audioLabel": "mess-ccom-b",
								"script": "To produce an accurate summary, it is essential to have grasped all the main elements of the recording. This one lacks the information that would strongly contribute to the overall clarity of the summary. Furthermore, it lacks fluidity with its choppy sentences. The response is thus difficult to follow, and even to understand. Use of connectives would add a little cohesion to this summary."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a4.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est le but du message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b2.mp3",
							"audioLabel": "q2-b",
							"script": "Quel est l’objet de l’annonce?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-c2.mp3",
							"audioLabel": "p2-c",
							"script": "Dans ce court message téléphonique que nous venons d’écouter, Marie appelle pour informer que la réunion hebdomadaire est annulée l’après-midi, parce que le président est absent.  Elle veut que l’employé informe le reste d’équipe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-d2.mp3",
							"audioLabel": "p2-d",
							"script": "C’était un message de Marie à Thomas. Elle l’a informé que la réunion hebdomadaire de l’après-midi était annulée et elle lui a demandé d’informer le reste de l’équipe. Ça c’est l’objectif de le message."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-b1.mp3",
								"audioLabel": "p2-ep2-e",
								"script": "Hebdedomaire est annulé parce que le président est absent et aussi Marie a demandé à Thomas d’informer le reste de l’équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-b4.mp3",
								"audioLabel": "p2-ep2-e",
								"script": "If a word is used that you do not know or cannot really use, it is often wise to use a synonym or try to get around it by explaining what you mean, rather than make a mistake that can be avoided."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-a1.mp3",
								"audioLabel": "p2-fp2-f",
								"script": "C’est un message de Marie à Thomas. Elle lui a informé la réunion hebdomadaire de l’après midi était annulée et elle lui a demandé si il a informé le reste de l’équipe. Ça c’est l’objectif de le message."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-a4.mp3",
								"audioLabel": "p2-fp2-f",
								"script": "When you choose to do a summary, you should pay close attention to the choice of verb tenses and use of the correct object pronoun. For example, the verb ” informer ” requires a direct object pronoun – l’ (le)."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a4.mp3",
							"audioLabel": "q3-a",
							"script": "Qu’est-ce qui doit être fait?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b3.mp3",
							"audioLabel": "q3-b",
							"script": "Quelle est la conclusion du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/mess-d.mp3",
							"audioLabel": "p2-g",
							"script": "Marie demande à Thomas d’appeler le reste de l’équipe pour leur faire savoir que la réunion est annulée pour ne pas que l’équipe se déplace inutilement."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/mess-e.mp3",
							"audioLabel": "p2-h",
							"script": "Marie veut que Thomas informe les autres membres que la réunion est annulée."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-f.mp3",
								"audioLabel": "p2-icom-c",
								"script": "Marie ordonne à Thomas de téléphoner à tous les membres de l’équipe pour les empêcher de se déplacer."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-c.mp3",
								"audioLabel": "p2-icom-c",
								"script": "When doing a summary, the words that you choose to use must be appropriate to the tone of the statement. You must pay special attention to the subtle differences in meaning. In this particular case. The verb “demander” is more polite than the word “ordonner”."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-g.mp3",
								"audioLabel": "p2-jcom-d",
								"script": "Marie demande à Thomas d’informer le reste de l’équipe que la réunion est annulée afin d’éviter de faire des déplacements inutles."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-d.mp3",
								"audioLabel": "p2-jcom-d",
								"script": "When listening to a recording, it is necessary to get an accurate understanding of the message, one obstscle being that certain words may sound alike to the listener. Indeed, the noun “déplacements”, phonetically, is exactly the same as “des placements”. They are homonyms."
							}
						}
					]
				}
			],
			"index": 0,
			"label": "Message",
			"content": {
				"audio": "/wp-content/uploads/2013/12/message-1.mp3",
				"audioLabel": "message 1",
				"script": "Bonjour Thomas, Marie à l’appareil.  Je t’appelle pour t’informer que la réunion hebdomadaire prévue en fin de journée a été annulée car M. Lapierre, qui devait la présider, est absent.  Pourrais-tu stp informer le reste de l’équipe afin d’éviter des déplacements inutiles.  Merci et à bientôt!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a8.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce message ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b6.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un court résumé de l’enregistrement ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/mess-h.mp3",
							"audioLabel": "mess-h",
							"script": "C’est un message d’une femme destiné à M. Dupont pour l’informer qu’il a réussi la première étape d’un concours pour le poste de directeur-adjoint à la division des communications. La raison pour laquelle elle téléphone est de le convoquer à une entrevue le 3 mars à 15 heures. Elle voudrait également avoir une confirmation de sa présence."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/mess-i.mp3",
							"audioLabel": "mess-i",
							"script": "l s’agit d’un message à l’intention de M. Dupont. La personne au téléphone a indiqué qu’il avait réussi la première étape d’un concours pour le poste de directeur-adjoint. Le but de l’appel était de l’inviter à une entrevue. La personne appelant lui a donné les détails concernant la date d’entrevue et a demandé à M. Dupont de la rappeler pour confirmer sa présence."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-j.mp3",
								"audioLabel": "mess-jcom-e",
								"script": "C’est un message destiné M. Dupont pour l’informer qu’il a obtenu le poste de directeur-adjoint à la division des communications. Ensuite, la personne du message lui dit qu’il pourra commencer à travailler le jeudi 3 mars. Elle veut qu’il la rappelle pour confirmer sa présence."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-e.mp3",
								"audioLabel": "mess-jcom-e",
								"script": "When listening to a recording, you must pay particular attention to certain details that are essential to an accurate understanding of the message. In this case, Mr. Dupont has passed only the first step of the competition process and March 3 is merely the day of his interview. This kind of information makes all the difference in the interpretation of the message."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-k.mp3",
								"audioLabel": "mess-kp2-d",
								"script": "Il s’agit d’un message très positif à propos d’un concours pour le poste de directeur-adjoint à la division des communications. Elle le convoque à une entrevue. Cette entrevue aura lieu dans leurs locaux le jeudi 3 mars à 15 heures. Elle lui demande de la rappeler et elle lui laisse le numéro de téléphone 613-444-1919 pour que M. Dupont puisse confirmer sa présence."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-d4.mp3",
								"audioLabel": "mess-kp2-d",
								"script": "This is an excellent response, but it is unduly long. It is not necessary to provide all the details mentioned in a recording, particularly details such as names and telephone numbers. If you are sure to have accurately noted this information, go ahead and use it, but it is an unnecessary risk."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a6.mp3",
							"audioLabel": "q2-a",
							"script": "Quel est le but du message?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-c4.mp3",
							"audioLabel": "q2-b",
							"script": "Quel est la raison du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/mess-l.mp3",
							"audioLabel": "mess-l",
							"script": "Le but du message est à la fois d’informer M. Dupont qu’il a réussi la première étape d’un concours pour le poste de directeur-adjoint et également lui laisser savoir qu’il est convoqué à un entrevue le 3 mars."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/mess-m.mp3",
							"audioLabel": "mess-m",
							"script": "La personne appelle M. Dupont car il a réussi la première étape du concours pour le poste de directeur-adjoint. Il est donc invité à une entrevue le jeudi 3 mars."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-n.mp3",
								"audioLabel": "mess-ncom-f",
								"script": "Parce que M. Dupont a eu de bonnes notes à une compétition pour un poste de directeur, on l’invite à une entrevue."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-f.mp3",
								"audioLabel": "mess-ncom-f",
								"script": "Pay special attention to the expressions used. In this message, there is no mention of marks or of a competition. It is better to employ the same terms that were used in the recording rather than your own choice of words which can mean something else entirely or carry a subtle difference in meaning."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-o.mp3",
								"audioLabel": "mess-ocom-g",
								"script": "M. Dupont a la chance d’être convoqué à une entrevue."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-g1.mp3",
								"audioLabel": "mess-ocom-g",
								"script": "This response is not complete. It is correct that Mr. Dupont has been invited to an interview, but the reason for this invitation is also part of the message. It is necessary to clearly identify all the elements that convey the purpose of the message."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a6.mp3",
							"audioLabel": "q3-a",
							"script": "Qu’est-ce qui doit être fait?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b5.mp3",
							"audioLabel": "q3-b",
							"script": "Quelle est la conclusion du message?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/mess-q.mp3",
							"audioLabel": "messs-q",
							"script": "Pour s’assurer de sa présence, la femme demande à M. Dupont de la rappeler."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/mess-p.mp3",
							"audioLabel": "mess-p",
							"script": "Comme conclusion, la personne au téléphone demande à M. Dupont de la rappeler pour confirmer sa présence à l’entrevue."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-r1.mp3",
								"audioLabel": "mess-rcom-h",
								"script": "Elle conclut en disant merci et à bientôt."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-h.mp3",
								"audioLabel": "mess-rcom-h",
								"script": "The final words of the message are not necessarily its conclusion. In this case, there is no point in mentioning the greetings. The real conclusion is the question asked by the lady at the end of the message concerning the confirmation."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/mess-s1.mp3",
								"audioLabel": "mess-scom-i",
								"script": "La conclusion est: « Pourriez-vous m’appeler au 613-444-1919 pour confirmer votre présence ? »."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/com-i.mp3",
								"audioLabel": "mess-scom-i",
								"script": "The purpose of the oral comprehension component is not to assess whether you are able to repeat parts of the message word for word. You have to be able to summarize the message in your own words so that the examiner can assess your knowledge of French and your ability to synthesize information. Furthermore, being able to produce complete and complex sentences is crucial."
							}
						}
					]
				}
			],
			"index": 1,
			"label": "Message 2",
			"content": {
				"audio": "/wp-content/uploads/2013/12/message-21.mp3",
				"audioLabel": "message 2",
				"script": "Bonjour M. Dupont, j’ai le plaisir de vous annoncer que vous avez réussi avec succès la première étape de notre concours pour le poste de directeur-adjoint à la division des communications.  Par conséquent, vous êtes convoqué à une entrevue qui aura lieu dans nos locaux le jeudi 3 mars à 15 heures.  Pourriez-vous m’appeler au 613-444-1919 pour confirmer votre présence.  Merci et à bientôt!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a4.mp3",
							"audioLabel": "q4-a",
							"script": "Pourriez-vous résumer ce dialogue?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b4.mp3",
							"audioLabel": "q4-b",
							"script": "Faites un court résumé de l’enregistrement."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-i.mp3",
							"audioLabel": "p2-i",
							"script": "C’est une conversation entre un gestionnaire, M. Martin, et un de ses employés, Rose à propos d’une situation délicate. Le gestionnaire dit qu’il avait remarqué qu’elle arrivait à 10h au lieu de 9h pendant la semaine, mais il a utilisé un ton professionnel pour annoncer le problème. Elle dit que c’est pour des raisons personnelles avec ses parents. Il a proposé qu’elle continue à entrer plus tard mais elle doit finir à 18h. Elle accepte et les deux sont contents."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-j.mp3",
							"audioLabel": "p2-i",
							"script": "Le dialogue est une conversation entre M. Martin et une de ses employés. Il note qu’elle arrive souvent tard, à 10h au lieu de 9h le matin et il demande si elle a quelques problèmes. Elle explique que sa mère est malade, qu’elle est à l’hôpital et que c’est la raison pour ses retards. Le patron propose qu’elle reste à son bureau une autre heure chaque jour afin de terminer son travail."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-g.mp3",
								"audioLabel": "wp2-gp2-h",
								"script": "Le dialogue est une conversation entre M. Martin et une de ses employés. Il note elle arrive souvent tard à 10 h au lieu de 9h et il demande à elle, elle a quelques problèmes et elle note sa mère est malade, elle est à l’hôpital et ça c’est la raison pour son retard. Le patron propose elle reste à son bureau une autre heure chaque journée afin de terminer son travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-h2.mp3",
								"audioLabel": "wp2-gp2-h",
								"script": "Do not omit the “que” in indirect declarative sentences nor the “si” in indirect interrogative sentences. These omissions make the message unclear."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-h.mp3",
								"audioLabel": "wp2-hp2-i",
								"script": "C’est une conversation entre un gestionnaire, M. Martin, et une de ses employés, Rose. La raison de la conversation est de discuter de ses horaires. Selon le monsieur, depuis une semaine Rose arrive au bureau plus tard et lui demande si elle a une raison pour ça. Rose dit que c’est vrai et que c’est pour une raison personnelle. Rose dit que sa mère est hospitalisée et qu’elle doit s’occuper de son père le matin et qu’elle est très fatiguée et c’est la raison pour laquelle elle arrive en retard chaque journée. Et la solution du gestionnaire est que Rose travaille les heures supplémentaires à la fin de la journée juste pour assurer qu’elle travaille les heures nécessaires. Rose est d’accord avec la suggestion de son gestionnaire parce que sa sœur peut s’occuper de son père le soir. J’ai trouvé que la conversation avait un ton formel et que le gestionnaire a bien fait son intervention. En somme, la discussion s’est bien terminée et tout le monde était heureux de la décision, surtout Rose."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-i1.mp3",
								"audioLabel": "wp2-hp2-i",
								"script": "This response is quite valid, but it is unduly long. It is not necessary to repeat all the details of the dialogue in order to summarize the problem and solution. Furthermore, contrary to Part 4, you are not expected to provide your opinion about the tone of the dialogue. Part 2 is designed to assess your comprehension and not your ability to discern the subtleties of a dialogue."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a3.mp3",
							"audioLabel": "q5-a",
							"script": "Quel est le but de la rencontre ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-c3.mp3",
							"audioLabel": "q5-c",
							"script": "Quelle est la raison de l’entretien ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-k.mp3",
							"audioLabel": "p2-k",
							"script": "La raison de la conversation est de discuter des horaires de Rose. M. Martin dit qu’elle arrive plus tard depuis une semaine et il veut savoir si elle a une raison pour ça."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-l.mp3",
							"audioLabel": "p2-l",
							"script": "M. Martin veut rencontrer Rose parce qu’elle arrive 1h en retard le matin depuis une semaine. Il veut savoir si elle a un problème avec son horaire."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-i.mp3",
								"audioLabel": "wp2-imini1-a",
								"script": "M. Martin demande à Rose pourquoi elle est en retard le matin. Elle dit qu’elle a un problème personnel : son mari est hospitalisé et elle a besoin de faire attention de son père dans le matin."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini1-a.mp3",
								"audioLabel": "wp2-imini1-a",
								"script": "This person is not answering the question that is being asked and is instead giving a summary of the dialogue. Pay close attention to the key words in the dialogue. When the term “mari” is used instead of “mère”, the examiner might detect a comprehension problem."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-j.mp3",
								"audioLabel": "wp2-jmini1-b",
								"script": "L’horaire de Rose doit être modifié pour qu’elle entre travailler plus tard."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini1-b.mp3",
								"audioLabel": "wp2-jmini1-b",
								"script": "This statement does not answer the question correctly. The purpose of the meeting does not involve the changes that must be made or the solution that has been found. It is necessary to fully understand the question before responding since the examiner can think there is a comprehension problem. "
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q6-a2.mp3",
							"audioLabel": "q6-a",
							"script": "Quelle est la conclusion de la discussion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q6-b2.mp3",
							"audioLabel": "q6-b",
							"script": "Quelle est la solution du dialogue?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-m.mp3",
							"audioLabel": "p2-m",
							"script": "Parce que Rose a des problèmes personnels avec sa famille, M. Martin propose qu’elle termine à 18h chaque jour pour terminer ses tâches. Elle a dit que c’était bien pour elle alors ils ont terminé en établissant un nouvel horaire pour Rose."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-n.mp3",
							"audioLabel": "p2-n",
							"script": "Le gestionnaire décide que Rose peut changer son horaire de travail pour faire des heures supplémentaires à la fin de la journée. Rose est en accord avec la suggestion de son gestionnaire et la conversation très formelle se termine bien."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-k.mp3",
								"audioLabel": "wp2-kmini1-c",
								"script": "M. Martin propose à Rose de travailler un peu plus tard jusque 18h dans le soir de régler le problème et de compléter ce tâches. Elle va pouvoir entrer plus tôt de s’occuper de sa mère."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini1-c.mp3",
								"audioLabel": "wp2-kmini1-c",
								"script": "Pay close attention to use of connectives. Use “pour” or “afin de” to indicate purpose rather than “de”."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-l.mp3",
								"audioLabel": "wp2-lmin1-d",
								"script": "La solution que M. Martin a trouvée est de laisser Rose arriver en retard mais elle doit partir plus tard pour terminer ses tâches. C’est une bonne idée pour elle parce qu’elle peut s’occuper…de son enfant ?"
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini1-d.mp3",
								"audioLabel": "wp2-lmin1-d",
								"script": "If ever you forget some detail, it is better to deal with it by simply leaving it out rather than risk making a mistake. If the examiner wants to clarify a point, he will ask further questions to determine your level of comprehension."
							}
						}
					]
				}
			],
			"index": 2,
			"label": "Conversation",
			"content": {
				"audio": "/wp-content/uploads/2013/12/mini-dialogue-11.mp3",
				"audioLabel": "mini-dialogue 1",
				"script": "-M. Martin : Bonjour Rose, entre!  J’aimerais te parler d’un problème que j’ai remarqué concernant tes horaires.-Rose : Oui bonjour M. Martin, que se passe-t-il?-M. Martin : Eh bien voilà, je me suis rendu compte que depuis une semaine tu arrivais tous les matins à 10 heures au lieu de 9 heures.  Aurais-tu un problème?-Rose : Eh bien oui, j’ai quelques problèmes personnels en ce moment.  Ma mère est hospitalisée et je dois m’occuper de mon père le matin.-M. Martin : Ah, je suis désolé pour toi.  Si tu veux rentrer plus tard le matin, je peux te proposer de rester jusqu’à 18 heures le soir pour que tu puisses terminer ton travail.-Rose : Oui, merci beaucoup!  Cela m’arrange bien car ma sœur pourra prendre le relais le soir.-M. Martin : Très bien!  Tout va bien alors!  Bonne journée Rose!-Rose : Merci, à vous aussi!"
			}
		},
		{
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a5.mp3",
							"audioLabel": "q4-a",
							"script": "Pourriez-vous résumer ce dialogue ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b6.mp3",
							"audioLabel": "q4-b",
							"script": "Faites un court résumé de l’enregistrement."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-o.mp3",
							"audioLabel": "p2-o",
							"script": "C’est une courte conversation entre Arthur et Mme Bertha au sujet du manque de coopération d’un des collègues d’Arthur. Il explique à sa patronne que Jean Lamoureux est en retard sur sa partie du travail. Elle comprend le problème et affirme qu’elle lui parlera cette après-midi.  "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-p.mp3",
							"audioLabel": "p2-p",
							"script": "Arthur rencontre Mme Bertha pour lui dire d’une situation délicate. Il explique qu’un de ses collègues ne termine pas son travail à temps et qu’il n’écoute pas lorsqu’il lui demande de le faire. La patronne va rencontrer le collègue cette après-midi pour lui dire de rattraper son retard."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-m.mp3",
								"audioLabel": "wp2-mmini2-a",
								"script": "Arthur vient voir la femme pour lui dire que quelqu’un dans l’équipe est en retard dans son travail. Elle va lui dire de se dépêcher."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-a.mp3",
								"audioLabel": "wp2-mmini2-a",
								"script": "This response could be considered acceptable for a B level learner. In order to reach the C level, it is necessary to deliver a clearer response and to expand on what you have said. "
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-n.mp3",
								"audioLabel": "wp2-np2-j",
								"script": "C’est une conversation entre Arthur et quelqu’un d’autre, je ne me souviens plus. Cette conversation est au sujet d’un problème avec un employé ou un collègue, je n’ai pas bien compris, et je pense que l’homme est fâché parce qu’un autre homme, j’ai oublié son nom, n’a pas terminer le travail. La femme va lui parler, je pense, pour qu’il travaille plus vite."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-j1.mp3",
								"audioLabel": "wp2-np2-j",
								"script": "It is better not to mention that you did not grasp some element or name. If you have not noted everything, use a synonym or try to get around it by explaining what you mean. The examiner might overlook the gasps in your summary if you do not mention them. Should he require further details, he will not hesitate to ask more questions."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a5.mp3",
							"audioLabel": "q5-a",
							"script": "Quel est le but de la rencontre ?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b7.mp3",
							"audioLabel": "q5-b",
							"script": "Quelle est l’objet de la conversation ?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-q.mp3",
							"audioLabel": "p2-q",
							"script": "La raison pour laquelle Arthur veut voir Mme Bertha est parce qu’il a un problème avec un collègue et il veut qu’elle s’en occupe."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-r.mp3",
							"audioLabel": "p2-r",
							"script": "L’objet de la conversation est le manque de coopération de Jean Lamoureux par rapport aux échéances du projet Corneille. Il fait part de ses observations à Mme Bertha pour qu’elle règle le problème."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-o.mp3",
								"audioLabel": "wp2-omini2-b",
								"script": "Le but de la rencontre est de dire à Mme Bertha que Jean Lamoureux ne travaille pas bien."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-b.mp3",
								"audioLabel": "wp2-omini2-b",
								"script": "This response is more or less accurate. You have to be objective and stick to the facts when explaining a dialogue. The learner must generally avoid giving his opinion in this part of the Test.  "
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-p.mp3",
								"audioLabel": "wp2-pmini2-c",
								"script": "Arthur rencontre sa patronne parce qu’il veut lui dire que quelqu’un prend du retard dans le travail de groupe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-c.mp3",
								"audioLabel": "wp2-pmini2-c",
								"script": "This response gets off to a good start. However, a good explanation requires more details. The examiner will ask you to continue in order to determine your level of comprehension. (Yes, Arthur is meeting Mrs. Bertha to discuss a problem, but is it only to express his discontent? No, he wants to find a solution to the problem…)."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q6-a4.mp3",
							"audioLabel": "q6-a",
							"script": "Quelle est la conclusion de la discussion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q6-b4.mp3",
							"audioLabel": "q6-b",
							"script": "Quelle est la solution du dialogue?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p2-s.mp3",
							"audioLabel": "p2-s",
							"script": "Mme Bertha va avertir Jean Lamoureux cette après-midi qu’il est en retard dans son travail. Elle veut qu’il rattrape son retard pour que le reste de ses collègues soient contents."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p2-t.mp3",
							"audioLabel": "p2-t",
							"script": "La patronne va s’occuper du problème parce qu’elle comprend la situation d’Arthur. Elle va parler au collègue en retard cette après-midi pour lui dire de se rattraper dans son travail."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-q.mp3",
								"audioLabel": "wp2-qp2-l",
								"script": "Mme Bertha a répondre, non a répondu qu’elle aurait… allait parler à, au collègue de… pardonnez-moi, je vais recommencer. Mme Bertha a répondu à l’employé qu’elle va rencontrer son euh… le collègue pour lui dire de se rattraper dans son euh… le travail cette après-midi."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p2-l1.mp3",
								"audioLabel": "wp2-qp2-l",
								"script": "It is not necessary to use indirect discourse with the past tense in this part of the Test. In this particular case, the candidate is hesitating so much that the message is becoming unclear. It would be preferable to simplify the formulation of the sentence in order to deliver a clearer message."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp2-r.mp3",
								"audioLabel": "wp2-rmini2-d",
								"script": "Mme Bertha a une solution. Elle va parler à Arthur du travail en retard et il va la rencontrer cette après-midi pour lui dire de se dépêcher."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/mini2-d.mp3",
								"audioLabel": "wp2-rmini2-d",
								"script": "This response is inaccurate. In this case, the candidate has chosen the wrong information. (Mrs. Bertha is going to talk to Jean Lamoureux and not to Arthur). You must be careful to choose the right information in the right place."
							}
						}
					]
				}
			],
			"index": 3,
			"label": "Conversation 2",
			"content": {
				"audio": "/wp-content/uploads/2013/12/mini-dialogue-21.mp3",
				"audioLabel": "minidialogue2",
				"script": "-Arthur: Bonjour Madame Bertha. Puis-je entrer ? -Mme Bertha: Bien-sur, assied-toi. Qu’est-ce qu’il ya ?-Arthur: J’aimerais vous parler d’un sujet délicat.-Mme Bertha: D’accord, je t’écoute.-Arthur: Vous savez que nous travaillons en groupe sur le dossier Corneille. Nous avons remarqué qu’un de nos collègues, Jean Lamoureux, est très en retard sur sa partie du travail. Nous lui avons transmis nos inquiétudes face aux délais préétablis et lui avons demandé d’être plus coopératif mais il n’est pas très réceptif.-Mme Bertha: Oh, je vois, Eh bien, je te remercie d’être venu me voir. Je vais lui en parler cette après-midi pour qu’il rattrape son retard. -Arthur: Merci beaucoup et au revoir. -Mme Bertha: Au revoir"
			}
		}
	]
};


export const LEVELC_PART3 = {
	"label": "part 3",
	"index": 2,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-3-LEVEL-C.mp4",
	"description": "Talk with follow-up questions: " +
		"1. The assessor proposes three topics for the talk. " +
		"2. You choose one topic and have a minute and a half to prepare for your talk. " +
		"3. Your talk should last approximately two to three minutes. " +
		"4. After your talk, you will be asked to answer follow-up questions. " +
		"5. Duration: 10 to 12 minutes.",
	"sections": [
		{
			"talkContent": {
				"index": 0,
				"label": "Topic 1 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q16-a1.mp3",
						"audioLabel": "q16-a",
						"script": "Quel est pour vous le gestionnaire idéal?"
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q16-b1.mp3",
						"audioLabel": "q16-b",
						"script": "Décrivez-moi ce qu’est pour vous un bon gestionnaire."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q16-c1.mp3",
						"audioLabel": "q16-c",
						"script": "Selon vous, quelles sont les qualités d’un bon gestionnaire?"
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-a1.mp3",
						"audioLabel": "p3-a",
						"script": "Je voudrais décrire un bon gestionnaire.  Au début, je dirais qu’il y a beaucoup de personnes qui diraient que la chose importante est d’avoir un leader qui est très dynamique et un bon motivateur pour tous les employés et ces éléments pourraient être très très importants mais selon moi, il y a autres choses qui sont plus importantes.  Permettez-moi de décrire quatre choses.Premièrement, selon moi, il faut qu’un bon gestionnaire ait une vision du groupe, c’est-à-dire les priorités.  Il doit être quelqu’un qui gère avec une vision globale et qui ne gère pas la situation jour après jour. Il y a une relation entre mon premier et mon deuxième argument.  Il faut que le gestionnaire reconnaisse la différence entre les choses urgentes et les choses importantes parce que c’est vraiment facile de passer trop de temps en ce qui concerne les enjeux quotidiens pendant que le gestionnaire ignore les choses importantes pour l’avenir.Troisièmement, je dirais qu’un bon gestionnaire doit être juste et transparent avec tous ses employés parce qu’il faut qu’il établisse une milieu de travail où tous les analystes sont à l’aise et où tous les analystes ont le sentiment que leur patron est juste.Et finalement, je dirais que un bon gestionnaire est quelqu’un qui peut travailler en équipe avec tous ses collègues : ses homologues, ses supérieurs, ses employés.  Puisque les relations interpersonnelles en milieu de travail sont très importantes et même si le gestionnaire est très intelligent, s’il n’est pas capable de maintenir les relations effectives avec ses collègues, ça ne marcherait pas selon moi.\nDonc, pour conclure, je noterais que il y a beaucoup de styles de leadership et de gestion divers et il n’y a pas d’approche parfait, mais enfin la chose la plus importante est d’avoir une vision, un sens d’équité, l’habileté de créer une vision pour le groupe et la capacité de maintenir les relations effectives avec tous ses collègues."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-b1.mp3",
						"audioLabel": "p3-b",
						"script": "J’aimerais vous décrire ce qu’est, selon moi, le gestionnaire idéal.  Tout d’abord dans la fonction publique, il y a différents styles de gestionnaires.  Selon moi, un gestionnaire idéal a trois différents éléments. Premièrement, ce type de gestionnaire devrait avoir la capacité de motiver son groupe, c’est-à-dire que il tiendrait compte des connaissances de son équipe avant de prendre ses décisions.  Ensuite, concernant la deuxième élément, un gestionnaire idéal devrait être intelligent, c’est-à-dire que cet individu serait très organisé, si bien que les demandes seraient claires.  Il devrait répartir tous les dossiers entre les membres de son équipe pour que cette équipe respecte toutes les échéances.  Ensuite, il faudrait que ce type de gestionnaire respecte tous les membres de son équipe, dans le but que ses membres restent pendant une longue période de temps et de plus, aiment leur travail. Pour conclure, selon moi, un gestionnaire idéal c’est quelqu’un qui est un vrai leader, c’est-à-dire que ce gestionnaire pourrait bien motiver son groupe pour que chacun offre ses meilleurs efforts."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-c2.mp3",
						"audioLabel": "p3-c",
						"script": "Le gestionnaire idéal pour moi, c’est un gestionnaire avec beaucoup d’énergie, c’est un optimiste, c’est un gestionnaire qui est positif et honnête dans son rapport avec les autres. En effet, ce n’est pas un gestionnaire qui dit une chose un jour et le lendemain le contraire.  C’est un gestionnaire qui est toujours présent et à la disposition de ses employés, en particulier maintenant parce que il y a beaucoup de fonctionnaires qui prendront leur retraite à l’avenir donc il y aura un manque de ressources nécessaires pour faire le travail.  Donc c’est nécessaire que le gestionnaire soit disponible. C’est aussi un gestionnaire qui crée et communique une vision tout en stimulant l’enthousiasme et l’engagement de ses employés et qui crée une synergie parmi eux.  Il assume la responsabilité de la vision.  Il donne l’exemple par son comportement et il explique aux membres de l’équipe qu’ils doivent eux-mêmes influencer le changement dans le milieu de travail.  C’est-à-dire que les employés ont le pouvoir de faire le changement eux-même, ce n’est pas nécessairement la responsabilité du gestionnaire de faire tous les changements.\nEt si j’avais un gestionnaire avec tous les critères que j’ai soulignés ici, je serais très content."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-d2.mp3",
						"audioLabel": "p3-d",
						"script": "Selon moi, le gestionnaire idéal a besoin de beaucoup de qualités différentes, des qualités d’un leader et aussi des qualités d’un bon gérant.Premièrement, il doit avoir une grande vision de le travail de son bureau, et la capacité de créer un environnement où tous les travaillants, les employés sont capables de comprendre cette vision.  Il est aussi nécessaire que le gestionnaire dépense de l’énergie au travail, par exemple, il doit travailler fort afin d’être un modèle pour ses employés, il doit être intéressé par le travail et puis il doit donner son énergie à le travail. Quand il fait ça, il est un modèle pour les employés. Aussi plus que ça le gestionnaire idéal doit connaître ses employés, il est nécessaire qu’il comprenne les qualités de chaque employé et qu’il s’assure que chaque employé est capable de faire le travail ou les tâches qui lui sont assignées.Enfin, un gestionnaire idéal doit être les deux : un leader avec une vision et des qualités de leadership et aussi un bon gérant quelqu’un qui est capable de créer un environnement où ses employés sont capables de faire les tâches en maintenant une bonne santé et avec les outils et qui sont nécessaires pour faire les tâches."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-a2.mp3",
							"audioLabel": "wp3-a",
							"script": "En ce qui concerne un gestionnaire idéal, d’abord et avant tout, je dois dire qu’étant donné que je suis un employé expérimenté, je veux avoir un gestionnaire qui délègue le travail aux gestionnaires, qui n’est pas une personne qui veut contrôle les activités quotidiennes de ses employés.  De plus un gestionnaire qui partage les responsabilités de gestion avec son équipe de gestionnaires parce que, à ce point dans ma carrière, mon patron est au niveau directeur, alors on forme l’équipe de gestion pour notre division. Ma réponse certainement est différente aujourd’hui qu’elle aurait été il y a 10 ou 15 ans, mais ça c’est en raison de l’augmentation de mon expérience.  De plus, vraiment pour avoir un bon défi au travail et pour rester motivé il faut que je choix les directions où il y a les grands défis parce que pendant cinq ans, j’ai travaillé à l’Agence de revenu.  Lorsque je suis arrivé, l’agence venait d’établir la direction d’approvisionnement et on a eu besoin d’établir toute l’équipe et acheter des systèmes informatiques et cetera, et mon directeur là-bas a délégué les responsabilités aux membres de son équipe et nous avons participé dans la gestion.  Dans mon poste actuel, nous avons un autre défi parce que c’est la première fois depuis 25 ans que le gouvernement a fait construire les grands navires et il faut y établir les compétences au sein de notre équipe.\nDonc, en conclusion, je suis chanceux parce que avec mon patron actuel et mon ancien patron à l’Agence de revenu j’ai au deux exemples de gestionnaires idéals pour moi et je me sens à l’aise dans les deux postes."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-a2.mp3",
							"audioLabel": "p3-a",
							"script": "The candidate is delivering a well-structured response using sound grammar. However, he is not answering the question directly. Although his response is addressing the topic of management, what he is saying about it is beside the point."
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-b2.mp3",
							"audioLabel": "wp3-b",
							"script": "J’aimerais vous décrivez selon moi le gestion idéal.  Tout d’abord dans la service public, ils sont différents styles de gestionnaires.  Selon moi, un gestion idéal a trois différents éléments. Premièrement, ce type de gestion devrait avoir tous les capacités de motiver sa groupe, c’est-à-dire que il tiendrait compte de leur connaissance avant de faire ses décisions.  Ensuite, concernant la deuxième élément, un gestion idéal serait être intelligente, c’est-à-dire que ce individu serait être trop organisé, si bien que les demandes est claires.  Il devrait répartir tous dossiers entre membres de sa équipe pour que ce équipe respect tous les échéances.  Ensuite, il faudrait ce type de gestion respect tous les membres de sa équipe, dans le but de ses membres restent pendant un période de temps long et de plus, aiment ses travails. Pour conclu, selon moi, un gestion idéal c’est quelqu’un qui est vrai leader, c’est-à-dire que ce gestionnaire pouvait bien motiver sa groupe pour que chaque offre meilleurs efforts."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-b2.mp3",
							"audioLabel": "p3-b",
							"script": "Minor mistakes are acceptable provided that they are not made systematically. In this case, there are so many that the listener has trouble understanding the message. At the C level, frequent basic mistakes (agreement in number and gender, common anglicisms…) must be avoided."
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-c2.mp3",
							"audioLabel": "wp3-c",
							"script": "Selon moi, le gestionnaire idéal a besoin beaucoup de qualités différentes, des qualités d’un leader et aussi les qualités d’un bon gérant.Premièrement, il doit avoir une grande vision de le travail de son bureau, et la capacité de créer un environnement où tous les employés sont capables de comprendre cette vision.Deuxièmement, le gestionnaire idéal doit connaître ses employés, il est nécessaire qu’il comprenne les qualités de chaque employé.Aussi une gestionnaire idéal, hum…  Je n’ai pas de troisième idée.En somme, voilà les qualités un gestionnaire idéal.  Si mon gestionnaire était comme ça, je serais content."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-c3.mp3",
							"audioLabel": "p3-c",
							"script": "This presentation is too short. The examiner requests that you speak for three minutes so that he will be able to accurately assess your language skills. Make good use of this time; it’s your opportunity to impress the examiner!"
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a11.mp3",
							"audioLabel": "q2-a",
							"script": "Croyez-vous que le leadership soit une qualité essentielle à un bon gestionnaire?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b7.mp3",
							"audioLabel": "q2-b",
							"script": "Le leadership est-il indispensable pour être un bon gestionnaire?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q2-c7.mp3",
							"audioLabel": "q2-c",
							"script": "Un gestionnaire doit-il nécessairement être un bon leader?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-e2.mp3",
							"audioLabel": "p3-e",
							"script": "Certaines personnes disent que le leadership est une qualité clé pour être un bon gestionnaire parce qu’elles pensent que chaque poste de gestionnaire exige une personne qui est capable de mener le changement.  Cependant il y a plusieurs postes de gestion au sein de la fonction publique et bien que la responsabilité clé de certains postes soit le leadership dans les temps de grands changements, il y en a plusieurs autres où les compétences en administration, en développement du personnel et les compétences à établir des normes sont plus importantes et je trouve que des compétences comme ça peuvent être formées chez les employés.  Après avoir reçu cette formation, les personnes qui manquent les qualités innées de leader peuvent devenir de bons gestionnaires et peuvent gagner le respect de leurs employés et de leurs patrons.  Donc, en conclusion, selon moi, le leadership est nécessaire dans une situation de changement, mais il y a plusieurs postes de gestionnaire où on peut former les personnes qui manquent de compétences."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-f2.mp3",
							"audioLabel": "p3-f",
							"script": "C’est une question difficile.  Il est nécessaire qu’un bon gestionnaire ait des qualités de leader ou de leadership, mais enfin, il est possible d’être un bon gestionnaire sans ces qualités. Ce sont les meilleurs gestionnaires qui ont cette qualité et d’habitude, à la fonction publique, ils n’ont pas cette qualité et cela les empêche d’être des gestionnaires très performants.  En somme, on peut être un bon gestionnaire sans la qualité de leadership, mais c’est mieux d’être aussi un leader à mon avis"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-g2.mp3",
							"audioLabel": "p3-g",
							"script": "Oui, comme gestionnaire, c’est nécessaire d’avoir la qualité de leader.  Un leader pour moi c’est une personne avec du charisme, une vision, de l’énergie pour les autres qui doivent suivre.  Si un gestionnaire manque les capacités de motiver l’équipe, c’est difficile d’atteindre les objectifs.  Mais le gestionnaire c’est plus qu’un leader.  Comme gestionnaire, c’est nécessaire de créer les occasions pour les autres pour l’avancement dans leur carrière aussi, de donner la chance pour la formation.  Donc, le leadership c’est seulement une partie des qualités requises afin d’être un bon gestionnaire.  Voilà en bref, c’est ce que je pense."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-h2.mp3",
							"audioLabel": "p3-h",
							"script": "Selon moi, c’est très important qu’un gestionnaire ait tous les qualités d’un leader, mais un leader n’est pas juste un gestionnaire.  Selon moi, d’un côté, un gestionnaire c’est quelqu’un qui organise les affaires de bureau, qui établit les priorités et puis qui respecte les échéances.  D’un autre côté, un leader c’est quelqu’un qui motive fort ses employés pour qu’ils travaillent le mieux possible.  Pour conclure, selon moi, la fonction publique doit avoir beaucoup plus de leaders et si j’avais l’expérience de travailler en étroite collaboration avec un leader, j’aimerais rester là pendant une longue période de temps."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-d2.mp3",
								"audioLabel": "wp3-d",
								"script": "Oui, c’est un qualité essentiel pour un bon gestionnaire je pense."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-d3.mp3",
								"audioLabel": "p3-d",
								"script": "Do not hesitate to expand on your ideas and to provide examples in order to illustrate what you want to say. The examiner is providing you with the opportunity to express yourself, so take advantage of it."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-e3.mp3",
								"audioLabel": "wp3-e",
								"script": "C’est une question difficile.Il est nécessaire qu’un bon gestionnaire ait des qualités de leader ou de leadership si bien qu’il soit un gestionnaire ultra-performant, mais enfin il est possible d’être un bon gestionnaire sans cette qualité, c’est-à-dire d’avoir plus de qualités d’un gestionnaire que d’un leader. Ce sont évidemment les meilleurs gestionnaires qui ont cette qualité, mais d’habitude beaucoup de gestionnaire lui manque cette qualité quoique mon gestionnaire soit un bon leader de manière qu’il fasse du bon travail.  En un mot, le leadership est important dans la mesure où il n’est pas essentiel."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-e3.mp3",
								"audioLabel": "p3-e",
								"script": "This response makes abundant use of connectives and of the subjunctive mood. However, this excessive use of complex structures makes the response awkward and hard to follow. Furthermore, connectives are not used logically in every case. It is sometimes better to simplify an answer rather than risk making it incomprehensible."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-f2.mp3",
								"audioLabel": "wp3-f",
								"script": "Oui, euh… comme… comme gestionnaire, c’est important, non pardonnez-moi, c’est nécessaire d’avoir la qualité de leader.  Un leader pour moi euh… c’est une personne avec le charisme, le vision, non excusez-moi la vision, non le vision et euh… l’énergie pour les autres doivent suivre.  Si un gestionnaire manquerait, non aurait manqué, non manquait les capacités de motiver l’équipe, ce serait difficile d’atteigner, non d’atteindre, excusez-moi, les objectifs.  Mais euh… le gestionnaire euh… c’est plus de, non que un leader.  Comme gestionnaire, c’est nécessaire, non primordial de créer les opportunités pour les autres pour l’avancement dans leur carrière aussi, de donner la chance pour la formation.  Donc, euh… le leadership euh… c’est seulement un partie, non une partie, excusez-moi de la qualité requier, requiè, non requise afin d’être un bon gestionnaire.  Voilà en bref, c’est ce que je pense."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-f3.mp3",
								"audioLabel": "p3-f",
								"script": "Of course, it’s all right to self-correct mistakes. You must, however, manage to limit instances of self-correction, since frequent self-correction may make it very hard for the listener to follow what you are saying. Try to keep this under control and, should this be too difficult to do, simplify your answers. "
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a10.mp3",
							"audioLabel": "q3-a",
							"script": "Selon vous, que doit faire un bon gestionnaire pour maintenir la motivation de ses employés?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b9.mp3",
							"audioLabel": "q3-b",
							"script": "D’après votre expérience, comment un bon gestionnaire fait-il conserver la motivation de son équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q3-c6.mp3",
							"audioLabel": "q3-c",
							"script": "À votre avis, que fait un bon gestionnaire pour garder son équipe motivée?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-i2.mp3",
							"audioLabel": "p3-i",
							"script": "Il y a beaucoup d’occasions où le gestionnaire peut donner l’occasion à l’équipe de rester en forme, d’être motivé.  Par exemple, c’est important que le gestionnaire parle avec ses employés, chaque employé, chaque jour si c’est possible et aussi qu’il offre de  la reconnaissance pour le bon travail.  C’est important de souligner les petits problèmes, mais aussi de donner l’encouragement pour l’avenir.  Aussi, c’est nécessaire pour le gestionnaire de bien écouter l’opinion d’autrui et d’offrir le travail qui est stimulant à chacun.  C’est une façon d’améliorer les relations entre le travailleur et les gestionnaires, mais c’est aussi possible d’avoir une bonne relation au sein de l’équipe avec les activités sociales comme le bowling, peut-être le volley-ball, un repas ensemble ou seulement une activité ensemble.  Donc avec tous les activités comme ça et avec la bonne direction du gestionnaire, je pense que c’est possible pour l’équipe de rester motivée."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-j2.mp3",
							"audioLabel": "p3-j",
							"script": "Pour ma part, concernant la motivation des employés, un gestionnaire doit tenir compte des connaissances et des opinions de l’équipe avant de prendre certaines décisions.  De plus, ce type de gestionnaire confie des dossiers en pensant aux compétences et aux intérêts des employés.  Enfin, pour mieux motiver les employés, un gestionnaire pourrait garder sa porte ouverte pour maintenir une bonne communication."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-k2.mp3",
							"audioLabel": "p3-k",
							"script": "Selon moi, un bon gestionnaire doit travailler avec son équipe pour qu’elle conserve son intérêt dans le travail. Il est nécessaire que il soit plus qu’un gérant et à mon avis il doit être un leader, il doit être un modèle pour ses employés.  Lorsqu’un gestionnaire est aussi un leader, il peut inspirer son équipe et ça c’est une bonne source de motivation donc selon moi, le leadership et la collaboration sont essentiels."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-l2.mp3",
							"audioLabel": "p3-l",
							"script": "À mon avis, je trouve que l’activité la plus importante pour un gestionnaire est la répartition du travail afin de maintenir la motivation.  Selon moi, il faut qu’un gestionnaire répartisse le travail également, mais ce n’est pas dire que il faut donner un nombre égal de dossiers à chaque employé.  Il faut choisir entre les dossiers en ce qui concerne la complexité de travail, l’occasion pour les employés d’améliorer leurs compétences avec certains dossiers clés pour le développement de la carrière.  En faisant cela, un bon gestionnaire peut motiver son équipe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-g2.mp3",
								"audioLabel": "wp3-g",
								"script": "Pour ma part, je trouve que l’activité la plus importante pour un gestionnaire est la répartition du travail.  Selon moi, il faut qu’un gestionnaire répartisse le travail également, mais ce n’est pas dire que il faille donner à chaque employé un nombre égal de dossiers.  Il faut choisir entre les dossiers en ce qui concerne la complexité du travail, l’occasion pour les employés d’améliorer leurs compétences avec certains dossiers clés pour le développement de la carrière.  De plus, je pense qu’un bon gestionnaire doit avoir l’idée qu’une équipe est toujours en train de changer, c’est-à-dire qu’il faut développer la nouvelle génération d’employés pour les niveaux supérieurs.  Il faut trouver les occasions pour donner les promotions et les occasions de développement aux employés et accepter de temps en temps qu’un bon jeune employé doive quitter pour avoir une chance de promotion ailleurs.  Je trouve qu’en particulier, au sein de la fonction publique, l’idée de changement de personnel est trop rapide et doit faire partie de l’évaluation d’un gestionnaire."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-g3.mp3",
								"audioLabel": "p3-g",
								"script": "The candidate is delivering a well-structured response using sound grammar. Nevertheless, he is not answering the question directly. Although the subject was accurately addressed at the beginning, the response strays altogether from the original topic, delivering an answer that is beside the point. It is sometimes better to ”cut it short” rather than risk getting off-topic."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-h2.mp3",
								"audioLabel": "wp3-h",
								"script": "Oui, je crois qu’un gestionnaire doit motiver son équipe.  C’est la responsabilité du gestionnaire de s’assurer que ses employés sont heureux avec le travail.  C’est évident que l’équipe doive aussi  communiquer avec son gestionnaire si elle n’est pas heureuse, si elle n’est pas motivée, mais c’est le gestionnaire qui a la plus grande part de responsabilité.  En effet, si un gestionnaire ne peut pas motiver son équipe, selon moi, il n’est pas un bon gestionnaire."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-h3.mp3",
								"audioLabel": "p3-h",
								"script": "It is necessary to pay close attention to the formulation of the question. This was an open-ended question, but the candidate responded to it as if it were a yes-or-no answer. This indicates a comprehension problem in spite of the sound grammar that is being used in the response.  "
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-i2.mp3",
								"audioLabel": "wp3-i",
								"script": "Je ne sais pas, je ne suis pas gestionnaire."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-i3.mp3",
								"audioLabel": "p3-i",
								"script": "It may be that you will be asked a question for which you do not have a response. This is not very serious if it occurs only once during the Test. In this type of situation, you should still keep a positive attitude by explaining why you cannot answer the question and kindly request that the examiner ask you a different question."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q4-a8.mp3",
							"audioLabel": "q4-a",
							"script": "Si vous deveniez gestionnaire à la place de votre patron, que changeriez-vous à son style de gestion?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q4-b9.mp3",
							"audioLabel": "q4-b",
							"script": "Si vous deviez prendre la place de votre patron, comment géreriez-vous l’équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q4-c4.mp3",
							"audioLabel": "q4-c",
							"script": "Si vous deviez remplacer votre patron, quels changements apporteriez-vous à sa façon de gérer l’équipe?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-m2.mp3",
							"audioLabel": "p3-m",
							"script": "C’est difficile à dire pour moi parce que je connais ma patronne depuis 20 ans et j’ai moi-même choisi de relever d’elle.  Donc certainement à sa place, je garderais l’habitude de déléguer le travail, de maintenir un environnement positif où on peut attirer et retenir les employés expérimentés parce que nos projets sont de très grande envergure. Néanmoins, je pense que si j’étais à la place de ma directrice, je prendrais le temps d’établir plusieurs normes en ce qui concerne les documents nécessaires pour les évaluations et les appels d’offre.  Aussi, j’établirais un poste de développement pour les agents de contrat pour les grands projets parce que je trouve qu’on aurait besoin de ce type de programme. "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-n2.mp3",
							"audioLabel": "p3-n",
							"script": "C’est une question difficile parce que j’admire ma patronne maintenant, mais si je devais la remplacer, j’aimerais augmenter mon budget pour avoir plusieurs activités sociales."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-o2.mp3",
							"audioLabel": "p3-o",
							"script": "Si je remplaçais mon directeur, je mettrais en place une façon de diminuer les étapes pour la dotation.  Je commencerais aussi à souligner les politiques, les lois et les règlements de notre équipe qui sont très importants pour les nouveaux arrivés.  Mais aussi, j’amorcerais un processus afin de diminuer le nombre de règles et politiques parce qu’avec ça je trouve que c’est une façon de diminuer l’efficacité du travail.  Je rencontrerais l’équipe plus fréquemment parce que je trouve que le directeur actuel rencontre seulement les autres gestionnaires donc il y a un vrai manque de communication entre les deux et pour moi, c’est un manque de respect pour les travailleurs dans l’équipe.  "
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-p2.mp3",
							"audioLabel": "p3-p",
							"script": "Si je prenais la place de mon patron, je ferais beaucoup de choses différemment.En priorité, si j’en étais capable, je changerais les postes et les classifications de quelques employés dans la section. Et aussi, si j’avais le soutien de mon patron, j’engagerais des discussions avec des membres de la GRC pour changer les relations entre les membres de mon équipe et ceux de la GRC."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-j2.mp3",
								"audioLabel": "wp3-j",
								"script": "C’est une question difficile parce que j’admire ma patronne maintenant, mais si j’avais dû remplacer ma patronne j’aurais aimé augmenter mon budget pour avoir plusieurs activités sociales."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-j3.mp3",
								"audioLabel": "p3-j",
								"script": "Whenever a hypothetical question is asked, pay special attention to the verb tenses that are used in order to re-use the right structures: present or past tense. Using  semiauxiliary verbs can lead to confusion; therefore, do not hesitate to practise these structures until they can be used naturally."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-k2.mp3",
								"audioLabel": "wp3-k",
								"script": "Si je prends la place de mon patron.  Non si je prendrais, prenais, si je serais prendre, non si je prenais la place de mon patron, je ferais beaucoup de choses différentes.  D’abord, si je serais capable, je changerais, non si j’étais capable, je changerais les postes et les classifications de quelques employés dans la section. Et aussi, si j’avais, j’étais, non j’avais le soutien de mon patron, je serais, non j’essaierais de commencer des discussions avec des membres de la GRC pour changer les relations entre les membres de mon équipe et les personnes de la GRC."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-k3.mp3",
								"audioLabel": "p3-k",
								"script": "When it comes to hypothetical questions, the trouble lies in the verbs. At the C level, the candidate should be able to formulate a hypothesis without too much trouble. It is not acceptable to correct yourself when using each verb in the sentence. Remember that practice makes perfect. Never stop practising!"
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-l2.mp3",
								"audioLabel": "wp3-l",
								"script": "Quand je remplace mon patron parce que parfois je suis gestionnaire intérimaire quand il est en vacances, je suis ses consignes et j’essaie de ne rien changer à sa gestion.  Je pense que mon patron est très bon et je le prends comme modèle pour gestionnaire donc je ne change rien.  Quand je serai gestionnaire, je crois que je ferai comme lui.  Je serai ouvert, sympathique, organisé, juste et j’aiderai mes employés comme mon gestionnaire actuel fait pour moi.  C’est lui qui m’encourage à devenir gestionnaire et j’aime bien le remplacer de temps en temps.  Il est vraiment excellent alors je ne change rien."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-l3.mp3",
								"audioLabel": "p3-l",
								"script": "The candidate does not seem to have grasped the fine points of the question, which is, in this case, a hypothetical question. The response is, therefore, inadequate. The grammar is sound, but it is absolutely necessary to respond to the question that is being asked; otherwise, it will be clear that the candidate has a comprehension problem."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q5-a6.mp3",
							"audioLabel": "q5-a",
							"script": "Dans quelle mesure le succès d’une équipe est-il dû au gestionnaire?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q5-b8.mp3",
							"audioLabel": "q5-b",
							"script": "Jusqu’à quel point un gestionnaire est-il responsable de la réussite de son équipe?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-q2.mp3",
							"audioLabel": "p3-q",
							"script": "C’est la responsabilité du gestionnaire, mais jusqu’à un certain point. Le gestionnaire c’est comme le capitaine de le bateau mais, il est très important que chaque employé crée un bon environnement de travail.  Cependant, c’est aussi important que le gestionnaire prenne les mesures nécessaires pour améliorer les capacités de travailler des employés donc s’il y a une personne qui reconnaît qu’elle a une faiblesse, c’est primordial que cet employé puisse suivre une formation ou qu’il obtienne de l’aide.  Donc en résumé, c’est d’abord la responsabilité du gestionnaire, mais c’est aussi la responsabilité de chaque employé.  "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-r2.mp3",
							"audioLabel": "p3-r",
							"script": "Selon moi, le gestionnaire est responsable de la réussite de l’équipe, mais jusqu’à un certain point parce qu’en réalité, ce sont les analystes qui sont les travailleurs qui font le travail à tous les jours.  Même si le gestionnaire est très très efficace, si il ou elle n’avait pas un bon groupe de travail, il serait difficile de faire un excellent travail.  En somme, le gestionnaire a un rôle à jouer, mais au fond, le succès de l’équipe c’est surtout la responsabilité des travailleurs, des analystes."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-s2.mp3",
							"audioLabel": "p3-s",
							"script": "À mon avis, un gestionnaire est responsable de la réussite de son équipe jusqu’à un certain point.  Selon moi, d’un côté un rôle important d’un gestionnaire est de bien motiver son groupe si bien que ses employés travaillent fort et respectent les échéances.  De l’autre côté, on pourrait avoir tous les ingrédients d’un bon leader, mais à la fin c’est la responsabilité de chacun d’être au bureau sans distraction et de travailler fort.  Donc, pour conclure, selon moi, c’est une combinaison entre les qualités d’un gestionnaire et la motivation de chacun dans l’équipe."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-t2.mp3",
							"audioLabel": "p3-t",
							"script": "Je pense que le rendement d’une équipe est relié au gestionnaire dans une grande mesure.  C’est le gestionnaire qui a la capacité d’attirer et de retenir les employés.  Aussi, je pense que c’est le gestionnaire qui est la personne la plus responsable pour établir l’ambiance au sein d’une équipe dans le sens positif ou négatif.  Lorsque le gestionnaire a une mauvaise réputation, on voit rapidement que le roulement de personnel devient un problème dans cette division.  En revanche, le gestionnaire n’est pas le seul membre de l’équipe alors les employés sont aussi responsables de leur travail.  Tout ça pour dire que c’est le gestionnaire qui est la personne clé pour établir l’ambiance de travail mais, ses employés doivent le suivre pour que l’équipe ait du succès"
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-m2.mp3",
								"audioLabel": "wp3-m",
								"script": "À mon avis la plupart des succès d’une équipe sont le résultat du bon travail d’un gestionnaire. Si une équipe n’a pas un bon leader, si l’équipe n’est pas bien gérée, il sera impossible pour l’équipe de réussir et donc d’être une bonne équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-m3.mp3",
								"audioLabel": "p3-m",
								"script": "In the case of dialectical questions, it is better to qualify your statements. It may happen that you have a clear-cut opinion on a subject; try, nevertheless, to qualify what you say about in the Test. This type of question allows the examiner to assess whether you are able to grasp the fine points of the question; therefore, you must deliver a subtle response in order to demonstrate this."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-n2.mp3",
								"audioLabel": "wp3-n",
								"script": "Selon moi, le gestionnaire est totalement responsable de la réussite, mais jusqu’à un certain point parce que la réalité c’est que ce sont les analystes qui font le travail chaque jour.  Même si le gestionnaire est très très efficace, si il ou elle n’a pas un bon groupe de travail, il serait difficile de faire de l’excellent travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-n3.mp3",
								"audioLabel": "p3-n",
								"script": "The first sentence of this response is contradictory: either someone is totally responsible for performing a task or he isn’t! Practise formulating responses to dialectical questions in order to avoid this type of mistake, which can easily be avoided."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-o2.mp3",
								"audioLabel": "wp3-o",
								"script": "Je pense que le rendement d’une équipe est relié au gestionnaire dans une grande mesure, y compris la capacité du gestionnaire d’attirer et de retenir les employés.  Aussi, je pense que c’est le gestionnaire qui est la personne la plus responsable pour établir l’ambiance au sein d’une équipe.  Lorsque le gestionnaire a une mauvaise réputation, on voit rapidement que le roulement du personnel devient un problème dans cette division.  Tout ça pour dire que c’est le gestionnaire qui est la personne clé pour établir l’ambiance de travail, pour avoir les bonnes politiques en ce qui concerne la gestion et le développement du personnel et on peut mesurer cela avec les statistiques de roulement du personnel."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-o3.mp3",
								"audioLabel": "p3-o",
								"script": "This response has two flaws: it does not deal with the subtleties of the question and it ends up being off-topic. Be sure to stay within the subject and to qualify your statements when you are dealing with a dialectical question.  "
							}
						}
					]
				}
			],
			"label": "Topic 1",
			"index": 0
		},
		{
			"talkContent": {
				"index": 1,
				"label": "Topic 2 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q17-a3.mp3",
						"audioLabel": "q17-a",
						"script": "Expliquez-moi comment vous restez motivé(e)?"
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q17-b3.mp3",
						"audioLabel": "q17-b",
						"script": "Comment faites-vous pour conserver votre motivation au travail?"
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q17-c4.mp3",
						"audioLabel": "q17-c",
						"script": "Expliquez-moi les moyens que vous utilisez pour garder votre motivation?"
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-u3.mp3",
						"audioLabel": "p3-u",
						"script": "Certainement, je travaille à la Commission dans l’unité des communications et dans cette unité, nous sommes vraiment préoccupés par le volume de travail donc il y a des moments où c’est difficile de rester motivé à cause de le stress, des tâches et aussi des relations avec les clients.  Donc pour moi c’est vraiment important de demeurer motivée pour effectuer un bon travail. Pour commencer, afin de rester motivée je fais attention à mon apprentissage parce que selon moi, c’est vraiment important d’acquérir de nouvelles compétences.  Je discute avec mes gestionnaires pour obtenir des formations à propos de certaines tâches ou d’avoir d’autres connaissances concernant notre travail.  Par exemple, nous avons récemment eu une formation pour travailler avec les autochtones parce qu’ils sont régis par certaines lois différentes et c’était très utile et intéressant.  Selon moi, apprendre est une excellente façon de rester motivée au bureau. Ensuite, je tire une grande fierté de mon travail donc c’est une bonne source de motivation quand je fais du bon travail dont je peux être fière ou quand j’aide mes collègues.  À mon avis, beaucoup d’employés ne sont pas fiers de leur travail et ça les démoralise.  Donc, en faisant un bon travail, je reste motivée au bureau.Enfin, les relations interpersonnelles au bureau sont vraiment importantes pour rester motivée.  Quand les collègues s’entraident c’est une bonne façon de rester motivée et de diminuer le stress.  Donc je prends le temps d’enrichir les relations interpersonnelles au bureau afin de faciliter la motivation et pour moi ça c’est vraiment important. Pour conclure, comme je l’ai dit, je me concentre sur les relations interpersonnelles, j’aime la formation et ensuite je fais un bon travail, car c’est bon pour la motivation. Donc ce sont les trois choses qui sont importantes pour moi afin d’avoir une bonne motivation au bureau."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-v3.mp3",
						"audioLabel": "p3-v",
						"script": "Pour moi, c’est une question intéressante parce que c’est la première fois qu’on me pose cette question. Toutes personnes pensent que mon travail est très intéressant parce que je travaille sur des crimes contre l’humanité.  Je mène des enquêtes sur les pires crimes au monde, donc je parle aux victimes de ces crimes et aussi aux coupables.  Mais pour moi, le problème est que c’est trop pour moi.  Les faits sont très durs, la loi est difficile et pour être motivé dans mon travail, c’est nécessaire que je trouve d’autres choses à faire, d’autres choses à lire sur d’autres sujets pour me changer les idées. En même temps, dans mon bureau, il y a beaucoup de choses administratives à faire et je n’aime pas beaucoup ce type de tâches.  Pour moi, c’est surtout une perte de temps et je me rends compte que de plus en plus, mon travail est celui d’un administrateur, d’un fonctionnaire, même si je voudrais être avocat.  Donc, pour être motivé encore, il est nécessaire pour moi de continuer mes études en droit et aussi d’avoir d’autres choses dans ma vie à côté du travail.  En somme, la plupart de mon travail est très intéressant et je suis très impliqué dans mon travail, mais comme je l’ai dit, je dois de temps en temps prendre un petit repos et chercher d’autres sujets et aussi me faire à l’idée que je suis plus qu’un avocat, je suis fonctionnaire aussi et donc, je dois faire les choses administratives."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-w3.mp3",
						"audioLabel": "p3-w",
						"script": "Les choses qui me motivent sont les défis en général. C’est intéressant mais à mon avis il y a quelques types différents de motivation et de défi. Pour moi le première défi est l’occasion de donner des conseils stratégiques concernant la communication à mes clients. Le deuxième est la nécessité de respecter les échéances et le troisième défi pour moi est la motivation de mon équipe. Et pour moi, ce sont les trois aspects de mon travail qui me motivent le plus.C’est vrai aussi que j’aimerais recevoir de la reconnaissance pour mes succès tout comme j’aime donner de la reconnaissance aux autres aussi, mais les trois défis représentent les plus importants aspects de mon travail.Ma capacité et les occasions de donner des conseil en communication stratégique me poussent le plus parce que ça demande  toutes mes exigences professionnelles et académiques.  Par exemple, pour bien gérer les problèmes dans les médias, il faut que je fasse la recherche nécessaire, que j’aie des conversation avec les clients et mes collègues aussi, et, c’est primordial que je trouve le problème et la solution en même temps. De plus, la division des communications est très occupée, il y a beaucoup d’échéances mais c’est vrai que j’adore les échéances pour me pousser à atteindre mes objectifs et le troisième est la motivation de mon équipe.Ça, ça représente probablement le défi le plus difficile de mon travail, parce que chaque membre de l’équipe possède des compétences différentes et des besoins différents. Et ça demande le plus de créativité pour moi, mais quand je suis capable de bien motiver mes employés  ça me donne beaucoup de confiance et une grande satisfaction au bureau aussi.  Voilà les défis que je relève pour rester motivée."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-x2.mp3",
						"audioLabel": "p3-x",
						"script": "Tout d’abord, en ce qui concerne la motivation, c’est important de faire un travail efficace, un travail exigeant et puis de respecter non seulement les échéances, mais aussi d’atteindre les objectifs, soit d’un projet, soit ne n’importe quel travail.  Et maintenant je voudrais dire quels sont les facteurs ou quels sont les critères qui renforcent la motivation au travail.Comme vous le savez, quand on travaille à la fonction publique, il y a beaucoup de restrictions, beaucoup de réglementation et à mon avis, la motivation c’est le défi que tous les employés doivent relever, mais il y a quelques outils qui nous aide à rester motivés.  Pour ma part, j’essaie de toucher à des sujets sur lesquels je n’ai jamais travaillé et pour y arriver, je poursuis mes études en vérifivation.  Aussi, le plus souvent possible, je participe à des colloques pour faire du réseautage et pour apprendre les nouveautés dans mon domaine comme les nouvelles techniques et les nouvelles approches pour faire un projet.  Finalement, je tente de prendre des initiatives en présentant les nouvelles façons de faire les choses pour continuer à évoluer et à mon avis ce sont quelques éléments que je fais pour rester motivée."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-p1.mp3",
							"audioLabel": "wp3-p",
							"script": "Les choses qui me motivent sont les défis en général.  Pour moi le premier défi est l’occasion de donner des conseil stratégiques concernant la communication à mes clients. Le deuxième est la nécessité de respecter des échéances et le troisième défi pour moi est la motivation de mon équipe. Et pour moi, ce sont les trois aspects de mon travail les plus motivants.Mais c’est vrai aussi que j’aime recevoir la reconnaissance pour mes succès en même temps que j’aime donner la reconnaissance aux autres aussi.Ma capacité et les occasions de donner le conseil des communications stratégiques me poussent le plus parce que ça demande toutes mes expériences professionnelles et académiques.  La division des communications est très occupée et il y a beaucoup d’échéances mais c’est vrai que j’adore les échéances pour me pousser à réaliser mes objectifs et le troisième est la motivation de mon équipe.Ça, ça représente probablement le plus difficile défi de mon travail, parce que chaque membre de mon équipe possède des compétences différentes et des besoins différents. Et ça demande le plus de créativité pour moi, mais quand je suis capable de bien motiver mes employés  ça me donne beaucoup de confiance et de satisfaction au bureau aussi.  C’est ce que je fais pour rester motivée."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-p3.mp3",
							"audioLabel": "p3-p",
							"script": "This response is an accurate explanation of the subject, but it is still a little too simple for the C level. It would be desirable to vary verb tenses, add connectives and use terms that are clearer. You must demonstrate that you are sufficiently comfortable with the French language to reach the C level."
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-q1.mp3",
							"audioLabel": "wp3-q",
							"script": "Je vais vous parler la façon je conserve ma motivation au travail.  Selon moi, il faut on garde sa motivation au travail et il y a un variété de façons de faire ça. Premièrement, trouve il est vraiment utile de garde votre santé, c’est vraiment important de règle toutes les façons possibles de garde votre santé et ce n’est pas justification de votre motivation au travail mais votre motivation pour bon vie aussi.  Par exemple, je pense c’est nécessaire de mange bien et faire les exercices. Additionellement, je pense c’est vraiment important de trouve la petite tâche au travail où vous avez l’opportunité de améliorer votre performance ou améliorer la performance de votre équipe, de continuer de continuer de trouver l’intérêt.  Une autre façon de trouver l’intérêt dans votre travail est de participer dans différents projets qui arrivent de temps en temps et de essayer de nouveaux défis.  De trouver un projet vous avez jamais essayé avant et d’être c’est difficile, mais c’est une bonne façon de continuer de trouver le motivation. Et finalement, je pense c’est vraiment important de suivi la formation de temps en temps c’est un excellente façon de rencontre nouveaux collègues"
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-q3.mp3",
							"audioLabel": "p3-q",
							"script": "This response has several deficiencies. First of all, verbs used to express an opinion are not correctly employed, since the ”que” is systematically omitted. Relative pronouns are also missing (”Je vais vous parler de la façon DONT je conserve ma motivation…”). Furthermore, the infinitive was rarely used with verbs that follow a preposition. Although a perfect response is not expected, basic grammar should be sufficiently mastered in order to reach C level.  "
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-r1.mp3",
							"audioLabel": "wp3-r",
							"script": "Tout d’abord, en ce qui concerne la motivation c’est important de faire un travail efficace, un travail exigeant et puis en respectant non seulement les échéances, mais aussi atteindre les objectifs d’un projet, soit un projet, soit un travail n’importe quoi.  Et maintenant je voudrais dire comment, quels sont les facteurs ou quels sont les critères qui renforcent la motivation au travail.Comme vous le savez, quand on travaille à la fonction publique, donc il y a beaucoup de restrictions, beaucoup de réglementation, même il y a quelques critères qui nous aide pour rester motivé.  À mon avis, c’est le défi que tous les employés relèvent.  Donc le sujet qu’on avait pas encore touché autour de notre travail, puis participer aux colloques, puis faire du réseautage en apprenant les nouveautés, les nouvelles techniques, les nouvelles approches pour faire un projet et puis prendre les initiatives, présenter les nouvelles façons de faire les choses et à mon avis ce sont quelques éléments il faut que je vois pour rester motivée."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-r3.mp3",
							"audioLabel": "p3-r",
							"script": "This response sticks to the subject and gets off to a good start. The candidate uses several complex structures and the vocabulary is varied. Nevertheless, he does not answer the question exactly. There is a long and elaborate introduction, but the body of the response is superficial and the candidate simply skips the conclusion. If it were a little more elaborate, this would be an excellent response."
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q7-a1.mp3",
							"audioLabel": "q7-a",
							"script": "Pensez-vous qu’il y ait un lien entre la motivation et la productivité?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q7-b1.mp3",
							"audioLabel": "q7-b",
							"script": "Croyez-vous que la motivation et la productivité soient liées?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q7-c1.mp3",
							"audioLabel": "q7-c",
							"script": "D’après vous, la motivation induit-elle la productivité?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-y1.mp3",
							"audioLabel": "p3-y",
							"script": "Selon moi, absolument, il y a un lien entre la motivation et la productivité parce que quand on est motivé à faire le travail et à faire un bon travail, la productivité augmente. Donc selon moi ça c’est évident.  Par contre, de temps en temps, il y a des personnes qui n’ont pas besoin d’avoir de motivation pour faire un bon travail ou pour augmenter la productivité mais, pour moi, à mon avis et dans mon expérience, il y a un lien entre la motivation et la productivité au travail."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-z1.mp3",
							"audioLabel": "p3-z",
							"script": "Absolument, je pense qu’il y a un lien fort.  Une personne qui n’est pas motivée ne fait pas beaucoup de travail et ce n’est pas le meilleur travail.  On doit être motivé et engagé dans le travail pour être très compétent donc, à mon avis, il y a un lien très fort."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-za1.mp3",
							"audioLabel": "p3-za",
							"script": "Vous m’avez posé une question vraiment intéressante.Selon moi, il y a bien un lien entre la motivation et la productivité au bureau. Ce que je veux dire c’est que, à mon avis, si une équipe est bien formée et qu’il y a beaucoup de motivation au sein de cette équipe, il y aura probablement plus de productivité et un meilleur rendement au bureau. Je pourrais vous donner un exemple de ça.  Je gère environ 20 personnes et il y a un bon esprit d’équipe à mon bureau. Donc ça veut dire que tous les personnes qui travaillent dans mon équipe ont beaucoup de respect pour leurs collègues, on partage l’information, on travaille ensemble pour trouver la solution à tous les problèmes au bureau. Donc, dans ce sens, il y a un bon esprit d’équipe, et j’ai remarqué qu’il y avait un bonne performance l’année passée. C’était une année où on a fait beaucoup de travail et c’était bien fait. Donc, en conclusion, je dirais qu’il y a certainement un lien entre la motivation et le performance au bureau."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zb1.mp3",
							"audioLabel": "p3-zb",
							"script": "Oui, c’est une question très pertinente au sein de la fonction publique, parce que aujourd’hui, en général, les fonctionnaires ont beaucoup de travail, alors pour avoir un bon rendement, c’est nécessaire d’avoir un bon esprit.  Mais souvent c’est une question où les fonctionnaires ne sont pas automatiquement motivés à faire le travail.  Donc, c’est la responsabilité du superviseur d’inciter quelqu’un à travailler dur sur un problème.  Sans préoccupation pour la motivation, le résultat souvent n’est pas bon.  Donc, selon moi, c’est important d’essayer de motiver ses employés en utilisant beaucoup d’outils comme reconnaître les compétences, le rendement et cetera pour augmenter le rendement et les résultats dans une vision stratégique pour aider les employés à suivre une bonne voie."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-s1.mp3",
								"audioLabel": "wp3-s",
								"script": "Absolument, c’est évident qu’il y a un lien très fort.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-s3.mp3",
								"audioLabel": "p3-s",
								"script": "This is a good response; however it should be more elaborate. It would benefit from examples and arguments in support of the initial assertion. Remember that the purpose of the Test is to assess your skills in French, and to do so, the examiner must hear you speak at length."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-t1.mp3",
								"audioLabel": "wp3-t",
								"script": "Absolument, il y a un lien entre les deux, jusqu’à un certain point.  Si vous n’aimez pas votre travail et si vous n’êtes pas vraiment motivé, je pense que je sais par expérience, que c’est vraiment difficile de faire le travail très productif.  Mais je pense que chaque personne a une tâche qu’elle n’aime pas, mais qui est quand même nécessaire de faire alors il faut trouver un truc pour rendre le travail plus intéressant ou plus amusant.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-t3.mp3",
								"audioLabel": "p3-t",
								"script": "Whenever you use a construction such as ”jusqu’à un certain point” (to a certain extent)  in order to qualify a statement, you have to explain what you mean. Otherwise, you will deliver an illogical response."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-u1.mp3",
								"audioLabel": "wp3-u",
								"script": "Oui, c’est une question très pertinente au sein de la fonction publique, parce que aujourd’hui, en général, les fonctionnaires ont beaucoup de travail alors pour avoir un bon rendement, c’est nécessaire d’avoir un bon esprit.  Mais souvent c’est une question où les fonctionnaires ne sont pas automatiquement motivés à faire le travail.  Donc, c’est la responsabilité du superviseur d’inciter quelqu’un à travailler dur sur le problème et cetera.  Sans une préoccupation pour la motivation, le résultat souvent n’est pas bon.  Donc, selon moi, c’est important d’essayer de motiver ses employés en utilisant beaucoup d’outils comme la reconnaissance des compétences, le rendement et cetera pour augmenter le rendement, le résultat ainsi que dans une vision stratégique pour aider les employés à suivre une bonne voie."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-u4.mp3",
								"audioLabel": "p3-u",
								"script": "Pay close attention to the question because it is essential that you stick to the subject. If you have trouble doing that, make a note of the key words of the question and refer back to your notes as you speak. That way, you will be able to answer the question accurately rather than formulate a response that is more or less related to the topic."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q8-a1.mp3",
							"audioLabel": "q8-a",
							"script": "Que pensez-vous des activités sociales pour garder la motivation d’une équipe?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q8-b1.mp3",
							"audioLabel": "q8-b",
							"script": "D’après vous, comment les activités sociales peuvent-elles contribuer à maintenir la motivation d’une équipe?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q8-c1.mp3",
							"audioLabel": "q8-c",
							"script": "Quelle est votre opinion sur la préservation de la motivation d’une équipe au moyen d’activités sociales?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zc1.mp3",
							"audioLabel": "p3-zc",
							"script": "Selon moi, les activités sociales peuvent garder la motivation d’une équipe dans une certaine mesure.  D’après moi, il y a trois avantages avec les activités sociales.  Premièrement, elles sont une bonne occasion pour tous les employés et tous les travailleurs de faire la connaissance de leurs collègues parce que souvent, dans le milieu du travail, certaines personnes côtoient seulement une ou deux autres personnes et les événements sociaux sont l’occasion de passer du temps libre avec d’autres collègues.  Ensuite, je note que les activités sociales sont de bonnes occasions de gérer le stress et par conséquent, elles sont bonnes pour la motivation aussi.  Et finalement, il me semble que les événements sociaux, notamment les événements qui arrivent à l’extérieur du bureau, peuvent établir un esprit d’équipe parmi tous les employés, mais en même temps, je dois remarquer que je ne suis pas d’accord avec les gestionnaires qui essaient de forcer les gens d’y participer.  Quelques fois les patrons disent que c’est important que tout le monde participe et ce n’est pas juste d’après moi.  Les temps libres sont les temps libres et ce n’est pas à propos de demander que tout le monde assiste à ce genre d’événements.  Pour terminer, je dirais que les événements sociaux sont une bonne idée qui peuvent garder la motivation d’une équipe, mais en même temps, il faut que les patrons et les gestionnaires reconnaissent que ce n’est pas juste d’exiger la participation de tout le monde."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zd1.mp3",
							"audioLabel": "p3-zd",
							"script": "Il y a des personnes qui pensent que les activités sociales sont vraiment importantes pour améliorer les relations interpersonnelles au bureau et que c’est une bonne source de motivation au bureau pour améliorer la productivité.   Néanmoins, je suis plus ou moins d’accord avec cette idée car je pense aussi que quand il y a beaucoup d’activités sociales, la productivité diminue parce que les personnes ne font pas autant de travail, mais de temps en temps c’est bon pour améliorer les relations.  Alors, les activités sociales peuvent servir de motivation s’il n’y en a pas trop."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-ze2.mp3",
							"audioLabel": "p3-ze",
							"script": "Ça c’est une question vraiment pertinente au bureau. En fait, j’ai une opinion assez tranchée sur ce sujet. Je trouve que les activités sociales au bureau sont vraiment importantes pour augmenter la motivation, pour renforcer l’esprit d’équipe. Je suis absolument certaine que c’est une activité essentielle qu’on doit faire au bureau pour avoir plus de temps pour partager l’information et pour améliorer la connaissance de chaque membre de l’équipe. Donc, j’aime bien les activités sociales au bureau.Il y a quelques mois, j’ai organisé un petit déjeuner pour toute mon équipe parce que j’avais remarqué qu’elle était un peu fatiguée. Il y avait beaucoup de travail à faire et l’horaire était bien chargé à tous les jours. Donc, j’ai organisé une déjeuner pour mon équipe dans le but d’avoir le temps de discuter ensemble, de partager un petit repas hors du bureau parce que je pensais que c’était vraiment important de prendre du temps pour nous. J’ai demandé à mon patron de nous accompagner parce que je pensais que c’était vraiment important d’avoir un membre de la haute gestion avec nous.  J’ai décidé d’avoir le repas pendant les heures de travail parce que c’était plus commode pour les parents qui sont monoparentaux. C’était une activité bien faite pour tous et j’ai remarqué que la motivation est revenue"
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zf1.mp3",
							"audioLabel": "p3-zf",
							"script": "En général, d’après moi, il va de soi que les activités sociales aident à inciter quelques employés à s’impliquer dans leur travail d’une manière meilleure qu’autrement.  Mais, d’autre part dans certains ministères, c’est possible d’avoir trop d’activités sociales à tel point que le rendement est menacé ou entravé. Donc, il n’y a pas de formule magique pour dire oui, les activités sociales sont nécessaires pour garder la motivation et augmenter le rendement."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-v2.mp3",
								"audioLabel": "wp3-v",
								"script": "Les activités sociales a un rôle au travail, mais je trouve que c’est important de limiter la quantité des activités sociales.  La motivation d’une équipe n’était pas juste dépendante de la moral qui pourrait augmenter avec les activités sociales.  Je pense que les membres du groupe ou d’une équipe devraient être travaillé bien ensemble pour s’assurer la motivation de le groupe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-v4.mp3",
								"audioLabel": "p3-v",
								"script": "Pay careful attention to the tense and mood of the verbs that you use. In this example, the choice of verb tenses and forms is so incoherent that it is difficult to make out the message that the candidate wishes to communicate, even though the speaker’s intentions seem right."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-w1.mp3",
								"audioLabel": "wp3-w",
								"script": "Il y a des personnes qui pensent que les activités sociales sont vraiment importantes pour améliorer les relations interpersonnelles au bureau et enfin ça c’est une bonne motivation au bureau pour améliorer la productivité.   Selon moi, c’est vrai, je suis plus ou moins d’accord avec cette idée."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-w4.mp3",
								"audioLabel": "p3-w",
								"script": "This response is incomplete and seems contradictory. Try to take a stand and to explain your position clearly. You are entitled to your opinion, but you must be able to defend it in the examination setting."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-x2.mp3",
								"audioLabel": "wp3-x",
								"script": "Ça c’est une question vraiment pertinente au bureau. Pour moi, en présumant que j’ai une opinion assez tranchée sur ce sujet. Il me semble que les activités sociales au bureau sont vraiment importantes en augmentant la motivation et en renforçant l’esprit d’équipe. Étant donné que je sois absolument certaine que c’est une activité essentielle qu’on doit faire au bureau, j’aime bien les activités sociales.  Il est possible de tenir une telle activité simple comme en dînant avec les collègues ou en buvant un café ensemble.  Je voudrais que j’organise ce type d’activité plus souvent dans l’intention d’avoir un meilleur esprit d’équipe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-x3.mp3",
								"audioLabel": "p3-x",
								"script": "It is all right to use the complex structures that you have learned in class, but you must not overdo it. If you do not feel altogether comfortable using them, you had better avoid them rather than use them incorrectly."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q9-a1.mp3",
							"audioLabel": "q9-a",
							"script": "Si vous deviez donner un conseil à un employé démotivé, que lui diriez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q9-b2.mp3",
							"audioLabel": "q9-b",
							"script": "Si vous rencontriez un collègue démotivé, quel conseil lui donneriez-vous?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q9-c1.mp3",
							"audioLabel": "q9-c",
							"script": "Si un membre de votre équipe était démotivé, comment l’aideriez-vous à regagner sa motivation?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zg1.mp3",
							"audioLabel": "p3-zg",
							"script": "Si j’avais l’occasion de donner des conseils concernant la motivation, je dirais à un tel employé de communiquer avec son gestionnaire pour voir s’il y a des façons d’améliorer sa motivation.  Par exemple, peut-être que cette personne pourrait changer de tâches ou ajouter d’autres tâches pour s’inspirer un peu.  "
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zh1.mp3",
							"audioLabel": "p3-zh",
							"script": "Ça c’est intéressant… Si je devais donner un conseil à un de mes employés qui semblait un peu déprimé et démotivé, je dirais qu’il est vraiment important de penser à long terme. Parce que s’il y  a beaucoup de travail pendant une journée, c’est parfois déprimant pour les employés au bureau.  Ce que je veux dire en fait c’est que c’est plus simple de penser à la fin de chaque projet.  Peut-être que s’il y a un problème avec une étape d’un projet c’est parce que d’est une étape difficile à compléter donc, en pensant au long terme, on peut imaginer la fin du projet et le sentiment de la fin du projet. Donc, penser au long terme, ça pourrait donner un peu plus de motivation aux employés et c’est la stratégie que j’emploie le plus souvent."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zi1.mp3",
							"audioLabel": "p3-zi",
							"script": "Avant de le conseiller, je parlerais avec lui pour déterminer les raisons de sa motivation et les raisons pour lesquelles la personne ne fonctionne pas bien.  Après ça, je lui suggérerais de parler avec son patron en cas de problème.  Ensuite, je lui suggérerais de participer aux activités sociales pour lui permettre d’interagir bien avec tout le monde.  Aussi, je lui conseillerais peut-être de trouver la vision stratégique du ministère ainsi que du bureau pour obtenir une bonne connaissance de son rôle dans l’organisation."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zj1.mp3",
							"audioLabel": "p3-zj",
							"script": "Si j’avais un employé qui n’était pas motivé, je pourrais discuter de la situation avec l’employé et trouver une solution ensemble.  Selon mon expérience, il est regrettable qu’un employé ne soit pas motivé, mais la plupart du temps, c’est la responsabilité de l’employé de trouver la motivation.  Mais comme superviseur, je peux discuter de la possibilité de changer de travail ou d’une occasion de travailler dans un autre poste, s’il y a un poste intérimaire disponible à ce moment-là ou d’ajouter du travail à quelqu’un par exemple."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-y1.mp3",
								"audioLabel": "wp3-y",
								"script": "Ça c’est intéressant… Si je devrais donner le conseil à un de mes employés qui semblerait un peu déprimé et démotivé, je dirais que c’était vraiment important de penser à long terme. Parce que s’il y aurait beaucoup de travail pendant une journée, ça serait déprimant pour les employés au bureau et je dirais juste de penser à long terme parce que c’était plus commode au bureau de penser à long terme qu’à court terme. Ce que je veux dire en fait c’est que c’est plus simple de penser à la fin de chaque projet. Peut-être si il y était un problème au bureau avec une étape d’un projet ce serait une étape très difficile à compléter, on pourrait penser à long terme juste pour imaginer le fin du projet et imaginer le sentiment à la fin du projet. Donc, ça pourrait donner un peu plus de motivation aux employés de penser à long terme."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-y2.mp3",
								"audioLabel": "p3-y",
								"script": "You must pay close attention to choice of verb tenses when dealing with hypothetical questions; otherwise, the response may lack coherence. Do not hesitate to practise until you develop the habit of using verb tenses correctly."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-z1.mp3",
								"audioLabel": "wp3-z",
								"script": "Avant que, de donner le avis peut-être, je parlerais avec il, le pour déterminer les raisons pour le motivation, les raisons pourquoi la personne ne pas fonctionner bien.  Après ça, je le suggérais que il puisse parler avec son patron si il y a des problèmes.  Ensuite, je lui disais de participer dans les activités sociales pour lui permettre d’interagir bien avec tout le monde.  Aussi, peut-être je le conseillerais que il puisse trouver la vision stratégique pour le ministre ainsi que le bureau pour obtenir une bonne connaissance par rapport l’avenir."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-z2.mp3",
								"audioLabel": "p3-z",
								"script": "The ideas expressed here are good, but there are too many basic grammar mistakes. They make the message hard to follow and show that the candidate does not fully master basic grammar."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-za2.mp3",
								"audioLabel": "wp3-za",
								"script": "Si j’avais un employé qui n’avais pas motivé, euh pardon qui n’était pas motivé, je voudrais, non pourrais discuter la situation avec l’employé, avec il, non lui et ensemble trouver une solution.  Selon ma expérience, euh mon expérience, il est regrettable qu’un employé ne soit pas motivé, mais la plupart des temps, non du temps, c’est la responsability, res-pon-sa-bi-li-TÉ de l’employé de trouver la motivation.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-za2.mp3",
								"audioLabel": "p3-za",
								"script": "Self-correction is a good strategy that you can use from time to time to correct minor mistakes. You must, however, avoid resorting to this strategy systematically since it hampers the normal flow of conversation."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q10-a.mp3",
							"audioLabel": "q10-a",
							"script": "Dans quelle mesure le gouvernement aide-t-il les fonctionnaires à demeurer motivés?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q10-b.mp3",
							"audioLabel": "q10-b",
							"script": "Jusqu’à quel point la fonction publique met-elle en place des solutions pour maintenir la motivation de ses employés?  "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zk1.mp3",
							"audioLabel": "p3-zk",
							"script": "Selon moi, le secteur public a des politiques concernant l’apprentissage et les activités sociales et en outre, il y a plusieurs échelons pour avancer la carrière donc il y a beaucoup de façons de rester motivé parce qu’il y a beaucoup d’options.  Par contre, je pense qu’en général les personnes ne connaissent pas les politiques et ça ce n’est pas une bonne chose ou alors, l’environnement de travail cause des problèmes de motivation donc je pense que les patrons et les employés doivent travailler sur ce sujet."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zl1.mp3",
							"audioLabel": "p3-zl",
							"script": "À mon avis, je pense le gouvernement doit aider les employés à être un peu plus motivés au bureau mais jusqu’à un certain point. Je pense que d’un côté, c’est vraiment important que le gouvernement donne les renseignements, l’information, peut-être les stratégies pour gérer le stress au travail dans le but de démontrer que le gouvernement veut que ses employés soient très motivés au bureau. Mais d’un autre côté, je pense que c’est à nous comme fonctionnaires de trouver une façon d’être plus motivés au bureau. Ce que je veux dire c’est que nous sommes des adultes et nous sommes des professionnels dans notre domaine. Donc ça veut dire que c’est à nous de trouver les petits parties de notre travail qui nous motive à faire un bon travail, pour avoir un bon rendement au bureau dans le but de nous motiver nous-même et aussi les autres membres d’équipe."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zm1.mp3",
							"audioLabel": "p3-zm",
							"script": "Dans la Fontion publique, même s’il y a certaines politiques qui découlent du Conseil du trésor, il y a une grande différence entre la manière dont une ministère aborde ce problème.  Pourtant, je dirais que, en général, tous les ministères aident les fonctionnaires à demeurer motivés dans la mesure où ils essaient d’encourager les employés à participer aux activités sociales.  Surtout  les activités organisées par le ministère.  D’autre part, le ministère essaie de donner de la reconnaissance à ses employés méritants.  Également, quand le ministère forme les gestionnaires, en général, il leur conseille d’augmenter le moral dans leur propre organisation de sorte que chacun sente que il participe profondément au but, au mandat et aux objectifs de leur propre ministère.  En revanche, bien que le gouvernement encourage ses employés à utiliser certains outils ou certaines approches pour rester motivés, la motivation est la responsabilité de chaque personne.  En somme, la fonction publique encourage la motivation, mais elle ne peut pas obliger ses employés à utiliser les outils."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zn1.mp3",
							"audioLabel": "p3-zn",
							"script": "Le gouvernement aide les fonctionnaires à rester motivés en offrant la possibilité de postes intérimaires et d’affectations et de mutations pour un changement de poste.  Aussi, il y a beaucoup de projets au gouvernement et normalement il y a des occasions de travailler sur un projet différent.  Aussi, il y a une politique où les employés peuvent devenir mentor et je pense que c’est une façon de motiver les employés.  Cependant, il faut que les employés connaissent ces programmes et veuillent les utiliser.  Donc, le gouvernement n’a pas toute la responsabilité de la motivation, c’est aussi la responsabilité de l’employé."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zb1.mp3",
								"audioLabel": "wp3-zb",
								"script": "C’est difficile de me motiver quand il y a beaucoup de choses à faire au bureau. Pour moi, je trouve que mon équipe c’est assez pour me motiver. J’aime bien les membres de mon équipe et ça me fait plaisir de me rendre au bureau et de voir les membres de mon équipe et d’avoir l’occasion de travailler ensemble avec les membres de mon équipe.  Donc ça, c’est une façon pour moi de me motiver au bureau."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zb2.mp3",
								"audioLabel": "p3-zb",
								"script": "The candidate is not answering the question. It would have been necessary to explain what the Government does to help public servants and not how he manages to find motivation at the office. Furthermore, the candidate is not qualifying his assertions."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zc1.mp3",
								"audioLabel": "wp3-zc",
								"script": "Dans la fonction publique peut-être, même si il y a certaines politiques qui découlent du Conseil du trésor, en général, il y a une grande différence entre la manière dont les ministères abordent ce problème.  Pourtant, je dirais qu’en général, tous les ministères essaient d’encourager les employés de participer aux activités sociales, surtout celles qui sont organisées par le ministère.  D’autre part, le ministère essaie de donner des primes pour la reconnaissance.  Également, quand le ministère forme les gestionnaires, en général, il leur conseille d’augmenter le moral dans leur propre organisation de sorte que chacun puisse sentir qu’il participe profondément au but et aux objectifs de leur propre ministère."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zc2.mp3",
								"audioLabel": "p3-zc",
								"script": "This response is incomplete. In the case of a dialectical question, it is absolutely necessary to qualify a statement in order to demonstrate that you understand the purpose of the question. If you do provide a clear-cut opinion, clearly state that it is because you have no reservations about the issue so that the examiner will know that you are nevertheless aware of the type of question that has been asked.  "
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zd1.mp3",
								"audioLabel": "wp3-zd",
								"script": "Le gouvernement aide les fonctionnaires à rester motivé dans la mesure où il offre la possibilité de postes intérimaires, d’affectations et de mutations pour un changement de poste. Aussi, il y a beaucoup de projets au gouvernement et normalement il y a des opportunités de travailler dans un projet différent. Aussi, il y a des politiques pour que les employés puissent obtenir un mentor et devenir mentor.  Donc je pense que le gouvernement offre beaucoup d’opportunités et d’avantages pour la motivation des employés."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zd2.mp3",
								"audioLabel": "p3-zd",
								"script": "The expression ”dans la mesure où” (to the extent that) expresses the candidate’s intention to qualify his statement but he does not do so in the rest of his response. You must never forget this aspect of a response to a dialectical question. If you have a tendency to do this, you could write DQM (dans quelle mesure) or JQP (jusqu’à quel point) on the sheet in front of you so that you may remember to qualify your assertions when dealing with this type of Test question."
							}
						}
					]
				}
			],
			"label": "Topic 2",
			"index": 1
		},
		{
			"talkContent": {
				"index": 2,
				"label": "Topic 3 Q&A",
				"questions": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/q18-a1.mp3",
						"audioLabel": "q18-a",
						"script": "Racontez-moi un voyage d’affaire."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/q18-b1.mp3",
						"audioLabel": "q18-b",
						"script": "Parlez-moi d’un voyage que vous avez fait dans le cadre de votre travail."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/q18-c1.mp3",
						"audioLabel": "q18-c",
						"script": "Parlez-moi d’une fois où vous êtes parti en voyage pour votre travail."
					}
				],
				"possibleAnswers": [
					{
						"index": 0,
						"audio": "/wp-content/uploads/2013/12/p3-zo1.mp3",
						"audioLabel": "p3-zo",
						"script": "Je voudrais raconter un voyage d’affaires que j’ai effectué en 2008 pour participer à une délégation canadienne et représenter mon ministère lors d’une négociation avec l’ONU.  Tout d’abord, je dois dire que ce voyage a duré trois semaines et que c’était une très bonne expérience professionnelle.  Le but de cette négociation était premièrement de promouvoir, deuxièmement de défendre et troisièmement d’avancer la position du Canada concernant les enjeux des immigrants. Plus particulièrement, j’ai participé à la négociation concernant les femmes immigrantes et la violence envers les femmes immigrantes.À mon avis, le processus de négociation était très important et très intéressant. Mon rôle était d’ajouter quelques mots dans la résolution pour défendre la position du Canada concernant les enjeux de la violence envers les femmes et notre approche dans le contexte international.  Par conséquent, j’ai fait plusieurs interventions et j’ai collaboré aux échanges et aux discussions afin de donner mon point de vue. Le déroulement du processus de négociation était de lire à haute voix chaque paragraphe pour que les participants, les délégués, ajoutent ou annulent quelques mots.  Lors de cette rencontre, j’ai suggéré certains concepts qui étaient très important pour le Canada. Donc, après quelques jours de négociation, les autres délégations ont accepté l’ajout de certains termes. Par conséquent, je peux dire que la délégation du Canada a été une grande réussite.Suite à cette expérience, je dirais que le monde de la diplomatie est vraiment très intéressant. En conclusion, si j’avais l’occasion de faire un changement dans ma carrière, je choisirais de travailler pour le ministère des affaires étrangères afin d’enrichir mes expériences professionnelles dans ce domaine."
					},
					{
						"index": 1,
						"audio": "/wp-content/uploads/2013/12/p3-zp1.mp3",
						"audioLabel": "p3-zp",
						"script": "Il y a un an, j’ai fait un voyage d’affaires à Whitehorse pour effectuer une recherche sur la société des peuples dans le Nord du Canada.  Mes collègues et moi avons pris deux vols d’une durée de 7 heures pour aller à Whitehorse. Nous sommes arrivés en après-midi, ensuite nous avons mangé ensemble et pour la première soirée, nous avons rencontré un conférencier qui était le sous-ministre d’environnement du Yukon.Il y avait quelques éléments de notre programme à compléter durant la semaine.  C’était un voyage de 5 jours et pour le programme il fallait que nous fassions des entrevues avec des autochtones, des représentants du gouvernement du Yukon et bien sûr, du gouvernement fédéral.  Ensuite, nous avons élaboré une présentation pour la fin de la semaine et enfin, nous avons créé une discussion interactive avec les représentants de la société du Yukon. En bref, nous avons eu un grand succès avec la présentation et si j’avais l’occasion de revisiter le Yukon dans l’avenir, j’aimerais rester là pour plus d’une semaine."
					},
					{
						"index": 2,
						"audio": "/wp-content/uploads/2013/12/p3-zq1.mp3",
						"audioLabel": "p3-zq",
						"script": "Il y a quelques années, nous avons fait un voyage assez particulier. Nous avons visité une mine de potasse sur un site qui devait obtenir une validation environnementale. C’était très intéressant parce que nous sommes descendus à un kilomètre de profondeur sous la terre dans un ascenseur qui était très rapide. Dans la mine, il faisait très chaud, bien sûr ce n’était pas bien éclairé et aussi, il y avait beaucoup de poussière. Nous avons fait beaucoup de kilomètres dans la mine lors de la première journée.Le deuxième jour, nous avons eu une séance pour améliorer l’esprit d’équipe. C’était très important puisque l’équipe travaillait dans des régions différentes, alors il était nécessaire que nous organisions des activités sociales pour améliorer l’atmosphère durant les réunions.Le troisième jour, nous nous sommes occupés de la mise à jour de toutes les activités du programme et de la division. Il y avait beaucoup de présentations données par chaque coordonnateur ou coordonnatrice de chaque région.En conclusion, je trouve qu’il est essentiel de créer de bonnes relations professionnelles avec nos collègues. Il faut absolument voyager pour rencontrer tous les membres de l’équipe qui travaillent à distance."
					},
					{
						"index": 3,
						"audio": "/wp-content/uploads/2013/12/p3-zr1.mp3",
						"audioLabel": "p3-zr",
						"script": "En février dernier, je suis allé à Miami pour assister à une conférence sur l’utilisation des logiciels des grandes entreprises. Le but de cet événement était de souligner les faiblesses retrouvées dans les entreprises. Il s’agissait d’une conférence de cinq jours et à ce moment-là, j`étais le gestionnaire responsable de l`approvisionnement des logiciels pour le gouvernement du Canada. Il y avait beaucoup de participants… par exemple, le gouvernement des États-Unis qui représentait le secteur privé et aussi le Canada qui représentait les travaux publics et la défense nationale. À chaque matin, il y avait une petite rencontre avec certaines compagnies qui offraient des conseils aux participants. En général, j`ai trouvé cette conférence très intéressante. D’ailleurs, j’étais très content parce que comme vous pouvez l’imaginer, la météo à Miami était très très bonne! Enfin, après avoir complété ce voyage d’affaires, je suis retourné à Ottawa et j’ai commencé un grand projet avec la défense nationale. En effectuant ce travail, j’ai eu l’occasion de mettre en pratique plusieurs conseils que j’avais reçus lors de la conférence. Finalement, si je n’avais pas assisté à cet événement, je  n’aurais pas pu travailler sur un projet aussi important."
					}
				],
				"problematicAnswers": [
					{
						"index": 0,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-ze1.mp3",
							"audioLabel": "wp3-ze",
							"script": "Nous avons visité une mine de potasse pour une visite d’un site qui a eu une validation environnementale. Le premier jour, nous sommes descendus à une kilomètre dans les terres dans un ascenseur qui était très rapide. Dans la mine il faisait très chaud et aussi il y avait beaucoup de poussière.Le deuxième jour nous avons eu une séance pour améliorer l’esprit d’équipe.  C’était important puisque l’équipe est nationale et travaille dans les régions différentes.Le troisième jour, nous sommes occupés avec une mise à jour de tous les activités du programme et de la division. Il y avait beaucoup de présentations par chaque coordinateur ou coordinatrice de chaque région.Le quatrième jour, nous avons fait la panification pour la réunion suivante.  Finalement, nous avons soupé ensemble dans un bon restaurant et nous avons dit au revoir.\nEn conclusion, les réunions face à face sont très importants pour l’équipe, il faut qu’on voyage pour rencontrer tous les membres de l’équipe."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-ze3.mp3",
							"audioLabel": "p3-ze",
							"script": "This is not a bad response, but it is closer to the type of response that is expected of a B level candidate. At the C level, it is necessary to be able to express oneself with greater ease and link ideas together in a logical way rather than simply deal with information in a chronological manner. Try to relate your experience in a livelier way or by sharing your impressions of the trip!"
						}
					},
					{
						"index": 1,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-zf1.mp3",
							"audioLabel": "wp3-zf",
							"script": "Oui en février dernière, je suis allé à Miami pour assister une conférence pour la meilleur façon de gérer le logiciel dans grand entreprise.  Euh…le but de la conférence est de souligner les faiblesse en général dans les entreprises avec la façon de gérer les affaires.  Ça a duré euh… cette conférence, ça a duré cinq jours. À ce moment-là, j’étais le gestionnaire responsable de l’approvisionnement de logiciels du gouvernement du Canada.  Il y a beaucoup de participants par exemple, le gouvernement des États-Unis, toujours les représentes des secteurs privés aux États-Unis et Canada, aussi il y a le gouvernement du Canada, c’est-à-dire les représentes de Travaux publics et un représente de la Défense nationale. Euh… chaque matin, il y a une petite séance avec une compagnie qui donner les conseils aux les autres avec leurs expériences bien gérer les logiciels dans l’entreprise.  Par exemple, dans les bureaux de la Défense nationale aux États-Unis, il est grand comme vous pouvez imaginer, c’est une grand ministère avec beaucoup d’emplois et de temps en temps, c’est difficile de déterminer combien de licences pour chaque produit cette organisation avait achetées. Euh… en général, j’ai trouvé cette conférence très intéressant.  J`étais très content aussi parce que comme vous pouvez imaginer c’est Miami en février, le météo était très très bon.  Après avoir complété euh après avoir fini cette conférence, je suis retourné à Ottawa et j’ai commencé un processus avec la Défense nationale afin d’économiser l’argent.  J’ai trouvé pour logiciel euh…la Défense nationale avait acheté euh… deux fois que licence que l’était nécessaire pour les entretiens donc à la fin, avec le travail avec la Défense nationale, il était possible d`économiser près de un million de dollars chaque année et si je n’avais pas participé à cette conférence, je n’aurais euh… je n’aurais pas obtenir le connaissances nécessaire pour cette économie."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-zf2.mp3",
							"audioLabel": "p3-zf",
							"script": "During the TOP, it is important to appear to be as comfortable as possible. Try to avoid excessive hesitation and also, try to stay structured. That is why you are given 90 seconds to think about your response. Furthermore, you should master the past tenses perfectly, an essential factor when doing a narrative."
						}
					},
					{
						"index": 2,
						"probAnswer": {
							"audio": "/wp-content/uploads/2013/12/wp3-zg3.mp3",
							"audioLabel": "wp3-zg",
							"script": "Je voudrais expliquer un voyage d’affaires que j’ai fait en 2008 pour participer dans une délégation canadienne et représenter mon ministère à l’ONU.  Le but de cette négociation était premièrement de promouvoir, deuxièmement de défendre et troisièmement d’avancer la position du Canada concernant les enjeux des immigrants et en particulier, j’ai participé dans la négociation concernant les femmes migrantes et la violence contre les femmes migrantes.Le processus était long, mais intéressant.  La stratégie canadienne était un peu complexe, mais elle était efficace.  Mais je trouve que le Canada pourrait faire un peu plus concernant cet enjeu.  Mon ministère a quelques politiques, mais elles ne sont pas suffisantes.  De plus, les efforts internationaux avancent très lentement et les pays où le trafic humain est le plus important ne font pas assez pour améliorer la situation.  Heureusement, il y a plusieurs délégués internationaux qui étaient de mon avis donc je suis toujours optimiste.En conclusion, j’aime travailler dans le monde de diplomatie et je voudrais un jour de faire le travail vraiment pour le ministère des affaires étrangères."
						},
						"comment": {
							"audio": "/wp-content/uploads/2013/12/p3-zg2.mp3",
							"audioLabel": "p3-zg",
							"script": "This candidate is providing an interesting personal viewpoint, but is forgetting the initial question. During the presentation, the candidate had better stick to the question even if he has a clear-cut opinion on the subject. The TOP being a very particular type of exercise, it is preferable to follow the rules rather than stray from the topic in order to express your opinion."
						}
					}
				]
			},
			"QAs": [
				{
					"label": "Q&A 1",
					"index": 0,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q12-a1.mp3",
							"audioLabel": "q12-a",
							"script": "Selon vous, les voyages d’affaire sont-ils toujours nécessaires?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q12-b1.mp3",
							"audioLabel": "q12-b",
							"script": "D’après vous, est-il toujours obligatoire de voyager pour le travail?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q12-c1.mp3",
							"audioLabel": "q12-c",
							"script": "Croyez-vous que les voyages d’affaire soient à chaque fois indispensables?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zs1.mp3",
							"audioLabel": "p3-zs",
							"script": "Selon moi, les voyages d’affaires ne sont pas toujours nécessaires, mais ils sont utiles dans la majorité des circonstances.  Selon moi, les avantages des voyages d’affaires l’emportent sur les désavantages.  Tout d’abord, les voyages d’affaires donnent une opportunité de développer ou d’améliorer les relations personnelles entre les collègues ou entre les clients.  Aussi, ils donnent une opportunité de comprendre la situation actuelle, sur la terre.  Par exemple, quand j’ai travaillé à la planification pour les Jeux Olympiques, c’était nécessaire de faire un voyage d’affaires à Vancouver et de voir la construction des sites pour les Jeux Olympiques. C’était donc l’occasion de vérifier les promesses que le ministre a fait dans sa soumission. Mais en même temps, il y a des désavantages aux voyages d’affaires.  Le désavantage primordial c’est le coût de ces voyages.  C’est très cher et aussi il y a une perte de temps quand un employé est à l’extérieur du bureau, mais en général, je pense que les avantages des voyages d’affaires l’emportent sur les désavantages."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zt1.mp3",
							"audioLabel": "p3-zt",
							"script": "Ils ne sont pas toujours nécessaires. C’est très important de déterminer le but, le coût et l’impact des voyages. Normalement, c’est mieux de faire un voyage d’affaires et comme vous pouvez imaginer, de temps en temps ça arrive quand un client, un vendeur, mon équipe ou mon assistant participe à une conférence ou une réunion, mais peut-être que ce n’est pas toujours essentiel. Donc à la fin, c’est nécessaire de prendre la décision après avoir pensé à toutes les possibilités."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zu1.mp3",
							"audioLabel": "p3-zu",
							"script": "Ça dépend vraiment de la situation de chaque division. Pour notre division, c’est nécessaire que nous fassions les voyages d’affaires une ou deux fois par année. C’est important de rencontrer tous les membres de l’équipe mais d’un autre côté, je pense qu’il y a des voyages d’affaires dans d’autres divisions qui ne sont pas vraiment nécessaires. C’est une sorte de prix pour les employés et souvent les réunions peuvent être faites par téléconférence. Je pense que dans les prochaines années la haute gestion va surveiller un peu plus les voyages d’affaires."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zv1.mp3",
							"audioLabel": "p3-zv",
							"script": "À mon avis, les voyages d’affaires sont utiles si la raison pour le voyage est d’avoir une rencontre face à face. Donc je crois que les voyages d’affaires sont moins requis maintenant grâce aux autres moyens de télécommunication, par exemple les vidéos, les téléconférences et enfin les courriers électroniques.  Donc en bref, je crois que les voyages d’affaires sont utiles jusqu’au point où ils sont nécessaires pour avoir une réunion directe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zh2.mp3",
								"audioLabel": "wp3-zh",
								"script": "Ça dépend vraiment de la situation de chaque division.  Pour notre division, c’est nécessaire que nous fassions les voyages d’affaires une ou deux fois par année.  Les autres moyens de communiquer avec les homologues ou les collaborateurs sur un projet ou certains contextes sont bien comme les courriels, les téléconférences, mais à mon avis, vraiment les bons résultats peuvent atteindre par les réunions face à face.  Mais en autre côté, je pense que peut être il y a les voyages d’affaires dans l’autre division qui ne sont pas vraiment nécessaires, c’est un sorte de prix pour les personnels et souvent les réunions peuvent faire par téléconférence."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zh2.mp3",
								"audioLabel": "p3-zh",
								"script": "When you use the passive voice, do not forget to add the verb “être”. Without it, this construction loses all meaning. Furthermore, if you wish to qualify an assertion, be sure to correctly formulate the connective: there is no such expression as “en autre côté” in French."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zi2.mp3",
								"audioLabel": "wp3-zi",
								"script": "Au sein de mon travail, il ne faut pas que je prends les voyages de travail pour mon position actuel, mais pour les autres membres de mon équipe il faut de temps en temps qu’ils prennent un voyage pour les affaires et je trouve que c’est important qu’ils sont disponibles et que l’employé est capable de voir ses clients et d’assister aux conférences. Maintenant, avec les outils techniques comme les téléconférences, de temps en temps, une personne ne doit pas aller à un autre endroit de être là avec ses opinions, son voix et peut-être son image, mais je pense que dans certains cas, comme les conférences où on apprend quelque chose, il faut qu’on est là.  Quand une personne est là en face, en personne, il peut interagir dans une manière plus facile, plus efficace que par distance.  Alors, je trouve que la plupart du temps, les voyages de travail sont nécessaires pour qu’un employé peut avoir la meilleure expérience d’une réunion avec un client ou d’assister à une conférence ou n’importe quelle raison."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zi2.mp3",
								"audioLabel": "p3-zi",
								"script": "At the C level, certain mistakes should absolutely be avoided. They can sometimes slip into the sentence, but they should not do so systematically. Anglicisms such as “prendre un voyage” should be eliminated. Also, the subjunctive ought to be mastered and used correctly, in particular after constructions using the impersonal pronoun “il”."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zj1.mp3",
								"audioLabel": "wp3-zj",
								"script": "Je pense les voyages d’affaires sont utiles si la raison pour le voyage est d’avoir une rencontre face à face.  Donc je crois les voyages d’affaires sont moins requis maintenant grâce à les autres moyens de télécommunication comme les téléconférences et les courriers électroniques.  Donc en bref, je crois les voyages d’affaires sont utiles jusqu’au point où ils sont nécessaires pour avoir une réunion directe."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zj2.mp3",
								"audioLabel": "p3-zj",
								"script": "Verbs used to express an opinion must absolutely be followed by “que” if the verb that follows is conjugated. Omitting “que” is indicative of a flaw which should no longer be seen, especially at the C level. What’s more, with a little practice, this mistake can easily be eliminated."
							}
						}
					]
				},
				{
					"label": "Q&A 2",
					"index": 1,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q13-a1.mp3",
							"audioLabel": "q13-a",
							"script": "D’après vous, comment pourrait-on rendre les voyages d’affaire plus profitables pour les contribuables?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q13-b1.mp3",
							"audioLabel": "q13-b",
							"script": "Selon vous, quels moyens utiliseriez-vous pour minimiser les dépenses produites par les voyages d’affaire?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q13-c1.mp3",
							"audioLabel": "q13-c",
							"script": "Comment rentabiliseriez-vous les coûts induits par les voyages d’affaire."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zw1.mp3",
							"audioLabel": "p3-zw",
							"script": "Quant à moi, il faudrait tout d’abord gérer plus efficacement notre temps lors des périodes moins occupées en effectuant d’autres tâches administratives.  Aussi, l’employé devrait utiliser ses outils technologiques comme l’agenda électronique et le téléphone cellulaire.  D’ailleurs, les nouvelles technologies sont très pratiques et elles nous offrent une panoplie de façons de travailler sur la route. Je trouve aussi qu’il serait important de réduire les coûts des voyages d’affaires.  C’est-à-dire qu’on pourrait trouver des moyens de transport moins chers… comme prendre un vol de fin de semaine au lieu d’un vol de semaine pour économiser un peu.  De plus, pendant les voyages d’affaires, il serait essentiel que les employés fassent du réseautage.  Je trouve que le réseautage augmente nos possibilités d’avancement dans le futur.  Enfin, je crois que les voyages d’affaires sont incontournables et qu’on peut trouver plusieurs stratégies afin de les rendre plus efficaces et profitables."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zx1.mp3",
							"audioLabel": "p3-zx",
							"script": "D’après moi, les voyages d’affaires seraient plus profitables pour les contribuables si l’utilisation du temps était bien planifiée.  Par exemple, si je devais aller à Victoria pour une réunion, j’aimerais avoir un agenda plein et utile pour une meilleure utilisation de mon temps.  Donc pour moi, c’est important de bien utiliser mon temps et celui des autres participants pour faire un bon travail."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zy1.mp3",
							"audioLabel": "p3-zy",
							"script": "Les voyages d’affaires peuvent être plus profitables s’il y a un but clair, s’il y a un horaire qui est organisé, s’il y a des rendez-vous formels pour rencontrer les gens et poser des questions pertinentes.  Et finalement, je trouve que les voyages d’affaires sont plus profitables quand il y a des opportunités pour socialiser, pour rencontrer les gens dans un contexte informel; c’est une opportunité d’améliorer, de développer des relations personnelles. En somme, je pense qu’il y a quatre critères pour structurer un voyage d’affaires très profitable."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zz1.mp3",
							"audioLabel": "p3-zz",
							"script": "On pourrait les rendre plus profitables en faisant davantage de réseautage. Selon moi, les voyages d’affaires devraient être utilisés afin de rencontrer nos clients, nos équipes et nos collaborateurs qui travaillent dans d’autres villes canadiennes. Si on organisait plus de rencontres durant l’année, nos relations professionnelles seraient plus enrichissantes. Pour terminer, je dirais que tous les voyages d’affaires devraient avoir un objectif précis afin d’obtenir un impact positif sur l’esprit d’équipe."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zk2.mp3",
								"audioLabel": "wp3-zk",
								"script": "D’après moi, les voyages d’affaires sont plus profitables pour les contribuables si l’utilisation de temps serait bien planifiée.  Par exemple, si j’irais à Victoria pour une réunion, j’aimerais avoir un agenda plein et utile pour la meilleure utilisation de mon temps.  Donc pour moi, c’est l’utilisation du temps pour moi et les autres participants pour faire le bon travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zk2.mp3",
								"audioLabel": "p3-zk",
								"script": "Ideally, the conditional would have to be repeated in the response when it has been used in the question. However, in this case, the conditional is badly used. When stating a hypothesis, “si” is never followed by a verb in the conditional, but by a verb in the imperfect tense."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zl4.mp3",
								"audioLabel": "wp3-zl",
								"script": "Plus profitables… je ne sais pas."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zl2.mp3",
								"audioLabel": "p3-zl",
								"script": "If ever you have a mental block or do not have an opinion, it is possible to inform the examiner and request another question. This shows that you are still actively participating in the conversation. However, do not systematically resort to this strategy."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zm4.mp3",
								"audioLabel": "wp3-zm",
								"script": "C’est une question très intéressante parce que comme fonctionnaire, nous avons un droit pour les choses hebdomadaires comme les repas et les coûts minimums pour le taxi et les choses comme ça.  "
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zm2.mp3",
								"audioLabel": "p3-zm",
								"script": "The candidate touches upon the topic, but does not answer it. In the follow-up questions, it is absolutely necessary to express an opinion. If you do not have any, tell the examiner, while suggesting that he ask you another question."
							}
						}
					]
				},
				{
					"label": "Q&A 3",
					"index": 2,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q14-a1.mp3",
							"audioLabel": "q14-a",
							"script": "Si vous pouviez choisir votre destination de voyage d’affaire, où iriez-vous?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q14-b1.mp3",
							"audioLabel": "q14-b",
							"script": "Si vous aviez la possibilité de décider du lieu de votre prochain voyage d’affaire, que choisiriez-vous?"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/q14-c1.mp3",
							"audioLabel": "q14-c",
							"script": "Si on vous donnait l’occasion de sélectionner la destination de votre voyage d’affaire, où préféreriez-vous partir?            "
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zza2.mp3",
							"audioLabel": "p3-zza",
							"script": "C’est une question très intéressante.  C’est un peu difficile de répondre maintenant parce que je viens de terminer une affectation à Vancouver et je n’ai pas encore reçu les nouveaux dossiers sur lesquels je devrai travailler. C’est difficile d’imaginer un voyage d’affaires qui pourrait être pertinent, mais cependant, si je devais choisir un lieu pour mon prochain voyage d’affaires, je choisiraisVancouver.  Dans mon dernier poste, j’ai travaillé à Vancouver et je trouvais que cette ville était très excitante. Je choisirais cet endroit pour obtenir des idées concernant les stratégies environnementales. Je pourrais observer des exemples concrets sur place et développer certains projets pour le gouvernement."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zzb2.mp3",
							"audioLabel": "p3-zzb",
							"script": "Si je pouvais choisir ma destination pour mon prochain voyage, j’irais en Fance. Je choisirais la France parce que ce serait l’occasion de pratiquer mon français."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zzc2.mp3",
							"audioLabel": "p3-zzc",
							"script": "Si j’avais le choix, je pense que je voudrais voyager à Vancouver pendant l’hiver parce que notre bureau régional se trouve à cet endroit. Bien sûr, j’aimerais beaucoup rencontrer nos collègues qui travaillent dans cette ville. Je pourrais aussi en profiter pour découvrir la région, participer à quelques activités sociales, et établir un meilleur contact professionnel avec tous les membres de l’équipe."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zzd2.mp3",
							"audioLabel": "p3-zzd",
							"script": "J’adore les voyages, mais en général, je préfère les voyages lorsqu’ils sont organisés pour prendre des vacances. Mais si je devais choisir un endroit pour mon prochain voyage d’affaires, je choisirais probablement un endroit ensoleillé comme le Sud de la France.  J’y suis allée en 2006 avec mon mari et j’ai adoré l’expérience. C’était au mois de mai, la température était parfaite et nous avons beaucoup apprécié cette région."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zn1.mp3",
								"audioLabel": "wp3-zn",
								"script": "Si je pourrai choisir ma destination pour mon prochain voyage, j’irai en France. Je choisirai la France parce que ce serait une occasion pour pratiquer mon français."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zn2.mp3",
								"audioLabel": "p3-zn",
								"script": "Pay attention to the structure of a hypothetical question. In this case, we have a hypothetical question in the present tense, but the candidate responds by (incorrectly) using the structure of a hypothetical sentence in the future tense. In this construction, “si” should be followed by a verb in the present tense.  "
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zo1.mp3",
								"audioLabel": "wp3-zo",
								"script": "Si j’avais choisi un autre endroit pour un voyage d’affaires, j’aurais aimé voyager au Nunavut parce que j’aimerais visiter le Nord du Canada et les peuples autochtones."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zo2.mp3",
								"audioLabel": "p3-zo",
								"script": "The question was a hypothetical question in the present tense, but the response becomes a hypothetical sentence in the past tense. The use of a semiauxiliary in the question is often the cause of this type of problem, as in this case. Therefore, pay particular attention to the way questions are formulated and do not hesitate to practise complex structures with your instructors."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zp.mp3",
								"audioLabel": "wp3-zp",
								"script": "Une bonne question.  J’adore les voyages, mais en général, je préfère les voyages en vacances, mais si je dois choisir un endroit, probablement je fais le choix d’un endroit ensoleillé comme le Sud de France.  J’étais là en 2006 avec mon mari et j’adore la mer et c’était au mois de mai et la température était parfaite comme 20 degrés pendant la journée.  Mais pour les raisons de travail, c’est difficile pour moi de dire exactement ce que je peux faire là, mais je veux être là."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zp2.mp3",
								"audioLabel": "p3-zp",
								"script": "In the case of hypothetical questions, make sure that you repeat the same structures as in the question in order to clearly demonstrate to the examiner that you have understood the hypothetical nature of the question."
							}
						}
					]
				},
				{
					"label": "Q&A 4",
					"index": 3,
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q15-a.mp3",
							"audioLabel": "q15-a",
							"script": "Dans quelle mesure les voyages d’affaire sont-ils avantageux par rapport à la vidéoconférence?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q15-b.mp3",
							"audioLabel": "q15-b",
							"script": "Avec les nouvelles technologies telles que la vidéoconférence, jusqu’à quel point les voyages d’affaire sont-ils indispensables?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p3-zze1.mp3",
							"audioLabel": "p3-zze",
							"script": "Dans une certaine mesure, je pense que les voyages d’affaires sont plus avantageux que les vidéoconférences.  Tout d’abord, je dirais qu’il y a beaucoup de personnes qui disent que les voyages d’affaires ne sont pas utiles du tout, qu’ils sont une perte de temps et une perte d’argent. De plus, étant donné que je travaille à Environnement Canada, beaucoup de personnes trouvent que les voyages, notamment par avion, ne sont pas bons pour l’environnement.  Mais, en même temps, je pense que quelques fois, les voyages d’affaires sont nécessaires.  Je trouve que les réunions face à face sont plus efficaces pour établir un premier rapport entre les personnes.  Ensuite, je trouve que c’est plus facile d’avoir des conversations ou des débats face à face de sorte que les personnes puissent discuter des enjeux. Et finalement, probablement la chose la plus importante… parfois la situation est très délicate et il y a peut-être un désaccord entre les participants. Selon moi, je crois qu’il est plus facile de résoudre les problèmes comme ça, c’est-à-dire face à face, au lieu d’utiliser une vidéoconférence.  Pour terminer, je dirais que quand c’est possible, c’est bien d’organiser des vidéoconférences afin d’économiser de l’argent et du temps. Par contre, dans d’autres circonstances, une réunion face à face est peut-être plus appropriée."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p3-zzf1.mp3",
							"audioLabel": "p3-zzf",
							"script": "Selon moi, les voyages d’affaires sont avantageux dans la mesure où les réunions en tête-à-tête sont vraiment nécessaires.  Par exemple, ils sont utiles afin d’avoir une réunion ou une rencontre en personne pour arriver à une entente avec une signature.  Par contre, les vidéoconférences sont plus avantageuses pour les discussions en équipe et les réunions rapides. Alors d’après moi, les voyages d’affaires sont plus utiles que les vidéoconférences uniquement lorsqu’une présence physique est nécessaire au bon déroulement des activités."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p3-zzg1.mp3",
							"audioLabel": "p3-zzg",
							"script": "Honnêtement, je trouve qu’à notre époque, les voyages d’affaires ne sont pas aussi avantageux que les vidéoconférences.  Tout d’abord, le coût des voyages est très très cher pour le gouvernement et pour les citoyens et avec la technologie, c’est très facile d’organiser des rendez-vous avec plusieurs personnes en même temps.  Par contre, je sais que les voyages d’affaires permettent de rencontrer personnellement les gens afin d’établir un vrai contact social.  Mais quand je pense au coût du voyage d’affaires, je trouve que c’est une bonne idée de faire ça seulement une fois par année.  Par exemple, c’est bien d’en faire au début d’une projet, mais après que les relations sont établies, c’est préférable d’effectuer des vidéoconférences."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p3-zzh1.mp3",
							"audioLabel": "p3-zzh",
							"script": "Je trouve que, la plupart du temps, on perd une certaine qualité de l’interaction quand on utilise une vidéoconférence.  Alors selon moi, quand on veut échanger ou partager des informations, une vidéoconférence est appropriée jusqu’à un certain point.Je préfère les rencontres face à face et je trouve que la vidéoconférence limite l’interaction physique, comme le langage corporel.  En revanche, j’ai parfois utilisé les vidéoconférences pour faire certaines entrevues. Les coûts étaient moins chers qu’un voyage d’affaires et je pouvais quand même avoir un aperçu des candidats. Enfin, bien que je préfère les voyages d’affaires, je crois qu’ils doivent être réservés à certaines occasions spéciales afin de respecter le budget de la fonction publique."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zq.mp3",
								"audioLabel": "wp3-zq",
								"script": "Je trouve qu’en général, c’est mieux d’avoir une réunion face à face mais ça arrive de temps en temps de faire la vidéoconférence.  Par exemple, chaque semaine avec le bureau de le directeur général, il y a une réunion avec chaque autre bureau dans toute la région.  Mais c’est pas possible pour moi d’avoir une réunion comme ça ensemble et le coût pour ça c’est très élevé aussi. Donc c’est très pratique avec les vidéoconférences et de temps en temps c’est très bon aussi avec les formations par exemple.  Et je trouve que dans le cas comme ça c’est très tactique aussi.  Euh…et comme vous pouvez imaginer, avec Travaux publics et Services gouvernementaux, nous sommes les acheteurs principaux pour tout le gouvernement et c’est nécessaire de travailler avec le fournisseur il y a 5, 6, 7 heures de décalage.  Mais comme vous pouvez imaginer par contre, c’est mieux de temps en temps de voir le vidéo face à face afin d’améliorer la connaissance et aussi d’obtenir de temps en temps avantage par exemple avec les négociations avec Toronto, c’est un contrat de 400 millions dollars.  Donc à mon avis, ça vaux la peine d’avoir les négociations face à face afin de donner l’avantage au gouvernement du Canada.  Si nous économisait seulement 1% pour cet contrat-là, puis un avantage d’économiser 4 million de dollars, donc ça vaut la peine."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zq2.mp3",
								"audioLabel": "p3-zq",
								"script": "The structure of this response is very difficult for the listener to make out. In this case, the oral interaction that is the purpose of the TOP is disrupted. Therefore, take the time to organize your thoughts in order to produce a coherent response that will make sense to the listener."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zr.mp3",
								"audioLabel": "wp3-zr",
								"script": "Je trouve, la plupart du temps, on perd une certaine qualité de l’interaction quand on utilise une vidéoconférence.  Alors, quand on échange ou doit partager les informations, une vidéoconférence fonctionne, mais à un certain point.  Comme si on doit passer une entrevue avec un candidat, il faut qu’on connaît une bonne idée des qualités d’esprit de quelqu’un et je trouve par vidéoconférence, ça manque une certaine qualité d’interaction, c’est-à-dire langage corporel.  On manque un élément d’interaction, les petites nuances de langage corporel sont perdues par vidéoconférence alors je préfère passer les entrevues avec les candidats face à face.  Mais j’avais utilisé les vidéoconférences pour faire une entrevue avec un candidat que nous avons engagé et ça avait fonctionne et ça avait coûté moins cher bien sûr qu’une vol de son endroit jusqu’à notre endroit.  Alors ça réduit les coûts les vidéoconférences, mais si c’est possible, je préfère avoir les interactions face à face."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zr2.mp3",
								"audioLabel": "p3-zr",
								"script": "This response has several flaws when it comes to the way verbs are used. Verbs whose function is to express an opinion must be followed by “que”; also, we must remember to use the subjunctive when it is called for. Finally, the “plus-que-parfait” (past perfect) is used in the example that is provided near the end of the response whereas the “passé compose” would have been the right choice of tense. Verbs form the basis of the language, so do not hesitate to practise them!"
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp3-zs.mp3",
								"audioLabel": "wp3-zs",
								"script": "Honnêtement, je trouve que dans cette époque, les avantages des voyages d’affaires ne sont pas aussi avantageux que les vidéoconférences.  Premièrement, le coût de voyager est très très cher pour le gouvernement et pour les citoyens et avec la technologie, c’est très facile de faire des rendez-vous avec quelques personnes en même temps.  Deuxièmement, les moyens de transport comme l’avion font de la pollution et parce que je travaille à Environnement Canada, je suis sensible à cet aspect.  Finalement, les vidéoconférences sont souvent plus rapides et je suis beaucoup moins fatigué après cela que après un voyage d’affaires.  Et aussi, puisque j’ai des jeunes enfants, je préfère rester dans la ville."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p3-zs2.mp3",
								"audioLabel": "p3-zs",
								"script": "This is an interesting response and the candidate does provide arguments in support of   his point of view. Nevertheless, a dialectical question requires an answer that explains the matter at hand with some degree of subtlety, which is not the case here. If you have a clear-cut opinion on a subject, inform the examiner of your position so that he will know that you have still understood the fine points of the question."
							}
						}
					]
				}
			],
			"label": "Topic 3",
			"index": 2
		}
	]
};


export const LEVELC_PART4 = {
	"label": "part 4",
	"index": 3,
	"video": "http://delta.mylearningmyway.com/wp-content/uploads/2019/02/EZ-TOP-PART-4-LEVEL-C.mp4",
	"description": "Listening and speaking in response to a longer audio recording: " +
		"1. You listen to a two-minute recording of a work-related conversation between two people at a meeting twice. " +
		"2. Afterwards, you are asked to provide a brief summary of its content and answer related questions. " +
		"3. Duration: 11 to 13 minutes.",
	"sections": [
		{
			"QAs": [
				{
					"index": 0,
					"label": "Q&A 1",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q1-a9.mp3",
							"audioLabel": "q1-a",
							"script": "Pourriez-vous résumer ce dialogue?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q1-b10.mp3",
							"audioLabel": "q1-b",
							"script": "Faites un résumé de l’enregistrement."
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p4-a.mp3",
							"audioLabel": "p4-a",
							"script": "Il s’agissait d’une conversation entre deux collègues au sujet d’un projet et des changements de responsabilités au sein de leur division.  Au début, ils ont parlé des vacances de Samantha. Elle revenait d’un voyage d’une semaine dans le Sud et elle semblait en pleine forme.  Elle a demandé à son collègue Bertrand s’il y avait des nouvelles en ce qui concerne le projet.  Il lui a donc expliqué que le directeur général avait alloué un budget pour le projet, mais que maintenant, la nouvelle activité de la maintenance des ordinateurs devenait une responsabilité de leur direction.  Samantha ne semblait pas très à l’aise avec ce changement, mais Bertrand croyait plutôt qu’il fallait prendre en charge cette nouvelle responsabilité.  Samantha voulait donc réévaluer l’échéance du projet et surtout en informer le client.  Vers la fin, les deux collègues se demandaient si l’aide d’une autre personne serait nécessaire étant donné la surcharge de travail dans la division. Bertrand a rassuré Samantha en lui mentionnant que cette troisième personne accepterait sûrement le travail afin d’acquérir de nouvelles expériences professionnelles enrichissantes.  Donc, ils ont terminé en disant que Samantha prendrait la responsabilité de contacter le client et que Bertrand discuterait des échéances lors d’une réunion le mercredi suivant avec le directeur général."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p4-b.mp3",
							"audioLabel": "p4-b",
							"script": "Il s’agissait d’une discussion professionnelle entre deux employés.  En commençant la conversation, ils ont discuté des vacances de la femme.  L’homme a ensuite expliqué à sa collègue qu’il y avait eu quelques changements dans leur milieu de travail pendant son absence. Au début, la femme ne semblait pas heureuse d’apprendre cette nouvelle. Ensuite, elle a compris le point de vue de son collègue et a mentionné qu’il serait nécessaire de modifier les échéances du projet. Finalement, les deux collègues ont développé un plan d’action pour l’avenir. Ils ont décidé d’ajouter un nouveau membre dans leur équipe, de contacter le client, et de renégocier les échéances auprès du directeur général."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p4-c.mp3",
							"audioLabel": "p4-c",
							"script": "C’était une conversation entre Bertrand et Samantha concernant un nouveau projet.Bertrand a expliqué qu’il avait reçu un budget supplémentaire mais qu’une nouvelle tâche concernant la maintenance des ordinateurs devait être ajoutée à leur charge de travail. Samantha n’était pas très contente de cette nouvelle décision. Bertrand a donc suggéré de demander l’aide d’un nouveau coéquipier pour faciliter leur travail. Après quelques échanges, Bertrand a réussi à convaincre Samantha et ils ont tous les deux décidé de revoir les échéances du projet. Enfin, Samantha a promis de contacter le client afin de discuter de la situation et Bertrand a mentionné qu’il allait parler des échéances au directeur général le mercredi suivant."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p4-d.mp3",
							"audioLabel": "p4-d",
							"script": "Il s’agissait d’une conversation entre deux fonctionnaires, probablement un patron et une employée. L’homme voulait savoir si sa collègue était prête à attaquer un nouveau projet concernant la maintenance des ordinateurs. Il lui a donné un petit résumé des nouvelles car l’employée avait été absente durant une courte période. Étant donné qu’il y avait de nouvelles responsabilités à accomplir, l’employée semblait un peu découragée au départ, mais a dit ensuite qu’elle voulait faire une analyse et négocier les échéances pour pouvoir effectuer le travail. Le patron a finalement suggéré d’intégrer un autre employé dans l’équipe. Ils ont donc terminé la conversation en trouvant un accord. L’employée a expliqué qu’elle contacterait le client pour parler des changements et le patron a dit qu’il discuterait avec le directeur général pour régler les derniers détails."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-a.mp3",
								"audioLabel": "wp4-ap4-a",
								"script": "Il s’agissait d’une discussion professionnelle entre deux employés.  En commençant la conversation, ils discutent des vacances de la femme.  L’homme a expliqué à sa collègue qu’il y a quelques changements dans leur milieu de travail pendant son absence. Au début, la femme ne semble pas heureuse d’apprendre cette nouvelle. Ensuite, elle a compris le point de vue de son collègue et mentionne qu’il est nécessaire de modifier les échéances du projet. Finalement, les deux collègues développent un plan d’action pour l’avenir. Ils décidaient d’ajouter un nouveau membre dans leur équipe, de contacter le client, et de renégocier les échéances auprès du directeur général."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-a1.mp3",
								"audioLabel": "wp4-ap4-a",
								"script": "This is a good summary of the situation, but unfortunately the way the different verb tenses are used indicates some difficulty in the candidate’s ability to articulate a message. To reach the C level, the past tenses must be well mastered. You have to avoid returning to the present tense and pay close attention to the agreement of tenses. To ensure success in the Test, there is nothing like practice to enhance concentration and develop good habits."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-b.mp3",
								"audioLabel": "wp4-bp4-b",
								"script": "C’était une conversation entre Bertrand et Samantha concernant un nouveau projet.Bertrand a expliqué qu’il avait reçu un budget supplémentaire mais qu’une nouvelle tâche devait être ajoutée. Bertrand a aussi dit qu’il demanderait l’aide d’un nouveau coéquipier pour faire le travail. Après, Bertrand et Samantha ont décidé de revoir les échéances du projet. Samantha a dit qu’elle allait contacter le client et Bertrand a mentionné qu’il allait parler des échéances à une autre personne."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-b1.mp3",
								"audioLabel": "wp4-bp4-b",
								"script": "This summary is too short and lacks the precision that is expected in the 4th part of the Test. It would be necessary to add some information related to the context of the conversation and provide some comments on, and impressions of, the participants (the sociolinguistic dimension)."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-c.mp3",
								"audioLabel": "wp4-cp4-c",
								"script": "Il s’agissait d’une conversation entre deux fonctionnaires, probablement… je pense… un patron et une employée, mais je ne suis pas certain, ce n’était pas clair. L’homme voulait savoir si sa collègue était prête à faire un nouveau projet concernant… le maintien… euh non… quelque chose concernant des ordinateurs. Il lui a donné un petit résumé des nouvelles car l’employée avait été absente durant une certaine période. Ensuite… parce que… euh… il y avait de nouvelles responsabilités à accomplir, l’employée semblait… je crois, un peu découragée ou peut-être frustrée au départ, mais a dit ensuite que… qu’elle… j’ai oublié, mais c’était quelque chose à propos d’une analyse. Le patron a finalement suggéré de… proposer… non… d’intégrer un autre employé dans l’équipe. Je crois aussi qu’ils ont terminé la conversation en trouvant un accord. L’employée a expliqué qu’elle contacterait quelqu’un… un client… pour parler des changements et le patron a dit qu’il discuterait avec… il me semble… un autre cadre supérieur."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-c1.mp3",
								"audioLabel": "wp4-cp4-c",
								"script": "There is far too much hesitation in this summary; this makes a bad impression during the oral test. You must work on developing confidence to be able to produce a clear summary that indicates a good comprehension of the dialogue. You must avoid certain expressions,  such as: ”je pense”, ”je crois”, ”il me semble” and ”je ne suis pas certain”."
							}
						}
					]
				},
				{
					"index": 1,
					"label": "Q&A 2",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q2-a8.mp3",
							"audioLabel": "q2-a",
							"script": "Dans quelle mesure est-ce que l’ambition vous motive à prendre de nouvelles responsabilités, malgré une surcharge de travail?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q2-b4.mp3",
							"audioLabel": "q2-b",
							"script": "Jusqu’à quel point l’ambition peut-elle vous motiver à accepter des responsabilités en plus, sachant que vous êtes déjà surchargé?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p4-e.mp3",
							"audioLabel": "p4-e",
							"script": "D’après moi, l’ambition me motive souvent à accepter de nouvelles responsabilités malgré les surcharges de travail. Je pense tout simplement que c’est normal d’avoir une surcharge de travail lorsqu’on accepte une promotion.  Dans le cas du gouvernement, avec chaque changement de poste, il y a toujours une période d’adaptation.  Par exemple, il est essentiel qu’un fonctionnaire puisse modifier ses méthodes de travail selon les critères et les préférences de son nouveau gestionnaire.   Lorsque nous sommes prêts à accepter des nouvelles tâches, il faut aussi être prêts à une charge supplémentaire de travail et à un changement en ce qui concerne nos habitudes professionnelles. À mon avis, avoir de l’ambition est une excellente façon de se fixer de nouveaux objectifs personnels et professionnels. Il faut donc accepter les nouvelles tâches comme un défi à relever."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p4-f.mp3",
							"audioLabel": "p4-f",
							"script": "Plusieurs fois durant ma carrière, j’ai décidé d’accepter d’autres tâches et de nouvelles charges de travail. Selon moi, ce n’était pas parce que j’étais ambitieux, mais plutôt parce que j’avais l’occasion d’apprendre de nouvelles choses et de vivre des nouvelles expériences. Donc d’habitude, les surcharges de travail ne me font pas très peur. Par contre, je dois dire que c’est plus difficile maintenant étant donné que j’ai deux petits enfants…"
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p4-g1.mp3",
							"audioLabel": "p4-g",
							"script": "Selon moi, ça dépend si le nouveau travail est intéressant et si je suis capable d’éliminer certaines responsabilités pour pouvoir effectuer les tâches plus importantes en premier. À mon avis, si on est prêt à accepter des nouvelles tâches et des nouveaux défis, il faut aussi être prêt à gérer notre temps d’une façon plus efficace. En bref, je trouve que l’ambition me pousse parfois à accepter de nouvelles responsabilités, mais je crois aussi qu’il faut être capable de faire les bons choix afin de demeurer productif au travail."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p4-h.mp3",
							"audioLabel": "p4-h",
							"script": "En ce qui me concerne, l’ambition est très importante et je n’ai pas peur des surcharges de travail.  Je comprends que certaines personnes préfèrent avoir une charge de travail normale, mais je crois qu’il faut avoir de l’ambition dans la vie.  De plus, c’est presque impossible de faire progresser sa carrière en évitant les tâches supplémentaires parce que aujourd’hui, à tous les jours, il y a beaucoup de problèmes auxquels on doit faire face.  L’ambition permet donc aux personnes d’aller au-delà des problèmes pour fonctionner efficacement peu importe la situation."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-d.mp3",
								"audioLabel": "wp4-dp4-d",
								"script": "D’après moi, c’est très important d’accepter de nouvelles responsabilités au travail. Je pense tout simplement que c’est normal d’avoir une surcharge de travail de temps en temps.  Lorsque nous sommes fonctionnaire, il faut être prêt à accepter des nouveaux projets, il faut aussi être prêt à une charge supplémentaire de travail et à un changement en ce qui concerne la distribution des tâches. À mon avis, c’est une excellente façon de conserver une bonne réputation auprès de nos gestionnaires. Il faut donc toujours accepter les nouvelles tâches sans la moindre hésitation."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-d1.mp3",
								"audioLabel": "wp4-dp4-d",
								"script": "This response lacks subtlety and the candidate seems to have forgotten the topic, i.e.,   ambition. Make sure that you understand the question well and that you fully grasp the various aspects of the dialectical question before answering. Furthermore, do not forget that delivering a subtle response is another requirement that you must meet to reach the C level."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-e.mp3",
								"audioLabel": "wp4-ep4-e",
								"script": "Selon moi, ça dépenderait si le nouveau travail serait intéressante et si je suis capable d’éliminer certains responsabilités pour pouvoir effectuer les tâches plus importants en premier. À mon avis, si on est prêt à accepter des nouveaux tâches et des nouveaux défis, il faut aussi être prêt à gérer notre temps dans une façon plus effective. En bref, je dis que l’ambition est importante pour moi, mais qu’il faut aussi être capable de faire les bonnes choix afin de demeurer productive au travail."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-e1.mp3",
								"audioLabel": "wp4-ep4-e",
								"script": "The ideas expressed in this response do not lack value, but unfortunately there are too many grammar mistakes (agreement of tenses in the hypothetical sentences, agreement of adjectives with nouns, English terms that must be avoided)."
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-f.mp3",
								"audioLabel": "wp4-fp4-f",
								"script": "Je crois que l’ambition est très importante et que je n’ai pas peur des surcharges de travail.  Je crois qu’il faut avoir de l’ambition dans la vie.  De plus, je crois que c’est presque impossible de faire progresser sa carrière en évitant les tâches supplémentaires. Je crois aussi qu’aujourd’hui, à tous les jours, il y a beaucoup de problèmes auxquels on doit faire face.  Finalement, je crois que l’ambition permet aux personnes d’aller au-delà des problèmes pour fonctionner efficacement peu importe la situation."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-f1.mp3",
								"audioLabel": "wp4-fp4-f",
								"script": "The expression ”je crois que” appears in every sentence, which makes for a cumbersome and repetitive message. Remember that it is important to indicate that you are stating an opinion while varying your choice of expressions. You must, therefore, use ”je pense que”, ”je trouve que”, ”selon moi”, ”quant à moi”, ”à mon avis” in order to enhance your\nresponses."
							}
						}
					]
				},
				{
					"index": 2,
					"label": "Q&A 3",
					"questions": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/q3-a11.mp3",
							"audioLabel": "q3-a",
							"script": "Jusqu’à quel point les changements de dernière minute vous dérangent-ils?"
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/q3-b10.mp3",
							"audioLabel": "q3-b",
							"script": "Dans quelle mesure une modification de dernière minute vous oblige-t-elle à changer votre manière de travailler?"
						}
					],
					"possibleAnswers": [
						{
							"index": 0,
							"audio": "/wp-content/uploads/2013/12/p4-i.mp3",
							"audioLabel": "p4-i",
							"script": "Au fil des années, j’ai adopté le point de vue que les changements de dernière minute font partie du travail au sein de la fonction publique.  C’est contre ma nature parce que je suis une personne qui préfère planifier les activités en avance et après ça m’occuper de l’exécution des tâches. Par contre, lorsqu’il y a des changements de dernière minute, j’essaie de trouver un peu de temps dans mon horaire pour effectuer les changements et résoudre les problèmes avec mon équipe et mon client.  Mais bien évidemment, c’est difficile pour moi parce que j’ai l’habitude de bien planifier mes activités et les activités de mon équipe. En bref, les changements de dernière minute me dérangent pafois parce qu’ils arrivent souvent le vendredi après-midi et qu’ils ont un impact négatif sur mon humeur."
						},
						{
							"index": 1,
							"audio": "/wp-content/uploads/2013/12/p4-j.mp3",
							"audioLabel": "p4-j",
							"script": "Les changements à la dernière minute me dérangent jusqu’à un certain point. Particulièrement lorsqu’ils interfèrent avec le travail que je dois faire.  Par exemple, si j’avais un projet important à remettre aujourd’hui, j’aimerais éviter les autres tâches additionnelles afin de terminer mon projet initial. En bref, avant d’accepter de nouvelles responsabilités, je préfère terminer mes tâches habituelles."
						},
						{
							"index": 2,
							"audio": "/wp-content/uploads/2013/12/p4-k.mp3",
							"audioLabel": "p4-k",
							"script": "À mon avis, c’est une question qui concerne directement les fonctionnaires puisqu’il s’agit d’une pratique régulière dans la fonction publique.Mais personnellement, les changements me dérangent plus ou moins car j’essaie d’apprivoiser ce problème en utilisant certaines stratégies. C’est-à-dire que je mets l’accent sur les actions plutôt que les résultats.  Donc, lorsqu’un changement comme ça arrive, immédiatement je me rappelle cette idée pour rester calme et flexible. Enfin, grâce à cette méthode, je peux m’attaquer aux problèmes sans être déstabilisé ou incommodé par la situation."
						},
						{
							"index": 3,
							"audio": "/wp-content/uploads/2013/12/p4-l.mp3",
							"audioLabel": "p4-l",
							"script": "Bien évidemment, les changements de dernière minute me dérangent un peu, mais normalement, si je suis bien organisée, je peux finir toutes mes tâches et même ajouter quelque chose d’autre sur ma liste des priorités.  Mais si la situation est impossible à gérer, je discute habituellement avec mon patron pour déterminer les priorités et le travail le plus important."
						}
					],
					"problematicAnswers": [
						{
							"index": 0,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-g.mp3",
								"audioLabel": "wp4-gp4-g",
								"script": "Les changements de dernière minute me dérangent jusqu’à un certain point. Ils font partie du travail au sein de la fonction publique et je suis une personne qui préfère planifier les activités en avance et après ça m’occuper de l’exécution des tâches. Il y a toujours des changements de dernière minute au travail et j’essaie de trouver un peu de temps dans mon horaire pour les effectuer et résoudre les problèmes avec mon équipe et mon client.  C’est difficile pour moi… j’ai l’habitude de bien planifier mes activités et les activités de mon équipe. Les changements de dernière minute me dérangent parfois car ils arrivent souvent le vendredi après-midi et ils ont un impact négatif sur mon humeur."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-g2.mp3",
								"audioLabel": "wp4-gp4-g",
								"script": "There are some good things to say about this response; however, no connectives were used in order to structure what was said. If you wish to enhance your responses, practise using the various connectives until you develop the habit of using them naturally in conversation."
							}
						},
						{
							"index": 1,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-h.mp3",
								"audioLabel": "wp4-hp4-h",
								"script": "Les changements à la dernière minute me dérangent lorsqu’ils interfèrent avec le travail que je dois faire. Avant d’accepter de nouvelles responsabilités, je préfère terminer mes tâches habituelles."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-h2.mp3",
								"audioLabel": "wp4-hp4-h",
								"script": "This response is a little too brief. Don’t be afraid to expand on what you’ve said in order to demonstrate your skills!"
							}
						},
						{
							"index": 2,
							"probAnswer": {
								"audio": "/wp-content/uploads/2013/12/wp4-i.mp3",
								"audioLabel": "wp4-ip4-i",
								"script": "Bien évidemment, les changements de dernière minute me déranger un peu, mais normalement, si je suis bien organisée, je peux fini toutes mes tâches et même ajouter quelque chose d’autre sur ma liste des priorités.  Mais si la situation serait impossible à gérer, je discuterais habituellement avec mon patron pour déterminer les priorités et le travail le plus important."
							},
							"comment": {
								"audio": "/wp-content/uploads/2013/12/p4-i1.mp3",
								"audioLabel": "wp4-ip4-i",
								"script": "In this case, we can notice several difficulties when it comes to use of verbs. To reach the C level, remember that it is essential to develop a good knowledge and command of verbs. Do not forget to review and practise conjugation, the agreement of tenses and pronunciation until all this becomes natural."
							}
						}
					]
				}
			],
			"index": 0,
			"label": "Conversation",
			"content": {
				"audio": "/wp-content/uploads/2013/12/long-dialogue1.mp3",
				"audioLabel": "long-dialogu",
				"script": "-Benoît : Salut Samantha!  Tu es finalement de retour?\n-Samantha : Salut Benoît!  Oui je suis revenue hier.\n-Benoît : Comment étaient tes vacances?\n-Samantha : C’était vraiment bien. Je suis allée passer une semaine dans le sud.-Benoît : Alors tu dois être en forme pour attaquer le projet dont nous avions parlé avant ton départ?\n-Samantha : En pleine forme!  Il y a eu du nouveau depuis?\n-Benoît : Oui, mais l’essentiel reste à faire.  Le directeur général a accepté de nous allouer un budget supplémentaire, mais nous devons inclure les maintenances des ordinateurs.\n-Samantha : La maintenance!  Mais, ce n’était pas ce qui était prévu au départ!  De plus, ce n’est pas le mandat de notre direction.\n-Benoît : Je le sais.  Mais vu les récentes coupures à la direction de la maintenance, il a dit que nous devions commencer à nous préparer à prendre en charge une partie de leur travail habituel.\n-Samantha : Dans ce cas, il faut refaire l’analyse et surtout renégocier les échéances. Il va aussi falloir prévenir le client.\n-Benoît : Oui. Il faut qu’on demande à Fred s’il veut faire partie du comité de préparation du projet. Ces connaissances et son expertise pourraient s’avérer très bénéfiques pour nous.\n-Samantha : Oui, mais penses-tu qu’il acceptera, surtout avec la surcharge de travail que connaît son équipe actuellement ?  Selon moi, il déclinera l’offre.\n-Benoît : Je pense qu’au contraire il sera tenté d’accepter surtout si on réussit à le convaincre de l’intérêt que pourrait avoir sa participation dans l’évolution de sa carrière.  Il ne sera pas insensible à ce genre d’argument.\n-Samantha : Vu comme ça, on a peut-être une chance.  Alors je me propose de contacter le client pour lui faire part du changement et de ton côté pourrais-tu en parler à Fred ?\n-Benoît : Oui, c’est ce que je vais faire. Je me chargerai aussi de revoir les échéances avec le directeur général lors de notre réunion mensuelle, mercredi prochain."
			}
		}
	]
};

export const LEVELC = {
	label: "Level C",
	parts: [LEVELC_PART1, LEVELC_PART2, LEVELC_PART3, LEVELC_PART4]
};

export const DATA = {
	levels: [LEVELB, LEVELC]
}

export default {DATA, LEVELC, LEVELB}